{
  "accept_invite": {
    "back_to_home": "Tillbaka till hemsidan",
    "choose_password": "Välj ett lösenord",
    "heading": "Acceptera inbjudan",
    "loading": "Laddar",
    "save_button": "Acceptera inbjudan",
    "text": "Du har blivit inbjuden att gå med i en arbetsyta. Vänligen välj ett lösenord för att fortsätta."
  },
  "automation": {
    "audience": "Den här målgruppen har för närvarande en aktiv medarbetare | Den här målgruppen har för närvarande {count} aktiva medarbetare",
    "automation_updated": "Automatisering uppdaterad",
    "delete": {
      "are_you_sure": "Är du säker på att du vill radera denna sekvens? Denna åtgärd kan inte ångras.",
      "automation_deleted": "Sekvens raderad",
      "button": "Radera"
    },
    "details": {
      "heading": "Detaljer",
      "text": "Automatiseringsdetaljer"
    },
    "edit": {
      "subtitle": "Bygg ditt automatiseringsflöde genom att lägga till åtgärder",
      "title": "Åtgärder"
    },
    "edit_automation": "Redigera inställningar",
    "employee_already_enrolled": "Denna medarbetare är redan registrerad",
    "enroll_employees": "Registrera medarbetare",
    "enrolled_employees": "Grupp uppdaterad",
    "flow": {
      "actions": {
        "assign_lesson": {
          "custom_label": "Anpassad"
        },
        "assign_quiz": {
          "custom_help": "När detta är inaktiverat väljer Moxso Intelligence den mest relevanta utbildningen baserat på den anställdes riskprofil.",
          "custom_label": "Anpassad bedömning",
          "risk_categories": "Riskkategorier"
        },
        "delete": {
          "button": "Ta bort åtgärd",
          "text": "Är du säker på att du vill ta bort den här åtgärden?"
        },
        "editing": {
          "add_tag_action": "Lägg till tagg",
          "assign_course_action": "Tilldela kurs",
          "assign_lesson_action": "Tilldela lektion",
          "assign_quiz_action": "Tilldela bedömning",
          "assign_video_action": "Tilldela video",
          "halt_action": "Stoppa automation",
          "remove_tag_action": "Ta bort tagg",
          "wait_action": "Vänta i en varaktighet"
        },
        "preview": "Visa aktivitet",
        "repeat_enabled": "Det här automatiseringsflödet kommer att upprepas för varje anställd.",
        "status": {
          "active": "Aktiv: {count}",
          "completed": "Slutförd: {count}",
          "halted": "Stoppad: {count}"
        },
        "step": "Steg {step}",
        "wait_units": {
          "days": "Dag | Dagar",
          "months": "Månad | Månader",
          "weeks": "Vecka | Veckor"
        }
      },
      "edit": "Redigera",
      "length": "Längd",
      "save_step": "Spara steg",
      "title": {
        "preview": {
          "assign_lesson_action": {
            "text": "Moxso AI kommer automatiskt att tilldela den bästa lektionen för varje anställd baserat på deras färdighetsnivå och inlärningsstil.",
            "title": "Använd Moxso AI för att tilldela en lektion"
          },
          "halt_action": {
            "text": "Automatiseringen stoppas för den anställde som når detta steg.",
            "title": "Stoppa automatisering"
          }
        },
        "wait_action": "Vänta i {duration} {unit}"
      },
      "unit": "Enhet"
    },
    "form_new_automation": {
      "button": "Skapa sekvens",
      "group": "Grupp",
      "group_placeholder": "Välj grupp",
      "name": "Namn",
      "template": {
        "label": "Mall",
        "placeholder": "Välj mall"
      },
      "title": "Skapa en sekvens"
    },
    "funnel": {
      "button": "Redigera sekvens",
      "start": "Starta",
      "title": "Sekvens tratt"
    },
    "hide_advanced_settings": "Dölj avancerade inställningar",
    "notification_frequency": "Aviseringsfrekvens",
    "notifications": "Aviseringar",
    "notifications_active": "Aktiv",
    "notifications_inactive": "Inaktiv",
    "participants": {
      "filter": {
        "status": {
          "active": "Aktiv ({count})",
          "all": "Alla ({count})",
          "completed": "Slutförd ({count})",
          "halted": "Avbruten ({count})"
        }
      },
      "heading": "Deltagare",
      "statistics": {
        "participant_coverage": "Deltagartäckning",
        "participant_coverage_text": "Beräknat resultat baserat på procentandelen anställda som är inskrivna i denna övning."
      },
      "text": "Deltagarstatistik"
    },
    "pause": "Pausa",
    "play": "Aktivera",
    "search": {
      "placeholder": "Sök alla anställda",
      "results": "Sökresultat för: {query}"
    },
    "sequence": {
      "subtitle": "Sekvensöversikt för automatiseringsflöde",
      "title": "Sekvens"
    },
    "settings": {
      "create_segment": "Skapa ett segment",
      "help": {
        "content_skipping_enabled": "Tillåt anställda att hoppa över steg i automatiseringen om deras kompetensnivå är tillräcklig.",
        "notification_flow_enabled": "Aktivera automatiska aviseringar för anställda som ännu inte har avslutat sin utbildning.",
        "notification_past_deadline_enabled": "Skicka veckovisa aviseringar i en månad efter en missad deadline",
        "notification_prelude_enabled": "Skicka en avisering till anställda när en ny bedömning tilldelas dem.",
        "relative_deadlines_enabled": "En medarbetare kommer inte att gå vidare i flödet förrän den föregående deadline har uppfyllts.",
        "relative_progression_enabled": "En anställd kommer att fortsätta inom flödet oavsett om den föregående lektionen har avslutats.",
        "repeat_enabled": "Tillåt att anställda går igenom automatiseringen mer än en gång",
        "repeat_only_after_halt": "Upprepa endast när anställd var stoppad",
        "repeatable_assignments_enabled": "En anställd kan tilldelas lektioner som redan har slutförts.",
        "segment": "Begränsa automatiseringsflödet till ett specifikt segment.",
        "trigger": "Välj utlösaren för detta automatiseringsflöde."
      },
      "labels": {
        "content_skipping_enabled": "Hoppa över innehåll",
        "date": "Datum",
        "group": "Grupp",
        "name": "Namn",
        "notification_flow_enabled": "Aktivera notifieringsflöde",
        "notification_frequency": "Meddelandefrekvens",
        "notification_past_deadline_enabled": "Aktivera påminnelser efter tidsfristen",
        "notification_prelude_enabled": "Aktivera inledning för avisering",
        "relative_deadlines_enabled": "Aktivera relativa deadlines",
        "relative_progression_enabled": "Aktivera relativ progression",
        "repeat_enabled": "Upprepa automationsflöde",
        "repeat_only_after_halt": "Upprepa endast efter stopp",
        "repeatable_assignments_enabled": "Aktivera återkommande uppgifter",
        "segment": "Segment",
        "tag": "Etikett",
        "trigger": "Utlösare",
        "use_segment": "Använd segment"
      },
      "no_segment_found": "Inga segment hittades för denna grupp",
      "not_editable_text": "Pausa din automation för att redigera inställningarna",
      "not_editable_title": "Automatisering körs för närvarande",
      "placeholder": {
        "course": "Välj kurs",
        "date": "Välj datum",
        "lesson": "Välj lektion",
        "segment": "Välj segment",
        "tag": "Välj tagg",
        "video": "Välj video"
      },
      "repeatable_assignments_enabled": "Eftersom du har valt att en anställd kan tilldelas övningar som de redan har slutfört vid en tidigare tidpunkt, måste sekvensen följa relativa deadlines.",
      "save_settings": "Spara inställningar",
      "settings_saved": "Inställningar sparade"
    },
    "show_advanced_settings": "Visa avancerade inställningar"
  },
  "billing": {
    "missing_payment_banner": "Åtgärd krävs: saknad betalning"
  },
  "breaches": {
    "breached_accounts": "Överträdelsekonton",
    "compromised_info": "Komprometterad information",
    "data_types": "Typer av data i denna läcka",
    "date": "Intrångsdatum",
    "disabled": {
      "button": "Gå till inställningar",
      "heading": "Intrång är inaktiverade",
      "text": "Meddela dina anställda omedelbart om de har varit inblandade i ett dataintrång, så att de snabbt kan vidta åtgärder för att skydda känslig information och minimera riskerna, samtidigt som du får en omfattande översikt över alla intrång som påverkar ditt team för bättre säkerhetshantering och snabb respons."
    },
    "high": "Hög",
    "medium": "Medelstor",
    "untitled_data_breach": "Obetitlad dataintrång"
  },
  "buttons": {
    "back": "Tillbaka",
    "cancel": "Avbryt",
    "copy": "Kopiera",
    "delete": "Radera",
    "download_csv": "Ladda ner CSV",
    "download_pdf": "Ladda ner PDF",
    "view_details": "Visa detaljer"
  },
  "charts": {
    "donut": {
      "amount_share": "Belopp / Andel",
      "category": "Kategori"
    },
    "resilience": {
      "score": "Poäng"
    }
  },
  "competency_profile": {
    "current_level": "Nuvarande nivå",
    "target_level": "Målnivå",
    "thresholds_info_text": "Tröskelvärdena är anpassade till varje anställds roll och deras nuvarande färdighetsnivå.",
    "title": "Kompetensprofil"
  },
  "demo_data": {
    "automations": {
      "onboarding_new_employees": "Onboarding - Nya anställda",
      "security_awareness_essentials_training": "Grundläggande cybersäkerhet",
      "upskilling_all_employees": "Kompetensutveckling - Alla anställda"
    },
    "campaign_templates": {
      "templates": {
        "annual_benefits_enrollment_deadline": {
          "html": "<p>Hej <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Detta är en vänlig påminnelse om att den årliga anmälningsperioden för förmåner för medarbetare på <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> snart löper ut. Du har till <strong>fredag den 15 september</strong> på dig att göra dina val för det kommande året.</p><p><strong>Viktiga ändringar i år:</strong></p><ul><li>Nya sjukförsäkringsalternativ med bättre täckning</li><li>Ökad matchning av tjänstepensionsavsättning upp till 6%</li><li>Förbättrade tand- och synvårdsplaner</li><li>Nya gränser för flexibla utgiftskonton</li></ul><p>Om du inte slutför din anmälan innan deadline blir du automatiskt anmäld till grundplanen, vilket kanske inte motsvarar dina nuvarande behov.</p><p>Granska dina alternativ och gör dina val via vår säkra förmånsportal:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Slutför anmälan till förmåner</a></strong></u></p><p>Om du har frågor om dina förmånsalternativ, tveka inte att kontakta HR-teamet.</p><p>Tack,<br/><strong>HR-avdelningen</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Åtgärd krävs: Deadline för årlig anmälan till förmåner"
        },
        "security_breach_immediate_action": {
          "html": "<p>Hej <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Vi har upptäckt misstänkt aktivitet på ditt konto i <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> som kräver omedelbar åtgärd. Våra säkerhetssystem har flaggat flera obehöriga inloggningsförsök från en okänd enhet.</p><p>För att skydda ditt konto och företagets data har vi tillfälligt begränsat åtkomsten till ditt konto. Du måste verifiera din identitet och återställa dina inloggningsuppgifter inom de kommande 24 timmarna för att undvika permanent avstängning.</p><p><strong>Det här behöver du göra:</strong></p><ol><li>Klicka på den säkra verifieringslänken nedan</li><li>Bekräfta din identitet med multifaktorautentisering</li><li>Uppdatera ditt lösenord omedelbart</li></ol><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Verifiera kontosäkerheten nu</a></strong></u></p><p>Om du inte slutför verifieringsprocessen inom 24 timmar kommer ditt konto att stängas av permanent av säkerhetsskäl.</p><p>Vänliga hälsningar,<br/><strong>IT-säkerhetsteamet</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Brådskande: Säkerhetsintrång - Omedelbar åtgärd krävs"
        },
        "upcoming_organizational_changes": {
          "html": "<p>Hej <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Jag kontaktar dig för att informera om några viktiga kommande förändringar inom <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>. På grund av förändrade verksamhetsbehov kommer vi att omstrukturera vissa avdelningar, och tyvärr kommer vissa tjänster att göras överflödiga.</p><p>Det är viktigt att du granskar den detaljerade informationen om dessa förändringar så snart som möjligt för att förstå hur de kan påverka dig och ditt team.</p><p>Klicka på länken nedan för att läsa det officiella blogginlägget som beskriver nästa steg och tillgängligt stöd:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Läs vd:ns uppdatering om organisationsförändringarna</a></strong></u></p><p>Vi uppskattar din snabba uppmärksamhet i denna fråga.</p><p>Med vänliga hälsningar,<br/><strong>Ledningen,</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Kommande organisationsförändringar"
        }
      }
    },
    "campaigns": {
      "completed_events": {
        "event_0": {
          "filename": "event_0.se.html",
          "from_name": "Slack-teamet",
          "title": "[Slack] Ditt lösenord håller på att gå ut"
        },
        "event_1": {
          "filename": "event_1.se.html",
          "from_name": "Love2Race-teamet",
          "title": "[Love2Race] Anpassat löparkit för ert nästa event"
        },
        "event_10": {
          "filename": "event_10.se.html",
          "from_name": "Maria Caroline Thomsen",
          "title": "Kaffemöte"
        },
        "event_11": {
          "filename": "event_11.se.html",
          "from_name": "SAS",
          "title": "Lägsta pris någonsin!"
        },
        "event_12": {
          "filename": "event_12.se.html",
          "from_email": "notifikationer@customer-service.se",
          "from_name": "Filippa",
          "title": "Anmälan till DHL-stafetten!"
        },
        "event_13": {
          "filename": "event_13.se.html",
          "from_name": "Slacks säkerhetsteam",
          "title": "[Slack] Viktigt: Ny integritetspolicy"
        },
        "event_14": {
          "filename": "event_14.se.html",
          "from_name": "HubSpot",
          "title": "[HubSpot] Ditt lösenord kommer att ändras"
        },
        "event_15": {
          "filename": "event_15.se.html",
          "from_name": "Ditt SAP ID Service-team",
          "title": "[SAP] Meddelande om återställning av lösenord"
        },
        "event_16": {
          "filename": "event_16.se.html",
          "from_name": "1Password",
          "title": "[1Password] Ditt huvudlösenord har uppdaterats"
        },
        "event_17": {
          "filename": "event_17.se.html",
          "from_name": "LinkedIn",
          "title": "[LinkedIn] Dina engagemangsinsikter är klara"
        },
        "event_18": {
          "filename": "event_18.se.html",
          "from_name": "DocuSign",
          "title": "[DocuSign] Granska dokument"
        },
        "event_2": {
          "filename": "event_2.se.html",
          "from_name": "Lars",
          "title": "Inbjudan till workshop för prestationsboost"
        },
        "event_3": {
          "filename": "event_3.se.html",
          "from_name": "SAS",
          "title": "BOKA FÖRE MIDNATT - SAS"
        },
        "event_4": {
          "filename": "event_4.se.html",
          "from_name": "Pleo",
          "title": "Har du precis försökt logga in?"
        },
        "event_5": {
          "filename": "event_5.se.html",
          "title": "Förslag om betalningslösning för kaffe"
        },
        "event_6": {
          "filename": "event_6.se.html",
          "from_name": "e-Boks A/S",
          "title": "Du har fått ny post från Rikspolisen"
        },
        "event_7": {
          "filename": "event_7.se.html",
          "from_name": "Facebook",
          "title": "Förnya ditt lösenord - Facebook"
        },
        "event_9": {
          "filename": "event_9.se.html",
          "from_name": "Microsoft",
          "title": "Kvot överskriden - Microsoft"
        }
      },
      "completed_sms_events": {
        "event_0": {
          "body": "TrackIt: Vi kunde inte leverera ditt paket i dag. Bekräfta din leveransadress före 18:00: https://trk-it.example/delivery",
          "from_name": "TrackIt"
        },
        "event_1": {
          "body": "Lön: Din lönespecifikation för april är klar. Granska det säkra dokumentet här: https://payroll-example.test/review",
          "from_name": "Lön"
        },
        "event_2": {
          "body": "IT Support: Vi har upptäckt en ny inloggning på ditt e-postkonto. Om det inte var du, verifiera din identitet nu: https://it-help.example/verify",
          "from_name": "IT Support"
        },
        "event_3": {
          "body": "Kontor: Du har lagts till i morgondagens behörighetslista till byggnaden. Öppna besökspasset här: https://office-pass.example/access",
          "from_name": "Kontor"
        },
        "event_4": {
          "body": "Bank: En kortbetalning har satts på paus. Bekräfta transaktionen för att undvika en tillfällig spärr: https://bank-secure.example/check",
          "from_name": "Bank"
        }
      },
      "names": {
        "automatic_campaign": "Automatisk kampanj",
        "christmas": "Jul",
        "sms_campaign": "SMS-kampanj",
        "test": "Test"
      }
    },
    "custom_courses": {
      "names": {
        "access_control_principles": "Principer för åtkomstkontroll",
        "backup_and_recovery_procedures": "Rutiner för säkerhetskopiering och återställning",
        "business_continuity_planning": "Planering för verksamhetskontinuitet",
        "cloud_security_basics": "Grunderna i molnsäkerhet",
        "cybersecurity_awareness_training": "Utbildning i cybersäkerhetsmedvetenhet",
        "data_protection_fundamentals": "Grunderna i dataskydd",
        "digital_ethics_and_compliance": "Digital etik och efterlevnad",
        "email_security_guidelines": "Riktlinjer för e-postsäkerhet",
        "gdpr_compliance_essentials": "Grundläggande GDPR-efterlevnad",
        "incident_response_training": "Utbildning i incidenthantering",
        "information_classification": "Informationsklassificering",
        "mobile_device_security": "Säkerhet för mobila enheter",
        "network_security_fundamentals": "Grunderna i nätverkssäkerhet",
        "password_security_best_practices": "Bästa praxis för lösenordssäkerhet",
        "phishing_prevention": "Förebyggande av phishing",
        "privacy_by_design": "Inbyggt integritetsskydd",
        "remote_work_security": "Säkerhet vid distansarbete",
        "secure_coding_practices": "Säker kodningspraxis",
        "social_engineering_defense": "Försvar mot social engineering",
        "vendor_risk_management": "Riskhantering för leverantörer"
      }
    },
    "custom_videos": {
      "videos": {
        "creating_strong_passwords": {
          "description": "Bästa praxis för att skapa och hantera starka och säkra lösenord.",
          "title": "Skapa starka lösenord"
        },
        "data_privacy_basics": {
          "description": "Det viktigaste om dataskydd och hur du skyddar din personliga information.",
          "title": "Grunderna i dataskydd"
        },
        "introduction_to_cyber_security": {
          "description": "En översikt av grunderna i cybersäkerhet och varför det är viktigt.",
          "title": "Introduktion till cybersäkerhet"
        },
        "multi_factor_authentication": {
          "description": "Hur flerfaktorsautentisering fungerar och varför du bör använda det.",
          "title": "Flerfaktorsautentisering"
        },
        "new_employee_security_awareness": {
          "description": "En introduktionsvideo för nya medarbetare om grundläggande säkerhetsrutiner.",
          "title": "Säkerhetsmedvetenhet för nya medarbetare"
        },
        "recognizing_phishing_emails": {
          "description": "Lär dig identifiera och undvika phishingmejl för att skydda din information.",
          "title": "Känna igen phishingmejl"
        },
        "safe_internet_browse": {
          "description": "Tips och tekniker för att surfa säkert och tryggt på internet.",
          "title": "Säker surfning på internet"
        },
        "securing_mobile_devices": {
          "description": "Lär dig hur du håller dina mobila enheter säkra mot hot.",
          "title": "Säkra mobila enheter"
        },
        "social_engineering_attacks": {
          "description": "Förstå social engineering-taktiker och hur du skyddar dig mot dem.",
          "title": "Social engineering-attacker"
        },
        "understanding_ransomware": {
          "description": "En introduktion till ransomware och hur du skyddar dina data mot det.",
          "title": "Förstå ransomware"
        }
      }
    },
    "policies": {
      "content": {
        "heading_second_paragraph": "Andra stycket",
        "paragraph_1": "På [Företagsnamn] är vi engagerade i att upprätthålla de högsta standarderna för datasäkerhet i alla delar av vår verksamhet. Vi erkänner att konfidentialitet, integritet och tillgänglighet för personliga och känsliga uppgifter är avgörande för att behålla förtroendet hos våra kunder, medarbetare, partners och tillsynsmyndigheter.",
        "paragraph_2": "Därför har vi etablerat denna policy för datasäkerhet för att definiera de principer och arbetssätt som vägleder våra insatser för att skydda data mot obehörig åtkomst, missbruk, förlust, förändring eller förstöring. Policyn gäller all persondata som vi samlar in, behandlar eller lagrar, oavsett om den är digital eller fysisk, och är i linje med erkända branschstandarder och regulatoriska krav, inklusive [ange tillämpliga lagar, t.ex. GDPR, CCPA, HIPAA].",
        "paragraph_3": "Vårt mål är att införa proaktiva säkerhetsåtgärder som minskar risk, säkerställer efterlevnad och stödjer vår övergripande styrning av information. Vi använder en kombination av tekniska, administrativa och fysiska skyddsåtgärder för att skydda data under hela dess livscykel.",
        "paragraph_4": "Detta inkluderar mekanismer för åtkomstkontroll, kryptering, säkra metoder för programvaruutveckling, planering för incidenthantering, utbildning av medarbetare och regelbundna revisioner. Varje medarbetare, konsult och tredjepartsleverantör som hanterar persondata förväntas förstå och följa de säkerhetsansvar som beskrivs i denna policy.",
        "paragraph_5": "Genom kontinuerlig utvärdering och förbättring av vår säkerhetsnivå strävar vi efter att ligga steget före föränderliga hot och säkerställa att persondata som anförtros oss hanteras med största möjliga omsorg och noggrannhet."
      },
      "names": {
        "acceptable_use_policy": "Policy för acceptabel användning",
        "access_control_policy": "Policy för åtkomstkontroll",
        "bring_your_own_device_byod_policy": "Policy för medarbetares egna enheter (BYOD)",
        "business_continuity_and_disaster_recovery_policy": "Policy för kontinuitetsplanering och katastrofåterställning",
        "change_management_policy": "Policy för förändringshantering",
        "cloud_usage_policy": "Policy för molnanvändning",
        "code_of_conduct": "Uppförandekod",
        "company_it_security_policy": "IT-säkerhetspolicy för företaget",
        "data_protection_and_privacy_policy": "Policy för dataskydd och integritet",
        "email_and_communication_policy": "Policy för e-post och kommunikation",
        "employee_onboarding_policy": "Policy för onboarding av medarbetare",
        "encryption_policy": "Krypteringspolicy",
        "incident_response_policy": "Policy för incidenthantering",
        "internet_usage_policy": "Policy för internetanvändning",
        "mobile_device_management_policy": "Policy för hantering av mobila enheter",
        "monitoring_and_logging_policy": "Policy för övervakning och loggning",
        "network_security_policy": "Policy för nätverkssäkerhet",
        "password_management_policy": "Policy för lösenordshantering",
        "patch_management_policy": "Policy för patchhantering",
        "physical_security_policy": "Policy för fysisk säkerhet",
        "remote_work_policy": "Policy för distansarbete",
        "secure_development_policy": "Policy för säker utveckling",
        "social_media_policy": "Policy för sociala medier",
        "software_installation_policy": "Policy för programvaruinstallation",
        "third_party_vendor_security_policy": "Policy för säkerhet hos tredjepartsleverantörer"
      }
    },
    "simulations": {
      "subjects": {
        "new_work_phones": "Vi får nya arbetstelefoner",
        "slack_privacy_policy": "[Slack] Viktigt: Ny integritetspolicy",
        "warning_files_deleted": "Varning: 4 214 filer har raderats - Microsoft"
      }
    },
    "threats": {
      "emails": {
        "free_gift_card_sender": "no-reply@ing.se"
      },
      "subjects": {
        "free_gift_card_opportunity_open": "👉 Din möjlighet till ett gratis presentkort på 300 kr är fortfarande öppen!",
        "free_gift_card_opportunity_short": "Din möjlighet till ett gratis presentkort på 300 kr e...",
        "free_gift_card_opportunity_short_with_space": " Din möjlighet till ett gratis presentkort på 300 kr e..."
      }
    },
    "training": {
      "courses": {
        "10564bf8-aa3e-4295-9cf0-d350276455da": "Grunderna i cybersäkerhet",
        "19a78f09-8c46-4090-b2aa-e2d655efb9cf": "Behandling av personuppgifter",
        "27ad50e1-7967-49bd-a85a-3c8a4a97975a": "En introduktion till GDPR",
        "2ba7b31b-c23c-4195-9506-6dd064f9c72d": "Phishing",
        "69e29286-5079-4053-bd59-f59e64b41cf2": "För nybörjare",
        "9dadf2a3-6883-4929-b77d-ac424f690a7c": "Lösenord",
        "a07d3c2d-0414-43bd-b8a7-6555af86c065": "Ransomware",
        "cdf2ba12-d0cd-4c71-a58e-267ec870007a": "Fysisk säkerhet"
      },
      "videos": {
        "a_secure_network": "Ett säkert nätverk",
        "ai_impact_on_phishing": "AI:s påverkan på phishing",
        "ai_powered_social_engineering_tactics": "AI-drivna social engineering-taktiker",
        "beware_of_public_networks": "Se upp med offentliga nätverk",
        "beware_of_usbs_and_other_hard_drives": "Se upp med USB-minnen och andra hårddiskar",
        "black_white_and_grey_hat_hackers": "Black hat-, white hat- och grey hat-hackare",
        "cybersecurity_on_mobile_devices": "Cybersäkerhet på mobila enheter",
        "data_leak_monitoring": "Övervakning av dataläckor",
        "gdpr_and_security_breaches": "GDPR och säkerhetsintrång",
        "hacking_of_hashes": "Hackning av hashar",
        "how_has_cryptocurrency_changed_hacking": "Hur har kryptovaluta förändrat hackning?",
        "how_to_create_strong_passwords": "Så skapar du starka lösenord",
        "how_to_detect_phishing": "Så upptäcker du phishing",
        "how_to_prevent_tailgating": "Så förhindrar du tailgating",
        "how_to_protect_confidential_data_in_llms": "Så skyddar du konfidentiell data i LLM:er",
        "how_to_strengthen_your_physical_security": "Så stärker du din fysiska säkerhet",
        "multi_factor_authentication": "Flerfaktorsautentisering",
        "password_managers": "Lösenordshanterare",
        "phishing_from_a_trusted_sender": "Phishing från en betrodd avsändare",
        "processing_of_personal_data": "Behandling av personuppgifter"
      }
    }
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "at_least_two_options": "Vänligen ange minst två alternativ för varje fråga",
        "invalid_locale": "Vänligen välj ett giltigt språk",
        "network": "Ett fel har inträffat",
        "noResponse": "Ingen respons mottogs från servern",
        "no_audience": "Vänligen välj en målgrupp",
        "no_date": "Vänligen fyll i ett giltigt datum",
        "no_group": "Vänligen välj en grupp",
        "no_lesson": "Vänligen välj en lektion",
        "no_manager": "Vänligen välj en chef",
        "no_phone_country_code": "Vänligen välj en telefonlandsnummerkod",
        "no_role": "Vänligen välj en roll",
        "no_tag": "Vänligen välj en tagg",
        "no_timezone": "Vänligen välj en tidszon",
        "unknown": "Ett okänt fel har inträffat"
      },
      "messages": {
        "at_least_one_manager": "Du måste ha minst en chef i din arbetsyta",
        "auth_failed": "Ogiltig e-post och/eller lösenord",
        "course_could_not_be_published": "Kunde inte publicera. Se till att alla steg är ifyllda på alla språk och att inget saknar titel.",
        "deepl_translation_failed": "AI-översättning misslyckades. Försök igen senare.",
        "duplicate_field_identifier": "Fältidentifierare finns redan",
        "duplicate_goal": "Det finns redan ett mål med den här typen och slutdatumet.",
        "general_exception": "Ett fel har inträffat",
        "goal_expired": "Ett mål som redan har löpt ut kan inte uppdateras.",
        "group_has_automation": "Den här gruppen kan inte tas bort eftersom den är en del av en aktiv automatisering.",
        "group_has_campaign": "Den här gruppen kan inte raderas eftersom den är en del av en aktiv kampanj.",
        "invalid_domain": "Ogiltig domän",
        "invalid_invite": "Ogiltig inbjudan",
        "invalid_metadata": "Metadata-URL:en kunde inte hämtas eller innehöll inte användbar SAML-metadata. Se till att SAML-konfigurationerna är angivna i din IdP.",
        "invalid_phone_number": "Ogiltigt telefonnummer",
        "invalid_provider": "Den valda leverantören är ogiltig.",
        "invalid_provider_id": "Leverantörs-ID:et du angav är ogiltigt",
        "invalid_request": "Tekniskt fel",
        "invalid_request_signature": "Länken du använde är ogiltig eller inte längre aktiv. Be din administratör att utfärda en ny inbjudan.",
        "invalid_response": "Identitetsleverantören returnerade ett ogiltigt svar.",
        "missing_calculation": "Det verkar som att vi saknar viss data. Försök igen senare.",
        "missing_teams_app_installation": "Teams-appen är inte installerad. Installera Moxso Teams-appen.",
        "missing_user": "Vi kan inte hitta en användare med den e-postadressen.",
        "no_available_integration": "Ingen integration för den valda leverantören är tillgänglig.",
        "not_found": "Kunde inte hitta begärd artikel",
        "passwords_dont_match": "De angivna lösenorden är inte identiska",
        "policy_has_active_audit": "Kan inte radera eftersom policyn har en aktiv granskning.",
        "policy_not_approved": "Kan inte skapa granskning eftersom policyn inte är godkänd.",
        "provider_resource_not_found": "Gruppen hittades inte i integrationskatalogen.",
        "saml_provider_not_found": "SAML-anslutningen hittades inte.",
        "sync_conflict": "Medarbetarsynkronisering är redan aktiverad via en annan katalogintegration eller SCIM-anslutning. Inaktivera den andra anslutningen för medarbetarsynkronisering innan du aktiverar den här.",
        "sync_provider_missing": "Kunde inte kontakta leverantören",
        "sync_provider_response_failure": "Det går inte att synkronisera kontakter",
        "too_many_requests": "För många försök. Försök igen om ett par minuter.",
        "two_factor_challenge_invalid": "Inloggningsutmaningen har löpt ut. Logga in igen.",
        "two_factor_code_invalid": "Autentiseringskoden är ogiltig.",
        "unexpected_error": "Ett oväntat fel uppstod. Försök igen.",
        "upcoming_action_has_data": "Åtgärder är redan planerade för efterföljande steg i denna sekvens. Vänligen ta bort dessa åtgärder innan du sparar.",
        "user_already_active": "Användaren finns redan.",
        "user_exists_in_different_workspace": "Användaren finns redan, men i en annan arbetsyta. Kontakta supporten för att lägga till användaren i den här arbetsytan.",
        "user_not_found": "Länken du använde är ogiltig eller inte längre aktiv. Vänligen be din administratör att utfärda en ny inbjudan.",
        "video_could_not_be_uploaded": "Video kunde inte laddas upp"
      },
      "validations": {
        "messages": {
          "accepted_if": "Ogiltiga fält",
          "after_or_equal": "Slutdatumet måste vara ett datum efter eller samma som startdatumet",
          "alpha": "Fältet {_field_} får endast innehålla alfabetiska tecken",
          "alpha_dash": "Fältet {_field_} kan innehålla alfanumeriska tecken samt bindestreck och understreck",
          "alpha_num": "Fältet {_field_} får endast innehålla alfanumeriska tecken",
          "alpha_spaces": "Fältet {_field_} får endast innehålla alfabetiska tecken och mellanslag.",
          "between": "Fältet {_field_} måste vara mellan {min} och {max}",
          "boolean": "{_field_} fältet är inte ett giltigt värde",
          "confirmed": "Bekräftelsen för fältet {_field_} stämmer inte överens",
          "currentPassword": "Lösenordet är inte giltigt",
          "date": "{_field_}-fältet är inte ett giltigt datum",
          "date_format": "{_field_} fält är inte ett giltigt datum",
          "digits": "Fältet {_field_} måste vara numeriskt och innehålla exakt {length} siffror.",
          "dimensions": "Fältet {_field_} måste vara {width} pixlar gånger {height} pixlar",
          "double": "Fältet {_field_} måste vara ett giltigt decimaltal",
          "email": "Fältet {_field_} måste vara en giltig e-postadress",
          "excluded": "Fältet {_field_} är inte ett giltigt värde",
          "ext": "Fältet {_field_} är inte en giltig fil",
          "image": "Fältet {_field_} måste vara en bild",
          "in": "{_field_}-fältet är inte ett giltigt värde",
          "integer": "Fältet {_field_} måste vara ett heltal",
          "invalid_domain": "Du måste verifiera din domän innan du kan lägga till användare",
          "invalid_field": "Ogiltiga fält",
          "invalid_phone_number": "Ogiltigt telefonnummer",
          "length": "Fältet {_field_} måste vara {length} tecken långt",
          "max": "Fältet {_field_} får inte vara större än {length} tecken",
          "max_value": "Fältet {_field_} måste vara {max} eller mindre",
          "mimes": "Fältet {_field_} måste ha en giltig filtyp",
          "min": "Fältet {_field_} måste vara minst {length} tecken.",
          "min_value": "Fältet {_field_} måste vara {min} eller mer",
          "missing_user": "Vi kan inte hitta en användare med den e-postadressen.",
          "non_disposable_email": "{_field_}-fältet måste vara en giltig e-postadress",
          "not_found": "{_field_} hittades inte",
          "numeric": "Fältet {_field_} får endast innehålla numeriska tecken.",
          "oneOf": "Fältet {_field_} är inte ett giltigt värde",
          "regex": "Formatet för fältet {_field_} är ogiltigt",
          "required": "Detta fält är obligatoriskt.",
          "required_if": "Fältet {_field_} är obligatoriskt",
          "size": "Fältet {_field_} måste vara mindre än {size}KB i storlek.",
          "string": "Fältet {_field_} får endast innehålla alfabetiska tecken",
          "true": "Fältet {_field_} måste accepteras",
          "unique": "{_field_} har redan tagits",
          "unique_provider_id": "Den här gruppen finns redan i integrationsleverantören"
        }
      }
    },
    "automation": {
      "flow": {
        "title": {
          "action_selector": "Välj åtgärd",
          "add_tag_action": "Lägg till tagg",
          "assign_course_action": "Tilldela kurs",
          "assign_lesson_action": "Tilldela lektion",
          "assign_quiz_action": "Tilldela bedömning",
          "assign_video_action": "Tilldela video",
          "halt_action": "Stoppa automatisering",
          "missing_action": "Åtgärd saknas",
          "remove_tag_action": "Ta bort tagg",
          "wait_action": "Vänta i en viss tid"
        }
      },
      "frequency": {
        "intense": "Intensiv",
        "loose": "Lös",
        "normal": "Normal"
      },
      "status": {
        "paused": "pausad",
        "running": "körs",
        "started": "startade"
      },
      "templates": {
        "advanced-it-security-training": {
          "description": "Avancerad säkerhetsutbildning för IT- och teknisk personal.",
          "title": "Avancerad IT-säkerhetsutbildning"
        },
        "blank": {
          "description": "Börja från början med en tom automatisering.",
          "title": "Tom automatisering"
        },
        "cybersecurity-and-physical-security-awareness-intense": {
          "description": "Omfattande säkerhetsutbildning för avancerade användare.",
          "title": "Cybersäkerhets- och fysisk säkerhetsmedvetenhet (Intensiv)"
        },
        "cybersecurity-and-physical-security-awareness-light": {
          "description": "Introducerande säkerhetsutbildning för anställda utan dator.",
          "title": "Cybersäkerhets- och fysisk säkerhetsmedvetenhet (Lätt)"
        },
        "cybersecurity-and-physical-security-awareness-medium": {
          "description": "Utbildning i säkerhetsmedvetenhet för anställda med datoråtkomst.",
          "title": "Cybersäkerhets- och fysisk säkerhetsmedvetenhet (Mellan)"
        },
        "cybersecurity-fundamentals": {
          "description": "Centrala principer och bästa praxis inom cybersäkerhet.",
          "title": "Grunder i cybersäkerhet"
        },
        "management-training-in-it-security": {
          "description": "Cybersäkerhetsmedvetenhet för chefer och ledning.",
          "title": "Ledarskapsutbildning i IT-säkerhet"
        },
        "security-awareness-essentials-training": {
          "description": "Grundläggande cybersäkerhetsmedvetenhet för alla anställda.",
          "title": "Grundläggande utbildning i säkerhetsmedvetenhet"
        }
      },
      "triggers": {
        "date_trigger": "På ett specifikt datum",
        "employee_added_to_audience_trigger": "När en anställd läggs till i sekvenspubliken",
        "employee_created_trigger": "När en anställd skapas",
        "simulation_link_clicked_trigger": "När en anställd klickar på en länk i en simulering",
        "tag_added_trigger": "När en anställd tilldelas en tagg",
        "tag_removed_trigger": "När en anställd tas bort från en tagg"
      },
      "triggers_help": {
        "date_trigger": "Registrerar alla i den valda målgruppen när utlösaren aktiveras. Anställda som läggs till i målgruppen efter det datumet registreras inte automatiskt.",
        "employee_added_to_audience_trigger": "Registrerar en anställd när personen läggs till i målgruppen som är kopplad till automatiseringen.",
        "employee_created_trigger": "Registrerar en anställd så snart personen läggs till i Moxso.",
        "simulation_link_clicked_trigger": "Registrerar en anställd när personen klickar på en länk i en nätfiskesimulering, så att du kan tilldela riktad uppföljningsutbildning."
      },
      "wait_units": {
        "days": "dagar",
        "hours": "timme | timmar",
        "minutes": "minut | minuter",
        "months": "månad | månader",
        "seconds": "sekund | sekunder",
        "weeks": "vecka | veckor"
      }
    },
    "employees": {
      "deactivation_notice": {
        "account_disabled": "Detta konto har inaktiverats manuellt av en administratör den {date}.",
        "active_directory": "Detta konto har inaktiverats på grund av en ändring i din Active Directory den {date}.",
        "simulation_bounce": "Detta konto har inaktiverats på grund av ett studshändelse i en simulering den {date}.",
        "simulation_complaint": "Detta konto har inaktiverats på grund av ett klagomål i en simulering den {date}."
      },
      "recent_activity": {
        "type": {
          "clicked": "{name} klickade på en simuleringslänk",
          "completed_course": "{name} har slutfört en kurs",
          "correct": "{name} svarade rätt på ett nätfisketest",
          "delivered": "{name} fick en simulering",
          "incorrect": "{name} svarade fel på ett nätfiskequiz",
          "mc_correct": "{name} svarade rätt på en flervalsfråga",
          "mc_incorrect": "{name} svarade fel på en flervalsfråga",
          "reported": "{name} rapporterade en simulering",
          "sms_clicked": "{name} klickade på en länk i en smishing-simulering",
          "sms_delivered": "{name} fick en smishing-simulering",
          "submission": "{name} loggade in på en simulering",
          "submit_delivered": "{name} fick en simulering",
          "watched_video": "{name} tittade på en video"
        }
      },
      "status": {
        "active": "aktiv",
        "inactive": "inaktiv"
      }
    },
    "export_form_fields": {
      "clicked_count": "Simuleringar klickade",
      "created_at": "Skapelsedatum",
      "department": "Avdelning",
      "dynamic_group_memberships": "Dynamiska gruppmedlemskap",
      "email": "E-post",
      "first_name": "Förnamn",
      "group_count": "Antal grupper",
      "last_name": "Efternamn",
      "locale": "Språk",
      "manager_name": "Chef",
      "onboarded": "Ombordstatus",
      "phishing_quizzes_count": "Genomförda nätfiskequizzer",
      "phone_number": "Telefonnummer",
      "point_count": "Poängsumma",
      "provider": "Integrationsleverantör",
      "received_count": "Mottagna simuleringar",
      "reported_count": "Rapporterade simuleringar",
      "score": "Poäng",
      "status": "Status",
      "submitted_count": "Inloggningar i simuleringar",
      "video_quizzes_count": "Videokvitton slutförda",
      "watched_count": "Videor visade"
    },
    "feature_upsell": {
      "bring-your-own-content": {
        "items": [
          "Ladda upp egna videor och utbildningsmaterial",
          "Lokalisera uppladdningar för flera språk och team",
          "Dela onboarding- och complianceinnehåll anpassat till organisationen",
          "Automatisera schemaläggning, uppföljning och rapportering för eget innehåll."
        ],
        "summary": "Kombinera Moxso-utbildning med eget material för att leverera innehåll som matchar era arbetsflöden, verktyg och interna kommunikation.",
        "title": "Eget innehåll"
      },
      "compliance-integration": {
        "items": [
          "Anslut Drata och Vanta med mindre friktion i uppsättningen.",
          "Minska manuell insamling av compliance-underlag.",
          "Koppla utbildningsaktivitet till revisionsvänliga arbetsflöden.",
          "Stöd återkommande granskningar med färre överlämningar."
        ],
        "summary": "Synkronisera compliance-underlag och koppla Moxso-aktivitet till Drata- och Vanta-arbetsflöden med mindre manuellt uppföljningsarbete.",
        "title": "Drata- och Vanta-complianceintegration"
      },
      "goal-setting": {
        "items": [
          "Sätt mätbara mål för viktiga resultatmått.",
          "Följ framsteg mot målet över tid.",
          "Använd prognostiserade trender för att se om målet är realistiskt.",
          "Upptäck tidigt om resultatet är på rätt spår."
        ],
        "summary": "Sätt ett mål, följ framsteg över tid och jämför det med en prognostiserad trendlinje för att se om målet är realistiskt och på rätt spår.",
        "title": "Målsättning"
      },
      "human-risk-intelligence": {
        "items": [
          "Övervaka mänskliga risksignaler på ett ställe.",
          "Följ tilldelningar och interventioner över tid.",
          "Förstå framväxande beteendebaserad risk tidigare.",
          "Prioritera åtgärder med rikare riskkontext."
        ],
        "summary": "Följ mänskliga risksignaler, interventioner och tilldelningar i en vy för att förstå framväxande beteendebaserad risk.",
        "title": "Insikt i mänsklig risk"
      },
      "industry-benchmarking": {
        "items": [
          "Jämför resultat mot benchmark från liknande verksamheter.",
          "Lägg till kontext för motståndskraft och utbildningsmätvärden.",
          "Upptäck avvikelser snabbare över centrala KPI:er.",
          "Stärk rapporteringen till intressenter och ledning."
        ],
        "summary": "Jämför motståndskraft och utbildningsresultat med branschbenchmark för att ge era säkerhetsmätvärden mer kontext.",
        "title": "Branschbenchmarking"
      },
      "phishing-reporting-add-in": {
        "items": [
          "Gör det enklare för medarbetare att rapportera misstänkta mejl direkt.",
          "Upptäck attacker snabbare innan de hinner spridas vidare.",
          "Håll säkerhetsrapportering enkel och top of mind för alla.",
          "Bygg in rapportering i det dagliga arbetet utan extra friktion."
        ],
        "summary": "E-posttillägg som låter medarbetare rapportera phishing och misstänkta mejl direkt från inkorgen.",
        "title": "Phishingrapportering"
      },
      "policy-management": {
        "items": [
          "Skapa och uppdatera interna policyer på ett ställe",
          "Tilldela policyer till rätt team vid rätt tidpunkt",
          "Samla in medarbetares bekräftelser på policyer",
          "Följ status och bevara ett revisionsspår"
        ],
        "summary": "Publicera interna policyer, följ upp bekräftelser och håll dokumentationen organiserad i hela organisationen.",
        "title": "Policyhantering"
      },
      "risk-based-training": {
        "items": [
          "Adaptivt lärande baserat på beteende och risksignaler.",
          "Minska mänsklig cyberrisk med personlig utbildning.",
          "Fokusera på verkliga sårbarheter, inte hypotetiska hot.",
          "Minska belastningen för användare med låg risk."
        ],
        "summary": "Säkerhetsutbildning som anpassar innehåll och intensitet utifrån medarbetares risksignaler och riskprofil, baserat på simuleringar och observerat beteende.",
        "title": "Riskbaserad utbildning"
      },
      "simulation-builder": {
        "items": [
          "Anpassa simuleringar efter organisationen och era hot.",
          "Tilldela kampanjer till de användare, roller eller grupper som betyder mest.",
          "Använd välbekanta avsändare, budskap och teman för autenticitet.",
          "Utforma kampanjer på era villkor och fokusera på prioriterade områden.",
          "Generera realistiska phishing-simuleringar med AI."
        ],
        "summary": "Konfigurationsverktyg för att skapa och hantera phishing-simuleringskampanjer, inklusive mallar, avsändarprofiler och domäner.",
        "title": "Simuleringsbyggare"
      },
      "smishing": {
        "items": [
          "Kör SMS-baserade phishing-simuleringar.",
          "Testa hur medarbetare reagerar på mobila enheter.",
          "Utöka awareness-utbildning bortom inkorgen.",
          "Mät motståndskraft mot mobilfokuserade attackmönster."
        ],
        "summary": "Utöka simuleringar bortom e-post med SMS- och QR-baserade phishing-scenarier anpassade för mobilfokuserade attacker.",
        "title": "Smishing och quishing"
      },
      "spear-phishing": {
        "items": [
          "Simulera programvarumålning och vd-bedrägerier.",
          "Testa insamling av inloggningsuppgifter i mer realistiska scenarier.",
          "Utöka phishingprogram med avancerade attacktyper.",
          "Förbered medarbetare för social engineering med högre risk."
        ],
        "summary": "Skapa avancerade phishing-simuleringar för programvarumålning, vd-efterlikning och scenarier för insamling av inloggningsuppgifter.",
        "title": "Spear phishing"
      },
      "teams-slack-integration": {
        "items": [
          "Koppla samarbetskanaler till säkerhetsarbetsflöden.",
          "Styr relevanta aviseringar dit teamen redan arbetar.",
          "Utöka rapportering och awareness till daglig kommunikation.",
          "Stöd snabbare uppföljning mellan säkerhet och drift."
        ],
        "summary": "Koppla samman samarbetsplattformar för att synkronisera aviseringar och utöka säkerhetsarbetsflöden till dagliga kommunikationskanaler.",
        "title": "MS Teams- och Slack-integration"
      },
      "threat-management": {
        "items": [
          "Insyn i rapporterade hot i realtid",
          "Branschspecifika varningar om nya attackmönster",
          "Analys av hottrender i organisationen",
          "Fungerar direkt med Outlook och Gmail."
        ],
        "summary": "Undersök misstänkta e-postmeddelanden, förstå risksignaler och hantera hot från ett samlat arbetsflöde för säkerhetsteam.",
        "title": "Hothantering"
      }
    },
    "frameworks": {
      "ai_act": "AI Act",
      "dora": "DORA",
      "gdpr": "GDPR",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "nis2": "NIS2",
      "soc_2": "SOC 2"
    },
    "goals": {
      "metric": {
        "click_rate": "Klickfrekvens",
        "employees_behind": "Medarbetare som ligger efter",
        "report_rate": "Rapporteringsfrekvens",
        "resilience_score": "Motståndskraftspoäng"
      },
      "outcome": {
        "achieved": "Uppnått",
        "missed": "Missat"
      },
      "status": {
        "ahead": "Före",
        "at_risk": "I riskzonen",
        "on_track": "På rätt spår"
      }
    },
    "group": {
      "sync_failure": {
        "invalid_provider": {
          "subtitle": "Vänligen välj en giltig leverantör och uppdatera data."
        },
        "invalid_provider_id": {
          "subtitle": "Vänligen välj ett giltigt leverantörs-ID och uppdatera data."
        },
        "no_available_integration": {
          "subtitle": "Vänligen välj en tillgänglig integration."
        },
        "provider_resource_not_found": {
          "subtitle": "Uppdatera gruppens leverantörs-ID."
        },
        "recommended_action": "Rekommenderad åtgärd",
        "title": "Synkronisering misslyckades"
      }
    },
    "groups": {
      "adaptive_conditions": {
        "fields": {
          "department": "Avdelning",
          "email": "E-post",
          "locale": "Språk",
          "manager_id": "Chef",
          "onboarded": "Onboardingstatus",
          "organizational_role_id": "Roll",
          "provider": "Integrationsleverantör",
          "score": "Poäng",
          "status": "Status",
          "timezone": "Tidszon"
        },
        "operators": {
          "contains": "innehåller",
          "ends_with": "slutar med",
          "equals": "är",
          "greater_than": "är större än",
          "greater_than_or_equal": "är större än eller lika med",
          "is_empty": "är tom",
          "is_not_empty": "är inte tom",
          "less_than": "är mindre än",
          "less_than_or_equal": "är mindre än eller lika med",
          "not_equals": "är inte",
          "starts_with": "börjar med"
        },
        "values": {
          "active": "Aktiv",
          "false": "Falskt",
          "google": "Google Workspace",
          "google_scim": "Google SCIM",
          "inactive": "Inaktiv",
          "microsoft": "Microsoft Entra ID",
          "microsoft_scim": "Microsoft Entra SCIM",
          "okta_scim": "Okta SCIM",
          "slack": "Slack",
          "true": "Sant"
        }
      }
    },
    "hri_integration_tags": {
      "access_permissions": {
        "description": "Åtkomsthändelser, auktorisering, privilegier och applikationsåtkomst.",
        "headline": "Åtkomst"
      },
      "account_security": {
        "description": "Kontostatus, skydd, ändringar, livscykel och riskutsatta användare.",
        "headline": "Kontosäkerhet"
      },
      "audit_administration": {
        "description": "Granskningsloggar, administrativa händelser och ändringar av säkerhetsinställningar.",
        "headline": "Granskningsloggar"
      },
      "authentication_mfa": {
        "description": "Inloggningar, inloggningsaktivitet, autentiseringsresultat och MFA-händelser.",
        "headline": "Autentisering"
      },
      "data_protection_insider_risk": {
        "description": "Händelser inom skydd mot dataförlust (DLP) och insiderrisker.",
        "headline": "Dataskydd"
      },
      "device_management": {
        "description": "Hanteringstäckning, agentstatus och säkerhetsläge för enhetsåtkomst.",
        "headline": "Enhetshantering"
      },
      "device_security": {
        "description": "Kryptering, skärmlås, slutpunktsskydd och enhetsefterlevnad.",
        "headline": "Enhetssäkerhet"
      },
      "email_security": {
        "description": "E-posthot och kontoövertaganden.",
        "headline": "E-postsäkerhet"
      },
      "incidents_investigations": {
        "description": "Säkerhetsincidenter, allvarlighetsgrad och utredningsstatus.",
        "headline": "Incidenter"
      },
      "remediation_control_gaps": {
        "description": "Skyddsbrister, kontrollfynd och åtgärdsförlopp.",
        "headline": "Kontrollbrister"
      },
      "service_health": {
        "description": "Tjänsteincidenter, komponentstatus och planerat underhåll.",
        "headline": "Tjänstestatus"
      },
      "sharing_data_activity": {
        "description": "Delningsändringar, dataförflyttning, objektanvändning och Git-aktivitet.",
        "headline": "Dataaktivitet"
      },
      "threats_detections": {
        "description": "Säkerhetsvarningar, hotsignaler och riskidentifieringar.",
        "headline": "Hot"
      },
      "vulnerabilities_exposure": {
        "description": "Sårbarheter, molnfynd, penetrationstestfynd och exponering.",
        "headline": "Sårbarheter"
      },
      "workforce_organization": {
        "description": "Roller, team, anställningar och arbetsformer.",
        "headline": "Personal"
      }
    },
    "hri_integrations": {
      "abnormal_ai": {
        "bullets": [
          {
            "label": "Verkliga e-posthot",
            "text": "{label}: Upptäckt nätfiske och andra e-postattacker som stöds ger underlag utöver simuleringar."
          },
          {
            "label": "Komprometterade konton",
            "text": "{label}: Fynd av kontoövertaganden hjälper till att identifiera konton som kan behöva utredas omgående."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Använd relevanta belägg för attacker för att göra vägledningen om nätfiske och kontosäkerhet mer specifik."
          },
          {
            "label": "Åtgärdskontext",
            "text": "{label}: Registrerade åtgärder och ärendestatus hjälper till att förklara vad som redan har hanterats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser information om hot och åtgärder utan att ta bort meddelanden eller vidta åtgärder på konton."
          }
        ],
        "description_long": "Abnormal AI upptäcker e-postattacker och kontoövertaganden. Anslut tjänsten så att Moxso kan använda verkliga attacksignaler för att rikta uppföljningen av mänskliga risker mot de hot som människor möter i er miljö.",
        "description_short": "Använd e-posthot och fynd av kontoövertaganden för att fokusera säkerhetsuppföljningen.",
        "title": "Abnormal AI"
      },
      "aikido": {
        "bullets": [
          {
            "label": "Säkerhetsfynd",
            "text": "{label}: Sårbarheter och andra problem som stöds identifierar områden som behöver teknisk uppmärksamhet."
          },
          {
            "label": "Exponeringskontext",
            "text": "{label}: Allvarlighetsgrad och information om berörda resurser hjälper till att förklara betydelsen av ett fynd."
          },
          {
            "label": "Fokuserade åtgärder",
            "text": "{label}: Använd relevanta fynd för att rikta tekniska åtgärder och säkerhetsvägledning till rätt team."
          },
          {
            "label": "Utveckling över tid",
            "text": "{label}: Ändringar i fyndens status hjälper till att skilja kvarstående problem från sådant som redan har hanterats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda säkerhetsfynd utan att ändra kod eller tillämpa korrigeringar."
          }
        ],
        "description_long": "Aikido Security identifierar svagheter i programvara och infrastruktur. Anslut tjänsten för att ta med relevant teknisk exponering i underlaget för era granskningar av mänskliga risker och er säkerhetsuppföljning.",
        "description_short": "Lägg till sårbarheter i programvara och infrastruktur i era riskgranskningar.",
        "title": "Aikido Security"
      },
      "airtable": {
        "bullets": [
          {
            "label": "Kontoskydd",
            "text": "{label}: Tillgängliga indikatorer för autentisering och privilegier hjälper till att belysa åtkomstproblem."
          },
          {
            "label": "Verklig aktivitet",
            "text": "{label}: Utvalda granskningshändelser ger belägg för säkerhetsrelevanta åtgärder och ändringar."
          },
          {
            "label": "Riktad vägledning",
            "text": "{label}: Använd relevanta händelser för att fokusera råd om kontoskydd och ansvarsfull åtkomst till delad information."
          },
          {
            "label": "Löpande granskning",
            "text": "{label}: Beakta ändringar av kontosäkerheten och återkommande händelser tillsammans med annat underlag."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsinformation utan att komma åt tabellposter. Åtkomst till Enterprise API kräver ett abonnemang som ger rätt till detta."
          }
        ],
        "description_long": "Airtable hjälper team att arbeta med delad verksamhetsinformation. Anslut tjänsten så att Moxso kan använda relevanta kontosäkerhets- och granskningssignaler som underlag för mänskliga risker och fokuserad uppföljning.",
        "description_short": "Granska kontosäkerhetssignaler och granskningsaktivitet kring delad verksamhetsinformation.",
        "title": "Airtable"
      },
      "asana": {
        "bullets": [
          {
            "label": "Åtkomstsignaler",
            "text": "{label}: Granskningshändelser som stöds identifierar aktivitet som påverkar åtkomst till konton och projekt."
          },
          {
            "label": "Delningsändringar",
            "text": "{label}: Utvalda medlemskaps- och länkåtkomsthändelser ger belägg för ändringar i samarbetsåtkomsten."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd omständigheterna kring en händelse för att fokusera åtkomstgranskningar och vägledning om säker delning."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta återkommande åtkomständringar tillsammans med annat säkerhetsunderlag."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda granskningsmetadata utan att komma åt uppgiftsbeskrivningar eller projektinnehåll. Tillgången till granskningsdata beror på ert Asana-abonnemang."
          }
        ],
        "description_long": "Asana hjälper team att organisera och dela arbete. Anslut tjänsten så att Moxso kan använda utvalda åtkomst- och delningshändelser som underlag för mänskliga risker och stödja säkrare samarbete.",
        "description_short": "Använd åtkomst- och delningshändelser som vägledning för säkrare samarbete.",
        "title": "Asana"
      },
      "atlassian": {
        "bullets": [
          {
            "label": "Kontosäkerhetssignaler",
            "text": "{label}: Granskningshändelser som stöds ger belägg för åtkomstrelaterad aktivitet."
          },
          {
            "label": "Känsliga ändringar",
            "text": "{label}: Administrativa åtgärder hjälper till att identifiera ändringar som bör granskas närmare."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Använd relevanta händelser som vägledning för åtkomstgranskningar och råd om kontosäkerhet."
          },
          {
            "label": "Löpande medvetenhet",
            "text": "{label}: Beakta återkommande aktivitet tillsammans med annat underlag innan ni beslutar om åtgärder."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda granskningsmetadata utan att komma åt ärendetexter i Jira eller sidinnehåll i Confluence."
          }
        ],
        "description_long": "Atlassian stödjer samarbete i hela organisationen. Anslut tjänsten så att Moxso kan använda utvalda konto- och administrativa händelser som underlag för mänskliga risker och vägleda relevant uppföljning.",
        "description_short": "Granska kontoaktivitet och administrativ aktivitet i era samarbetsverktyg.",
        "title": "Atlassian"
      },
      "auth0": {
        "bullets": [
          {
            "label": "Verkliga inloggningssignaler",
            "text": "{label}: Utvalda misslyckade inloggningar, MFA-händelser och attackrelaterade händelser visar åtkomstproblem."
          },
          {
            "label": "Kontoskydd",
            "text": "{label}: Ändringar av inloggningsuppgifter och säkerhetsrelaterade kontoändringar ger ytterligare granskningsunderlag."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd aktivitet som kan kopplas till medarbetare som vägledning för utredningar och råd om kontosäkerhet."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta upprepade autentiseringsproblem i sammanhanget för den berörda applikationen."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald aktivitet utan att ändra applikationskonton eller autentiseringsinställningar."
          }
        ],
        "description_long": "Auth0 hanterar inloggningar i era applikationer. Anslut tjänsten så att Moxso kan använda relevanta autentiserings- och kontosäkerhetssignaler som underlag för mänskliga risker när aktiviteten berör er personal.",
        "description_short": "Använd personalens inloggnings- och kontosäkerhetshändelser som underlag för riskgranskningar.",
        "title": "Auth0"
      },
      "clerk": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tillgängliga statusar för låsta och avstängda konton hjälper till att identifiera konton som kan behöva granskas närmare."
          },
          {
            "label": "Åtkomstkontext",
            "text": "{label}: Organisationsmedlemskap hjälper till att sätta applikationsåtkomst i perspektiv."
          },
          {
            "label": "Fokuserad uppföljning",
            "text": "{label}: Använd relevant kontokontext som vägledning för åtkomstgranskningar och samtal om kontosäkerhet."
          },
          {
            "label": "Aktuell bild",
            "text": "{label}: Beakta kontots senaste status tillsammans med annat underlag när ni avgör vad som behöver uppmärksammas."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser konto- och åtkomstinformation utan att ändra inställningar i Clerk. Den här anslutningen samlar inte in inloggningshändelser eller sessionsaktivitet."
          }
        ],
        "description_long": "Clerk hanterar åtkomst till era applikationer. Anslut tjänsten så att Moxso kan beakta kontext kring kontoåtkomst tillsammans med mänskliga risker och bidra till mer relevant uppföljning av kontosäkerhet.",
        "description_short": "Använd kontostatus och organisationsmedlemskap som underlag för åtkomstgranskningar.",
        "title": "Clerk"
      },
      "cloudflare_zero_trust": {
        "bullets": [
          {
            "label": "Säkerhetsändringar",
            "text": "{label}: Utvalda granskningshändelser identifierar ändringar av åtkomstrelaterade inställningar och resurser."
          },
          {
            "label": "Åtkomstkontext",
            "text": "{label}: Tillgängliga uppgifter om aktör, åtgärd och utfall hjälper till att förklara betydelsen av en händelse."
          },
          {
            "label": "Fokuserad granskning",
            "text": "{label}: Använd känsliga ändringar för att identifiera var en åtkomstgranskning eller säkerhetsuppföljning behövs."
          },
          {
            "label": "Löpande insyn",
            "text": "{label}: Beakta upprepade administrativa ändringar tillsammans med annat säkerhetsunderlag."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsinformation utan att ändra åtkomstpolicyer. Den här anslutningen tillhandahåller inte trafikövervakning eller inloggningstelemetri från Access."
          }
        ],
        "description_long": "Cloudflare Zero Trust skyddar åtkomsten till företagets resurser. Anslut tjänsten så att Moxso kan använda utvalda säkerhets- och åtkomstkontrolländringar som kontext för mänskliga risker och utredningar.",
        "description_short": "Granska säkerhets- och åtkomstkontrolländringar som påverkar företagets resurser.",
        "title": "Cloudflare Zero Trust"
      },
      "comp_ai": {
        "bullets": [
          {
            "label": "Säkerhetsfynd",
            "text": "{label}: Fynd som stöds belyser förhållanden som behöver granskas eller åtgärdas."
          },
          {
            "label": "Skyddskontext",
            "text": "{label}: Tillgängliga enhetssäkerhetskontroller, inklusive krypteringsstatus, hjälper till att förklara problemet."
          },
          {
            "label": "Praktiska åtgärder",
            "text": "{label}: Använd relevant underlag för att fokusera uppföljningen med medarbetaren, IT-teamet eller den kontrollansvariga."
          },
          {
            "label": "Förändrade förhållanden",
            "text": "{label}: Uppdateringar av fynd och skyddsstatus hjälper till att skilja kvarstående problem från sådant som har åtgärdats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalt säkerhetsunderlag utan att slutföra uppgifter eller ändra policyer."
          }
        ],
        "description_long": "Comp AI följer säkerhetskontroller och efterlevnadsfynd. Anslut tjänsten så att Moxso kan beakta relevanta skyddsbrister vid granskning av mänskliga risker och beslut om var uppföljning behövs.",
        "description_short": "Använd säkerhetsfynd och brister i enhetsskyddet för att fokusera uppföljningen.",
        "title": "Comp AI"
      },
      "crowdstrike": {
        "bullets": [
          {
            "label": "Verkliga attacksignaler",
            "text": "{label}: Slutpunktsvarningar ger belägg för misstänkt eller skadlig aktivitet."
          },
          {
            "label": "Exponeringskontext",
            "text": "{label}: Allvarlighetsgrad, berörda resurser och tillgängliga sårbarhetsuppgifter hjälper till att sätta fynd i perspektiv."
          },
          {
            "label": "Fokuserad uppföljning",
            "text": "{label}: Använd relevanta fynd för att samordna utredningar, åtgärder på enheter och vägledning till medarbetare."
          },
          {
            "label": "Utredningsförlopp",
            "text": "{label}: Fynd- och ärendestatus hjälper till att visa vilka problem som fortfarande behöver uppmärksammas."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda säkerhetsfynd utan att isolera värddatorer eller ändra utredningar."
          }
        ],
        "description_long": "CrowdStrike Falcon upptäcker hot på arbetsenheter. Anslut tjänsten så att Moxso kan använda relevanta slutpunktsfynd som underlag för mänskliga risker och fokusera uppföljningen på verkliga säkerhetsproblem.",
        "description_short": "Ta med slutpunktsvarningar och sårbarhetsfynd i era riskgranskningar.",
        "title": "CrowdStrike"
      },
      "datadog": {
        "bullets": [
          {
            "label": "Säkerhetssignaler",
            "text": "{label}: Utvalda fynd ger belägg för aktivitet som bör utredas."
          },
          {
            "label": "Kontoaktivitet",
            "text": "{label}: Autentiserings-, åtkomst- och säkerhetskonfigurationshändelser som stöds tillför kontext."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Använd medarbetarrelaterat underlag som vägledning för kontosäkerhetsgranskningar och relevanta råd."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta återkommande händelser och fynduppdateringar tillsammans med annat riskunderlag."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsinformation utan att importera allmänna applikationsmätvärden eller ändra inställningar."
          }
        ],
        "description_long": "Datadog identifierar säkerhetsaktivitet i övervakade miljöer. Anslut tjänsten så att Moxso kan använda relevanta säkerhetsfynd och kontohändelser som underlag för granskningar av mänskliga risker.",
        "description_short": "Lägg till säkerhetsfynd och kontoaktivitet från övervakade miljöer.",
        "title": "Datadog"
      },
      "deel": {
        "bullets": [
          {
            "label": "Rollkontext",
            "text": "{label}: Ansvarsområden och avdelningar hjälper till att sätta säkerhetsproblem i perspektiv."
          },
          {
            "label": "Personalförändringar",
            "text": "{label}: Ändringar av anställningsstatus ger kontext för att granska om åtkomsten fortfarande är lämplig."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Beakta personens arbetssituation när ni väljer säkerhetsråd och ämnen för säkerhetsmedvetenhet."
          },
          {
            "label": "Fokuserad uppföljning",
            "text": "{label}: Använd roll- och livscykelkontext tillsammans med säkerhetsunderlag som vägledning för samtal med rätt personer."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser relevant personalinformation utan att ändra anställningsuppgifter eller hantera löner."
          }
        ],
        "description_long": "Deel hjälper till att hantera personal med olika roller och arbetsformer. Anslut tjänsten så att Moxso kan beakta relevant personalkontext vid granskning av mänskliga risker och planering av säkerhetsuppföljning.",
        "description_short": "Lägg till personalkontext från globala medarbetarregister.",
        "title": "Deel"
      },
      "drata": {
        "bullets": [
          {
            "label": "Skyddssignaler",
            "text": "{label}: Kontroller av kryptering, antivirus, brandvägg, uppdateringar och skärmlås som stöds hjälper till att identifiera svagheter."
          },
          {
            "label": "Säkerhet i vardagen",
            "text": "{label}: Kontroller av lösenordshanterare och andra tillgängliga kontroller ger kontext för praktiska säkerhetsvanor."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Använd specifika brister för att avgöra vad som behöver medarbetarvägledning och vad som kräver IT-åtgärder."
          },
          {
            "label": "Löpande förbättring",
            "text": "{label}: Beakta förändrade kontrollresultat tillsammans med annat underlag om mänskliga risker."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalt säkerhetsunderlag utan att ändra kontrollresultat eller enhetsinställningar."
          }
        ],
        "description_long": "Drata samlar in underlag om säkerhetskontroller på arbetsplatsen. Anslut tjänsten så att Moxso kan använda relevanta kontrollbrister som kontext för mänskliga risker och mer fokuserad uppföljning.",
        "description_short": "Använd säkerhetskontroller för enheter och arbetsplatser för att identifiera skyddsbrister.",
        "title": "Drata"
      },
      "duo": {
        "bullets": [
          {
            "label": "Verkliga autentiseringssignaler",
            "text": "{label}: Lyckade, nekade och misslyckade autentiseringar samt rapporterade bedrägerihändelser hjälper till att identifiera aktivitet som behöver granskas."
          },
          {
            "label": "Användbar kontext",
            "text": "{label}: Tillgängliga autentiseringsfaktorer och orsaker till resultaten hjälper till att förklara vad som hände."
          },
          {
            "label": "Riktad vägledning",
            "text": "{label}: Fokusera råden på att känna igen oväntade förfrågningar och skydda åtkomsten där relevanta händelser inträffar."
          },
          {
            "label": "Upprepad aktivitet",
            "text": "{label}: Beakta återkommande nekanden eller misslyckanden tillsammans med annat underlag innan ni beslutar om åtgärder."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser autentiseringsaktivitet och utvald säkerhetsaktivitet utan att godkänna förfrågningar eller ändra Duo-policyer."
          }
        ],
        "description_long": "Duo hjälper till att skydda konton med multifaktorautentisering. Anslut tjänsten så att Moxso kan använda verkliga autentiseringsresultat som vägledning för uppföljning av MFA-vanor och kontosäkerhet.",
        "description_short": "Använd autentiseringsresultat som vägledning för uppföljning av MFA och kontosäkerhet.",
        "title": "Duo"
      },
      "fortinet_fortianalyzer": {
        "bullets": [
          {
            "label": "Åtkomstsignaler",
            "text": "{label}: Autentiseringsresultat som stöds hjälper till att identifiera kontoaktivitet som är värd att utreda."
          },
          {
            "label": "Känsliga ändringar",
            "text": "{label}: Administrativa händelser tillför belägg för ändringar som påverkar er miljö."
          },
          {
            "label": "Fokuserad uppföljning",
            "text": "{label}: Använd relevant kontoaktivitet som vägledning för utredningar och råd om åtkomstsäkerhet."
          },
          {
            "label": "Återkommande mönster",
            "text": "{label}: Beakta upprepade åtkomstproblem tillsammans med andra signaler innan ni väljer åtgärd."
          },
          {
            "label": "Dataåtkomst",
            "text": "{label}: Använder loggsökningsuppgifter för att läsa utvalda händelser utan att ändra brandväggskonfigurationen."
          }
        ],
        "description_long": "FortiAnalyzer samlar in säkerhetsaktivitet från er Fortinet-miljö. Anslut tjänsten så att Moxso kan använda utvalda åtkomsthändelser och administrativa händelser som underlag för granskningar av mänskliga risker.",
        "description_short": "Granska autentiseringshändelser och administrativa händelser från er Fortinet-miljö.",
        "title": "FortiAnalyzer"
      },
      "github_enterprise": {
        "bullets": [
          {
            "label": "Känsliga ändringar",
            "text": "{label}: Utvalda granskningshändelser belyser ändringar av åtkomst, behörigheter och kontosäkerhet."
          },
          {
            "label": "Kodåtkomstaktivitet",
            "text": "{label}: Git-händelser som stöds ger ytterligare belägg för åtkomst till kodarkiv."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Använd medarbetarrelaterade händelser för att fokusera råd om skydd av inloggningsuppgifter och säkra utvecklingsmetoder."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta upprepad åtkomstaktivitet och känsliga ändringar i deras arbetskontext."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda aktivitetsmetadata utan att komma åt källkoden i kodarkiven."
          }
        ],
        "description_long": "GitHub Enterprise skyddar åtkomsten till er källkod och era utvecklingsflöden. Anslut tjänsten så att Moxso kan använda relevant aktivitet på utvecklarkonton som underlag för mänskliga risker och fokuserad säkerhetsuppföljning.",
        "description_short": "Använd aktivitet på utvecklarkonton och åtkomst till kodarkiv som vägledning för säkerhetsuppföljning.",
        "title": "GitHub Enterprise"
      },
      "google_workspace": {
        "bullets": [
          {
            "label": "Verkliga aktivitetssignaler",
            "text": "{label}: Utvalda inloggnings-, kontosäkerhets- och administratörshändelser belyser aktivitet som är värd att granska."
          },
          {
            "label": "Delningsrisk",
            "text": "{label}: Nedladdningar, delningsändringar och applikationsauktoriseringar som stöds ger belägg för hur information används."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Fokusera vägledningen på kontoskydd, tredjepartsappar och säker delning där underlaget visar ett behov."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta upprepade händelser och förändrat åtkomstbeteende tillsammans med resultat från medvetenhetsträning."
          },
          {
            "label": "Läsåtkomst",
            "text": "{label}: Läser utvalda säkerhetsmetadata utan att läsa Gmail-meddelanden eller innehållet i Drive-filer."
          }
        ],
        "description_long": "Google Workspace är platsen där människor loggar in, delar filer och auktoriserar applikationer. Anslut tjänsten så att Moxso kan använda säkerhetsrelevant aktivitet som underlag för mänskliga risker och göra uppföljningen mer relevant för det dagliga arbetet.",
        "description_short": "Granska inloggnings-, delnings- och applikationsåtkomstaktivitet som underlag för mänskliga risker.",
        "title": "Google Workspace"
      },
      "gusto": {
        "bullets": [
          {
            "label": "Rollförståelse",
            "text": "{label}: Befattnings- och avdelningskontext hjälper till att förklara arbetet bakom ett kontos aktivitet."
          },
          {
            "label": "Anställningsförändringar",
            "text": "{label}: Tillgänglig information om anställningsstatus stödjer samtal om åtkomst när omständigheterna förändras."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Beakta ansvarsområden när ni väljer ämnen för säkerhetsmedvetenhet och praktiska säkerhetsråd."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Använd anställningskontext tillsammans med säkerhetssignaler när ni avgör vad som behöver uppmärksammas."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser relevant anställningsinformation utan att ändra ersättningar eller köra löner."
          }
        ],
        "description_long": "Gusto underhåller anställningsinformation när människor börjar, byter roll och slutar. Anslut tjänsten så att Moxso kan beakta denna kontext vid granskning av mänskliga risker och göra uppföljningen relevant för personens ansvarsområden.",
        "description_short": "Lägg till personalkontext från medarbetarregister.",
        "title": "Gusto"
      },
      "hibob": {
        "bullets": [
          {
            "label": "Rollkontext",
            "text": "{label}: Ansvarsområden och avdelningar hjälper till att sätta säkerhetsaktivitet i perspektiv."
          },
          {
            "label": "Arbetsmiljö",
            "text": "{label}: Tillgänglig information om arbetsplats tillför kontext för att förstå personens omständigheter."
          },
          {
            "label": "Livscykelförändringar",
            "text": "{label}: Ändringar av anställningsstatus kan ge underlag för diskussioner om kontoåtkomst och säkerhetsansvar."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd arbetskontexten tillsammans med faktiskt säkerhetsunderlag som vägledning för praktiska råd."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser relevant personalinformation utan att ändra HR-uppgifter eller komma åt prestationsbedömningar via den här anslutningen."
          }
        ],
        "description_long": "HiBob ger kontext om människors roller och arbetsmiljö. Anslut tjänsten så att Moxso kan beakta denna kontext tillsammans med mänskliga risker och göra säkerhetsuppföljningen mer relevant för det dagliga arbetet.",
        "description_short": "Lägg till medarbetar- och rollkontext från ert HR-system.",
        "title": "HiBob"
      },
      "hubspot": {
        "bullets": [
          {
            "label": "Inloggningssignaler",
            "text": "{label}: Lyckade och misslyckade inloggningshändelser hjälper till att identifiera problem med kontoåtkomst."
          },
          {
            "label": "Känsliga åtgärder",
            "text": "{label}: Utvalda händelser för behörigheter, inloggningsuppgifter, integrationer och dataförflyttning tillför kontext."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Använd medarbetarrelaterad aktivitet för att fokusera råd om kontosäkerhet och hantering av kundinformation."
          },
          {
            "label": "Återkommande problem",
            "text": "{label}: Beakta upprepade händelser tillsammans med annat riskunderlag innan ni väljer åtgärd."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsaktivitet utan att komma åt CRM-kontakter, affärer eller marknadsföringsinnehåll."
          }
        ],
        "description_long": "HubSpot stödjer arbete med kundinformation. Anslut tjänsten så att Moxso kan använda relevanta kontoåtkomst- och säkerhetshändelser som underlag för mänskliga risker och göra uppföljningen specifik för det arbetet.",
        "description_short": "Granska inloggnings- och säkerhetsaktivitet kring åtkomst till kundinformation.",
        "title": "HubSpot"
      },
      "iru": {
        "bullets": [
          {
            "label": "Skyddstäckning",
            "text": "{label}: Indikatorer för hanterings- och agentstatus hjälper till att identifiera enheter som behöver uppmärksammas."
          },
          {
            "label": "Enhetstillgänglighet",
            "text": "{label}: Senaste incheckning och indikatorer för saknade enheter ger kontext om huruvida skyddsinformationen är aktuell."
          },
          {
            "label": "Relevant aktivitet",
            "text": "{label}: Utvalda säkerhetsrelaterade granskningshändelser hjälper till att förklara ändringar som bör granskas."
          },
          {
            "label": "Praktisk uppföljning",
            "text": "{label}: Använd skyddsbrister som vägledning för åtgärder med medarbetare och IT."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald enhetssäkerhetsinformation utan att köra åtgärder på enheter."
          }
        ],
        "description_long": "Iru hjälper organisationer att hantera och skydda arbetsenheter. Anslut tjänsten så att Moxso kan beakta brister i enhetshanteringens täckning vid granskning av mänskliga risker.",
        "description_short": "Identifiera brister i enhetshanteringens täckning och agentskyddet.",
        "title": "Iru"
      },
      "jamf_pro": {
        "bullets": [
          {
            "label": "Enhetsskydd",
            "text": "{label}: Information om FileVault och lösenkoder som stöds kan belysa säkerhetsinställningar som behöver uppmärksammas."
          },
          {
            "label": "Hanteringstäckning",
            "text": "{label}: Tillgänglig hanteringsstatus hjälper till att fastställa om en enhet står under organisationens kontroll."
          },
          {
            "label": "Praktisk uppföljning",
            "text": "{label}: Skyddsbrister kan vägleda samtal med medarbetare och det IT-team som ansvarar för deras enheter."
          },
          {
            "label": "Välgrundade granskningar",
            "text": "{label}: Beakta enheternas tillstånd tillsammans med annat underlag i stället för att se en underkänd kontroll som bevis på osäkert beteende."
          },
          {
            "label": "Anslutningsstatus",
            "text": "{label}: Den här integrationen är för närvarande inte tillgänglig för anslutning i den registrerade leverantörskatalogen."
          }
        ],
        "description_long": "Tillgänglighet: För närvarande inte tillgänglig. Jamf Pro hjälper till att skydda de Apple-enheter som människor använder i arbetet. Enhetssäkerhetsinformation kan sätta mänskliga risker i sitt sammanhang och skilja skyddsbrister från problem som kräver vägledning till medarbetare.",
        "description_short": "Hantering av Apple-enheter. Den här integrationen är för närvarande inte tillgänglig.",
        "title": "Jamf Pro"
      },
      "jumpcloud": {
        "bullets": [
          {
            "label": "Autentiseringsunderlag",
            "text": "{label}: Utvalda Directory Insights-händelser visar lyckade och misslyckade åtkomstförsök."
          },
          {
            "label": "Känslig aktivitet",
            "text": "{label}: Administrativa händelser och händelser för privilegierad åtkomst som stöds belyser ändringar som förtjänar uppmärksamhet."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd kontorelaterat underlag som vägledning för utredningar och råd om åtkomstsäkerhet."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Granska återkommande autentiseringsproblem och känsliga ändringar tillsammans med andra signaler."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsinformation utan att ändra inställningar i JumpCloud."
          }
        ],
        "description_long": "JumpCloud hjälper till att säkra åtkomst till applikationer och enheter. Anslut tjänsten så att Moxso kan använda verkliga autentiserings- och administrativa signaler som underlag för mänskliga risker och fokusera uppföljningen på relevanta åtkomstproblem.",
        "description_short": "Använd autentiseringshändelser och administrativa händelser för att granska åtkomstrisker.",
        "title": "JumpCloud"
      },
      "lattice": {
        "bullets": [
          {
            "label": "Rollförståelse",
            "text": "{label}: Befattnings- och avdelningskontext hjälper till att förklara personens ansvarsområden."
          },
          {
            "label": "Kontolivscykel",
            "text": "{label}: Tillgänglig kontostatus tillför kontext när människor börjar eller slutar använda en applikation."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Beakta arbetsansvar när ni väljer säkerhetsämnen och praktiska råd."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Använd organisationskontext tillsammans med säkerhetsunderlag när ni diskuterar åtkomst och uppföljning."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser relevant konto- och organisationsinformation utan att komma åt prestationsbedömningar, återkoppling eller ersättningsuppgifter via den här anslutningen."
          }
        ],
        "description_long": "Lattice ger kontext om roller och organisatoriska ansvarsområden. Anslut tjänsten så att Moxso kan beakta denna kontext vid granskning av mänskliga risker och val av relevant säkerhetsuppföljning.",
        "description_short": "Lägg till kontext om medarbetarprofiler och teamstruktur.",
        "title": "Lattice"
      },
      "linear": {
        "bullets": [
          {
            "label": "Kontoändringar",
            "text": "{label}: Granskningshändelser som stöds identifierar säkerhetsrelevanta ändringar, till exempel kontoavstängning."
          },
          {
            "label": "Åtkomstkontext",
            "text": "{label}: Tillgängliga uppgifter om aktör och åtgärd hjälper till att förklara vad som hände."
          },
          {
            "label": "Fokuserad uppföljning",
            "text": "{label}: Använd relevanta händelser som vägledning för granskningar av kontoåtkomst och säkerhetssamtal."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta återkommande ändringar tillsammans med andra säkerhetssignaler."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda granskningsmetadata utan att komma åt ärendeinnehåll. Granskningsloggar kräver ett Enterprise-abonnemang som ger rätt till detta."
          }
        ],
        "description_long": "Linear stödjer samarbete inom produkt och utveckling. Anslut tjänsten så att Moxso kan använda utvalda konto- och åtkomständringar som underlag för mänskliga risker och bidra till fokuserad säkerhetsuppföljning.",
        "description_short": "Granska konto- och åtkomständringar i produkt- och utvecklingsteam.",
        "title": "Linear"
      },
      "microsoft_defender_xdr": {
        "bullets": [
          {
            "label": "Verkliga hotsignaler",
            "text": "{label}: Varningar och incidenter identifierar aktivitet som Microsoft bedömer som misstänkt eller skadlig."
          },
          {
            "label": "Exponeringskontext",
            "text": "{label}: Tillgängliga slutpunktsfynd och sårbarheter hjälper till att förklara omständigheterna kring en händelse."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Prioritera utredning och relevant säkerhetsvägledning där fynd rör människor eller deras arbetsenheter."
          },
          {
            "label": "Utredningsförlopp",
            "text": "{label}: Ändringar i fyndens status hjälper till att skilja aktiva problem från sådant som har åtgärdats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda fynd utan att isolera enheter, stänga incidenter eller tillämpa korrigeringar."
          }
        ],
        "description_long": "Microsoft Defender XDR identifierar hot i hela er Microsoft-miljö. Anslut tjänsten så att Moxso kan använda relevanta varningar och incidenter för att förankra granskningar av mänskliga risker i verkliga säkerhetshändelser.",
        "description_short": "Ta med Microsofts säkerhetsvarningar, incidenter och sårbarheter i riskgranskningar.",
        "title": "Microsoft Defender XDR"
      },
      "microsoft_entra": {
        "bullets": [
          {
            "label": "Verkliga attacksignaler",
            "text": "{label}: Läckta inloggningsuppgifter, lösenordssprejning, ovanliga resor och obekanta inloggningar kan visa konton som behöver uppmärksammas."
          },
          {
            "label": "Kontext för mänskliga risker",
            "text": "{label}: Risknivåer och identifieringsuppgifter hjälper till att sätta misstänkt aktivitet i perspektiv."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Fokusera utredning och vägledning om kontosäkerhet på de personer som berörs av relevanta händelser."
          },
          {
            "label": "Risk över tid",
            "text": "{label}: Ändringar från aktiv risk till åtgärdad eller avfärdad ger underlag för vad som fortfarande behöver uppmärksammas."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser status för riskutsatta användare och riskidentifieringar. Signalernas detaljnivå beror på Microsoft-licensieringen; premiumidentifieringar kan kräva Entra ID P2."
          }
        ],
        "description_long": "Entra ID Protection flaggar inloggningar och konton som verkar vara komprometterade. Anslut tjänsten så att Moxso kan använda verkliga identitetsrisksignaler som underlag för uppföljning, baserat på vad som händer i er miljö tillsammans med simuleringar.",
        "description_short": "Använd riskfyllda inloggningar och signaler om komprometterade konton för att fokusera säkerhetsuppföljningen.",
        "title": "Microsoft Entra ID Protection"
      },
      "microsoft_intune": {
        "bullets": [
          {
            "label": "Enhetssäkerhetssignaler",
            "text": "{label}: Tillgängliga efterlevnads- och krypteringsstatusar belyser skyddsbrister."
          },
          {
            "label": "Relevanta ändringar",
            "text": "{label}: Utvalda hanteringshändelser tillför kontext om åtgärder som påverkar enhetssäkerheten."
          },
          {
            "label": "Praktisk uppföljning",
            "text": "{label}: Hjälper till att skilja enhetsproblem som behöver IT:s uppmärksamhet från ämnen som lämpar sig för medarbetarvägledning."
          },
          {
            "label": "Förändrat säkerhetsläge",
            "text": "{label}: Beakta aktuell skyddsstatus och återkommande brister vid riskgranskning."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald enhetssäkerhets- och granskningsinformation utan att ändra enhetsinställningar. Kräver relevant åtkomst och licens för Intune."
          }
        ],
        "description_long": "Microsoft Intune hjälper till att skydda de enheter som människor använder i arbetet. Anslut tjänsten så att Moxso kan beakta slutpunkternas säkerhetsläge tillsammans med mänskliga risker och vägleda praktisk uppföljning.",
        "description_short": "Granska brister i enheternas efterlevnad och kryptering tillsammans med mänskliga risker.",
        "title": "Microsoft Intune"
      },
      "microsoft_purview": {
        "bullets": [
          {
            "label": "Dataskyddssignaler",
            "text": "{label}: DLP-händelser som stöds identifierar aktivitet som utlöste en regel för datahantering."
          },
          {
            "label": "Ytterligare riskkontext",
            "text": "{label}: Utvalda insiderriskhändelser tillför utredningsunderlag där de är tillgängliga."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Använd omständigheterna kring en händelse för att fokusera råd om säker hantering och delning av företagsinformation."
          },
          {
            "label": "Välgrundad granskning",
            "text": "{label}: Beakta upprepade signaler och deras sammanhang innan ni drar slutsatser om beteende eller avsikt."
          },
          {
            "label": "Begränsad åtkomst",
            "text": "{label}: Läser utvalda aktivitetsmetadata och kan initiera de nödvändiga flödena. Ändrar inte dataskyddspolicyer."
          }
        ],
        "description_long": "Microsoft Purview hjälper till att identifiera riskfylld hantering av känslig information. Anslut tjänsten så att Moxso kan använda relevanta dataskyddssignaler som vägledning för granskningar av mänskliga risker och mer fokuserad uppföljning.",
        "description_short": "Använd dataskydds- och insiderriskhändelser som vägledning för säker informationshantering.",
        "title": "Microsoft Purview"
      },
      "microsoft_sentinel": {
        "bullets": [
          {
            "label": "Verkliga incidenter",
            "text": "{label}: Allvarlighetsgrad och incidentuppgifter ger underlag om säkerhetsproblem som redan utreds."
          },
          {
            "label": "Användbar kontext",
            "text": "{label}: Tillgänglig käll- och attackinformation hjälper till att förklara varför en incident är viktig."
          },
          {
            "label": "Samordnad uppföljning",
            "text": "{label}: Använd relevant incidentunderlag för att samordna medarbetarvägledning med säkerhetsteamets insatser."
          },
          {
            "label": "Utredningsförlopp",
            "text": "{label}: Statusändringar hjälper till att skilja nya, aktiva och lösta problem åt."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser incidentinformation utan att ändra utredningar eller köra allmänna loggsökningar."
          }
        ],
        "description_long": "Microsoft Sentinel samlar säkerhetsincidenter för utredning. Anslut tjänsten så att Moxso kan beakta relevanta incidenter tillsammans med mänskliga risker och hjälpa till att samordna uppföljningen med ert säkerhetsteam.",
        "description_short": "Använd säkerhetsincidenter och utredningsstatus för att samordna uppföljning.",
        "title": "Microsoft Sentinel"
      },
      "monday": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tillgängliga aktiva och inaktiva statusar hjälper till att identifiera konton som kan behöva granskas."
          },
          {
            "label": "Åtkomstkontext",
            "text": "{label}: Kontotyper och teamrelationer hjälper till att sätta applikationsåtkomst i perspektiv."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Beakta kontokontext tillsammans med säkerhetssignaler när ni avgör var uppmärksamhet behövs."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd denna kontext som vägledning för samtal om kontosäkerhet och lämplig åtkomst."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser information om kontoåtkomst utan att ändra inställningar i monday.com eller komma åt innehållet i tavlor och objekt."
          }
        ],
        "description_long": "monday.com hjälper team att organisera arbetet och samarbeta mellan avdelningar. Anslut tjänsten så att Moxso kan beakta kontext kring applikationsåtkomst tillsammans med mänskliga risker och göra uppföljningen av kontosäkerhet mer relevant.",
        "description_short": "Använd kontostatus och teamrelationer som underlag för åtkomstgranskningar.",
        "title": "monday.com"
      },
      "new_relic": {
        "bullets": [
          {
            "label": "Åtkomstkontext",
            "text": "{label}: Tillgängliga kontorelationer hjälper till att sätta åtkomsten till er övervakningsmiljö i perspektiv."
          },
          {
            "label": "Organisationskontext",
            "text": "{label}: Gruppmedlemskap ger bakgrund för att granska hur åtkomsten är organiserad."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Beakta applikationsåtkomst tillsammans med annat underlag när ni avgör vad som behöver uppmärksammas."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd åtkomstkontext som vägledning för samtal om kontosäkerhet med ansvariga team."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser information om kontoåtkomst utan att ändra inställningar i New Relic. Den här anslutningen samlar inte in övervakningsvarningar, applikationstelemetri eller granskningshändelser."
          }
        ],
        "description_long": "New Relic stödjer de team som ansvarar för att övervaka era system. Anslut tjänsten så att Moxso kan beakta kontext kring applikationsåtkomst tillsammans med mänskliga risker och bidra till fokuserade kontosäkerhetsgranskningar.",
        "description_short": "Lägg till kontext om användarkatalog och gruppmedlemskap från New Relic.",
        "title": "New Relic"
      },
      "okta": {
        "bullets": [
          {
            "label": "Autentiseringssignaler",
            "text": "{label}: Inloggningsresultat och utvalda säkerhetshändelser ger belägg för hur konton används."
          },
          {
            "label": "Känsliga ändringar",
            "text": "{label}: Konto- och behörighetsändringar hjälper till att identifiera åtkomst som bör granskas närmare."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Använd relevanta händelser som vägledning för utredningar och praktiska råd om kontosäkerhet."
          },
          {
            "label": "Återkommande problem",
            "text": "{label}: Beakta upprepade autentiseringsproblem tillsammans med annat underlag om mänskliga risker."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsinformation utan att ändra Okta-konton eller åtkomstpolicyer."
          }
        ],
        "description_long": "Okta skyddar åtkomsten till företagets applikationer. Anslut tjänsten så att Moxso kan använda autentiserings- och kontosäkerhetssignaler för att förstå verkliga åtkomstrisker och vägleda mer relevant uppföljning.",
        "description_short": "Granska autentiserings- och kontosäkerhetshändelser för att förstå åtkomstrisker.",
        "title": "Okta"
      },
      "oneleet": {
        "bullets": [
          {
            "label": "Bekräftade svagheter",
            "text": "{label}: Tillgängliga penetrationstestfynd beskriver problem som identifierats vid säkerhetstestning."
          },
          {
            "label": "Riskkontext",
            "text": "{label}: Prioritet, berörda mål och åtgärdsvägledning hjälper till att förklara vad som behöver uppmärksammas."
          },
          {
            "label": "Fokuserade åtgärder",
            "text": "{label}: Använd relevanta fynd som vägledning för tekniska åtgärder och säkerhetssamtal med ansvariga team."
          },
          {
            "label": "Utveckling över tid",
            "text": "{label}: Fyndens status hjälper till att skilja öppna problem från sådant som redan har hanterats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser fynd utan att köra tester eller ändra deras åtgärdsstatus."
          }
        ],
        "description_long": "Oneleet identifierar säkerhetssvagheter genom penetrationstestning och efterlevnadsarbete. Anslut tjänsten för att lägga till relevanta tekniska fynd i underlaget för granskningar av mänskliga risker och säkerhetsuppföljning.",
        "description_short": "Lägg till penetrationstestfynd och åtgärdskontext i säkerhetsgranskningar.",
        "title": "Oneleet"
      },
      "onepassword": {
        "bullets": [
          {
            "label": "Inloggningssignaler",
            "text": "{label}: Lyckade och misslyckade försök ger belägg för kontoåtkomstaktivitet."
          },
          {
            "label": "Känsliga åtgärder",
            "text": "{label}: Händelser för objektanvändning och administration som stöds tillför kontext om hur lösenordshanteraren används."
          },
          {
            "label": "Riktad uppföljning",
            "text": "{label}: Fokusera vägledning om säkra inloggningsuppgifter och utredningar på relevant aktivitet."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta upprepade åtkomstproblem tillsammans med annat kontosäkerhetsunderlag."
          },
          {
            "label": "Inga hemliga uppgifter",
            "text": "{label}: Läser aktivitetsmetadata utan att komma åt lösenord, säkra anteckningar eller dokument i valv."
          }
        ],
        "description_long": "1Password hjälper människor att skydda och använda sina inloggningsuppgifter. Anslut tjänsten så att Moxso kan använda inloggnings- och lösenordshanteraraktivitet som underlag för mänskliga risker utan att komma åt hemligheterna i era valv.",
        "description_short": "Granska inloggnings- och lösenordshanteraraktivitet utan att komma åt lagrade hemligheter.",
        "title": "1Password"
      },
      "ping_one": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tillgänglig information om huruvida konton är aktiverade ger kontext för åtkomstgranskning."
          },
          {
            "label": "Åtkomstrelationer",
            "text": "{label}: Gruppmedlemskap hjälper till att förklara hur konton är organiserade."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Beakta åtkomstkontext tillsammans med säkerhetshändelser från era andra anslutna verktyg."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd det samlade underlaget som vägledning för samtal om kontosäkerhet och åtkomstgranskningar."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser information om kontoåtkomst utan att ändra PingOne-policyer. Den här anslutningen samlar inte in autentiseringshändelser."
          }
        ],
        "description_long": "PingOne hjälper till att hantera åtkomst till företagets applikationer. Anslut tjänsten så att Moxso kan beakta relevant kontext kring kontoåtkomst tillsammans med mänskliga risker och vägleda mer fokuserade säkerhetsgranskningar.",
        "description_short": "Lägg till kontext om användarkatalog och medlemskap från PingOne.",
        "title": "PingOne"
      },
      "remote": {
        "bullets": [
          {
            "label": "Rollkontext",
            "text": "{label}: Tillgängliga uppgifter om ansvarsområden och avdelningar hjälper till att sätta säkerhetsproblem i perspektiv."
          },
          {
            "label": "Arbetsformer",
            "text": "{label}: Kontext om land och anställningsform kan bidra till att anpassa råden till personens omständigheter."
          },
          {
            "label": "Anställningsförändringar",
            "text": "{label}: Tillgänglig livscykelinformation stödjer samtal om åtkomst när arbetsformer förändras."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Beakta personalkontext tillsammans med säkerhetsunderlag när ni väljer praktisk vägledning."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser relevant anställningsinformation utan att ändra avtal eller hantera löner."
          }
        ],
        "description_long": "Remote hjälper till att hantera människor som arbetar i olika länder och anställningsformer. Anslut tjänsten så att Moxso kan beakta relevant arbetskontext vid granskning av mänskliga risker och planering av säkerhetsuppföljning.",
        "description_short": "Lägg till personalkontext för globala och geografiskt spridda team.",
        "title": "Remote"
      },
      "rippling": {
        "bullets": [
          {
            "label": "Rollförståelse",
            "text": "{label}: Information om befattning och arbetskontext hjälper till att förklara ansvaret bakom kontoaktivitet."
          },
          {
            "label": "Anställningskontext",
            "text": "{label}: Tillgänglig personalstatus ger bakgrund för åtkomstgranskning när omständigheterna förändras."
          },
          {
            "label": "Relevant vägledning",
            "text": "{label}: Beakta personens ansvarsområden när ni väljer säkerhetsråd och ämnen för säkerhetsmedvetenhet."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Använd anställningskontext tillsammans med säkerhetsunderlag som stöd för åtkomstdiskussioner och uppföljning."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser relevant personalinformation utan att ändra löner, förmåner eller åtkomstinställningar i Rippling."
          }
        ],
        "description_long": "Rippling underhåller kontext om människors roller och anställningar. Anslut tjänsten så att Moxso kan beakta denna kontext tillsammans med mänskliga risker och göra säkerhetsuppföljningen relevant när ansvarsområden förändras.",
        "description_short": "Lägg till medarbetar- och personalkontext från Rippling.",
        "title": "Rippling"
      },
      "sentinel_one": {
        "bullets": [
          {
            "label": "Verkliga hotsignaler",
            "text": "{label}: Hot och varningar identifierar misstänkt aktivitet som påverkar arbetsenheter."
          },
          {
            "label": "Riskkontext",
            "text": "{label}: Tillgänglig information om allvarlighetsgrad, klassificering och sårbarheter hjälper till att förklara vad som behöver uppmärksammas."
          },
          {
            "label": "Fokuserade åtgärder",
            "text": "{label}: Använd underlaget för att samordna utredningen och avgöra om uppföljningen hör hemma hos IT, säkerhetsteamet eller en medarbetare."
          },
          {
            "label": "Förändrad status",
            "text": "{label}: Fynduppdateringar hjälper till att skilja kvarstående problem från aktivitet som redan har hanterats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvald säkerhetsinformation utan att isolera enheter eller åtgärda hot."
          }
        ],
        "description_long": "SentinelOne upptäcker och utreder hot mot slutpunkter. Anslut tjänsten så att Moxso kan använda relevanta hotsignaler som underlag för mänskliga risker och bidra till fokuserad säkerhetsuppföljning.",
        "description_short": "Använd slutpunktshot och sårbarhetsfynd för att fokusera säkerhetsuppföljningen.",
        "title": "SentinelOne"
      },
      "slack": {
        "bullets": [
          {
            "label": "Verklig kontoaktivitet",
            "text": "{label}: Inloggnings- och åtkomsthändelser som stöds hjälper till att synliggöra kontosäkerhetsproblem."
          },
          {
            "label": "Delningssignaler",
            "text": "{label}: Utvalda filrelaterade händelser och delningshändelser tillför belägg för hur information hanteras."
          },
          {
            "label": "Riktad vägledning",
            "text": "{label}: Fokusera råd om säkert samarbete, kontoskydd och informationsdelning där relevanta händelser inträffar."
          },
          {
            "label": "Mönster över tid",
            "text": "{label}: Beakta återkommande aktivitet tillsammans med resultat från medvetenhetsträning och simuleringar."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda granskningsmetadata utan att läsa meddelanden eller filinnehåll. Granskningsåtkomst kräver en Slack Enterprise-organisation som ger rätt till detta."
          }
        ],
        "description_long": "Slack är platsen där människor samarbetar och delar information under dagen. Anslut tjänsten så att Moxso kan använda relevanta inloggnings- och delningssignaler som underlag för mänskliga risker och mer praktisk uppföljning.",
        "description_short": "Använd inloggnings- och delningsaktivitet som vägledning för säkrare samarbete i vardagen.",
        "title": "Slack"
      },
      "splunk": {
        "bullets": [
          {
            "label": "Säkerhetsfynd",
            "text": "{label}: Utvalda fynd belyser aktivitet som er säkerhetsövervakning har identifierat som värd att uppmärksamma."
          },
          {
            "label": "Kontoaktivitet",
            "text": "{label}: Autentiseringshändelser och administrativa händelser som stöds ger ytterligare utredningsunderlag."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd fynd som rör människor eller deras konton som vägledning för säkerhetsåtgärder och råd."
          },
          {
            "label": "Förändrad risk",
            "text": "{label}: Uppdaterad fyndstatus hjälper till att sätta pågående problem i sitt sammanhang."
          },
          {
            "label": "Dataåtkomst",
            "text": "{label}: Använder sökningar för att läsa utvald säkerhetsinformation utan att ändra de underliggande fynden."
          }
        ],
        "description_long": "Splunk samlar säkerhetsunderlag från hela er miljö. Anslut tjänsten så att Moxso kan använda utvalda fynd och kontorelaterade händelser som underlag för mänskliga risker och fokuserad uppföljning.",
        "description_short": "Samla säkerhetsfynd och kontoaktivitet för granskningar av mänskliga risker.",
        "title": "Splunk"
      },
      "statuspage": {
        "bullets": [
          {
            "label": "Tjänsteincidenter",
            "text": "{label}: Publicerad incidentinformation förklarar störningar som rapporterats av tjänsteägaren."
          },
          {
            "label": "Berörda tjänster",
            "text": "{label}: Komponentstatus hjälper till att identifiera vilka delar av en tjänst som påverkas."
          },
          {
            "label": "Planerat underhåll",
            "text": "{label}: Underhållsmeddelanden ger kontext för förväntade avbrott."
          },
          {
            "label": "Åtgärdsförlopp",
            "text": "{label}: Incidentuppdateringar hjälper till att förklara om ett problem utreds eller har lösts."
          },
          {
            "label": "Driftkontext",
            "text": "{label}: En tjänstestörning i sig fastställer inte att ett konto är komprometterat eller att en medarbetare har agerat osäkert."
          }
        ],
        "description_long": "Redaktionell status: Utkast; omfattningen av Moxso-integrationen är inte verifierad i detta kodarkiv. Statuspage kommunicerar tjänsteincidenter och underhåll. Information om tjänstestatus kan ge användbar bakgrund vid säkerhetsuppföljning och hjälpa team att förstå när ett åtkomstproblem sammanfaller med en känd störning.",
        "description_short": "Kontext om tjänsteincidenter och underhåll. Integrationens omfattning är ännu inte verifierad.",
        "title": "Statuspage"
      },
      "tailscale": {
        "bullets": [
          {
            "label": "Åtkomstens säkerhetsläge",
            "text": "{label}: Enhetsauktorisering och status för extern åtkomst hjälper till att identifiera förhållanden som är värda att kontrollera."
          },
          {
            "label": "Skyddskontext",
            "text": "{label}: Information om nycklars giltighetstid och anslutningsstatus ger ytterligare kontext kring nätverksåtkomst."
          },
          {
            "label": "Praktisk uppföljning",
            "text": "{label}: Använd relevanta åtkomstproblem som vägledning för enhetssäkerhetskontroller med ansvarigt team."
          },
          {
            "label": "Aktuella förhållanden",
            "text": "{label}: Granska åtkomstens säkerhetsläge när det förändras i stället för att betrakta en gammal ögonblicksbild som permanent."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser information om enhetsåtkomst utan att ändra nätverksauktorisering eller fånga upp trafik."
          }
        ],
        "description_long": "Tailscale ansluter enheter till ert privata nätverk. Anslut tjänsten för att lägga till nätverksåtkomstens säkerhetsläge i den säkerhetskontext som används vid granskning av mänskliga risker.",
        "description_short": "Granska enhetsauktorisering och skydd av nätverksåtkomst tillsammans med mänskliga risker.",
        "title": "Tailscale"
      },
      "vanta": {
        "bullets": [
          {
            "label": "Säkerhetskontrollsignaler",
            "text": "{label}: Tillgängliga kontroller av kryptering, skärmlås, antivirus och lösenordshanterare belyser skyddsbrister."
          },
          {
            "label": "Tydligare kontext",
            "text": "{label}: Enskilda kontrollresultat ger mer användbara detaljer än en enda efterlevnadsetikett."
          },
          {
            "label": "Praktisk uppföljning",
            "text": "{label}: Använd relevanta brister som vägledning för åtgärder med medarbetare och IT."
          },
          {
            "label": "Förändringar över tid",
            "text": "{label}: Beakta aktuella kontrollresultat och återkommande underkännanden vid riskgranskning."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalt säkerhetsunderlag utan att ändra efterlevnadsresultat eller enhetsinställningar."
          }
        ],
        "description_long": "Vanta kontrollerar om viktiga säkerhetskontroller finns på plats. Anslut tjänsten så att Moxso kan beakta relevanta skyddsbrister tillsammans med mänskliga risker och bidra till praktisk uppföljning.",
        "description_short": "Använd kontroller av kryptering, skärmlås och slutpunkter för att identifiera skyddsbrister.",
        "title": "Vanta"
      },
      "wiz": {
        "bullets": [
          {
            "label": "Molnsäkerhetsfynd",
            "text": "{label}: Problem som stöds belyser exponeringar som behöver utredas eller åtgärdas."
          },
          {
            "label": "Användbar kontext",
            "text": "{label}: Allvarlighetsgrad och information om berörda resurser hjälper till att förklara omständigheterna bakom ett fynd."
          },
          {
            "label": "Fokuserade åtgärder",
            "text": "{label}: Använd relevant exponering som underlag för ansvarsdiskussioner och teknisk uppföljning."
          },
          {
            "label": "Förändrad exponering",
            "text": "{label}: Fynduppdateringar hjälper till att skilja aktiva problem från sådant som har åtgärdats."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser utvalda molnfynd utan att ändra molnkonfigurationen."
          }
        ],
        "description_long": "Wiz identifierar säkerhetsrisker i molnmiljöer. Anslut tjänsten för att lägga till relevant molnexponering i underlaget för granskningar av mänskliga risker och samordnad säkerhetsuppföljning.",
        "description_short": "Lägg till molnsäkerhetsfynd och exponeringskontext i era riskgranskningar.",
        "title": "Wiz"
      },
      "workos": {
        "bullets": [
          {
            "label": "Kontostatus",
            "text": "{label}: Tillgänglig information om kontostatus ger kontext för granskning av applikationsåtkomst."
          },
          {
            "label": "Åtkomstrelationer",
            "text": "{label}: Organisations- och grupprelationer hjälper till att sätta kontoåtkomst i perspektiv."
          },
          {
            "label": "Fokuserade granskningar",
            "text": "{label}: Beakta kontokontext tillsammans med säkerhetshändelser från andra anslutna verktyg."
          },
          {
            "label": "Relevant uppföljning",
            "text": "{label}: Använd det samlade underlaget som vägledning för åtkomstgranskningar och samtal om kontosäkerhet."
          },
          {
            "label": "Skrivskyddad åtkomst",
            "text": "{label}: Läser katalogens åtkomstinformation utan att ändra konton. Den här anslutningen samlar inte in inloggningshändelser eller sessionsaktivitet."
          }
        ],
        "description_long": "WorkOS kopplar samman applikationer med organisationers åtkomstsystem. Anslut tjänsten så att Moxso kan beakta relevant kontext kring kontoåtkomst tillsammans med mänskliga risker och bidra till fokuserade säkerhetsgranskningar.",
        "description_short": "Lägg till kontext om katalog och organisationsmedlemskap från WorkOS.",
        "title": "WorkOS"
      }
    },
    "human_risk_intelligence": {
      "assignment": {
        "rule_labels": {
          "cooldown_days": "Nedkylningsfönster",
          "interval_days": "Tilldelningsintervall",
          "respect_mandatory_training": "Respektera obligatorisk utbildning"
        }
      },
      "assignment_status": {
        "awaiting_assignment": "Inte schemalagd ännu",
        "completed": "Slutförd",
        "due_soon": "Förfaller snart",
        "overdue": "Försenad"
      },
      "intervention": {
        "notification_type": {
          "hri_employee_intervention_email": "Interventionsmejl till anställd",
          "hri_intervention_email": "Interventionsmejl till anställd"
        }
      },
      "onboarding": {
        "glance": {
          "notifications_behavior": {
            "continue_until_completion": "Aviseringar skickas efter deadline tills utbildningen är slutförd",
            "stop_after_deadline": "Aviseringar stoppas när deadline har passerat"
          },
          "notifications_frequency": {
            "intense": "Intens",
            "loose": "Lätt",
            "normal": "Normalt"
          }
        }
      },
      "polarity": {
        "neutral": "Neutral",
        "risky": "Riskfylld",
        "vigilant": "Vaksam"
      },
      "risk_level": {
        "critical": "Kritisk",
        "high": "Hög",
        "low": "Låg",
        "minimal": "Minimal",
        "moderate": "Moderat",
        "severe": "Allvarlig"
      },
      "risk_matrix": {
        "columns": {
          "somewhat_likely": "Något sannolikt",
          "very_likely": "Mycket sannolikt",
          "very_unlikely": "Mycket osannolikt"
        },
        "rows": {
          "high": "Hög",
          "low": "Låg",
          "medium": "Moderat"
        }
      },
      "settings": {
        "interventions": {
          "actions": {
            "assignment": "Tilldela ny lektion",
            "notify_admin": "Meddela administratörer",
            "notify_employee": "Meddela anställd",
            "notify_manager": "Meddela chef"
          },
          "groups": {
            "breach_exposure": {
              "description": "Agera när en anställd förekommer i ett känt dataintrång.",
              "title": "Intrångsexponering"
            },
            "critical_phishing_interactions": {
              "description": "Reagera när en medarbetare utför en kritisk nätfiskeåtgärd, som att skicka in inloggningsuppgifter, öppna en bilaga eller svara.",
              "title": "Kritiska nätfiskeinteraktioner"
            },
            "phishing_interactions": {
              "description": "Agera när en anställd klickar på en länk i en phishing-simulering via e-post eller SMS.",
              "title": "Phishing-interaktioner"
            },
            "simulation_non_reporting": {
              "description": "Agera när en anställd inte rapporterar en phishing-simulering inom 2 eller 7 dagar.",
              "title": "Ej rapporterad simulering"
            },
            "training_inactivity": {
              "description": "Agera när en anställds obligatoriska utbildning är försenad.",
              "title": "Utbildningsinaktivitet"
            }
          },
          "severities": {
            "high": "Hög (60+ dagar försenad)",
            "low": "Låg (7 dagar försenad)",
            "medium": "Medel (30 dagar försenad)"
          },
          "timeframe_options": {
            "intense": "Intensiv",
            "loose": "Lös",
            "normal": "Normal"
          }
        },
        "strategy": {
          "compliance": {
            "description": "Tilldelar utbildning för att uppfylla dokumenterade krav i ISO 27001, SOC 2 och relaterade ramverk.",
            "glance": "för att uppfylla organisationens efterlevnadskrav",
            "title": "Efterlevnadsutbildning"
          },
          "group": {
            "description": "Anpassar utbildning med hjälp av aggregerade beteendetrender över team och avdelningar utan att rikta in sig på individer.",
            "glance": "baserat på aggregerade beteenderisksignaler",
            "title": "Gruppbaserad utbildning"
          },
          "intervention": {
            "description": "Rullar ut riktade interventioner baserade på medarbetares beteendesignaler. Ger skräddarsydd utbildning och korrigerande åtgärder för att hantera identifierade riskmönster och mätbart minska organisationens exponering.",
            "title": "Interventionsstrategi"
          },
          "risk": {
            "description": "Tilldelar utbildning baserat på roll, åtkomstnivå och ansvarsdriven risk i linje med NIS2-förväntningar.",
            "glance": "baserat på varje medarbetares rollriskprofil",
            "title": "Riskbaserad utbildning"
          }
        },
        "summary_signals": {
          "impact": {
            "high": "Hög påverkan",
            "low": "Låg påverkan",
            "medium": "Medel påverkan"
          },
          "signal_labels": {
            "failed_simulation": "Misslyckad phishing-simulering",
            "low_score": "Låg utbildningspoäng"
          }
        }
      },
      "trend": {
        "down": "Ned",
        "stable": "Stabil",
        "up": "Upp"
      }
    },
    "indicators": {
      "A_10": "A.10",
      "A_11": "A.11",
      "A_13": "A.13",
      "A_14": "A.14",
      "A_15": "A.15",
      "A_16": "A.16",
      "A_17": "A.17",
      "A_19": "A.19",
      "A_21_2_A": "A.21(2)(a)",
      "A_21_2_B": "A.21(2)(b)",
      "A_21_2_C": "A.21(2)(c)",
      "A_21_2_D": "A.21(2)(d)",
      "A_21_2_F": "A.21(2)(f)",
      "A_21_2_G": "A.21(2)(g)",
      "A_21_2_I": "A.21(2)(i)",
      "A_23": "A.23",
      "A_24": "A.24",
      "A_26": "A.26",
      "A_28": "A.28",
      "A_30": "A.30",
      "A_32": "A.32",
      "A_33": "A.33",
      "A_34": "A.34",
      "A_39_1_B": "A.39(1)(b)",
      "A_4": "A.4",
      "A_5": "A.5",
      "A_5_15": "A.5.15",
      "A_5_17": "A.5.17",
      "A_5_1_C": "A.5(1)(c)",
      "A_5_1_E": "A.5(1)(e)",
      "A_5_1_F": "A.5(1)(f)",
      "A_5_23": "A.5.23",
      "A_5_24": "A.5.24",
      "A_5_25": "A.5.25",
      "A_5_26": "A.5.26",
      "A_5_27": "A.5.27",
      "A_5_28": "A.5.28",
      "A_5_31": "A.5.31",
      "A_5_34": "A.5.34",
      "A_5_7": "A.5.7",
      "A_6": "A.6",
      "A_6_3": "A.6.3",
      "A_6_7": "A.6.7",
      "A_7_1": "A.7.1",
      "A_7_2": "A.7.2",
      "A_7_3": "A.7.3",
      "A_7_4": "A.7.4",
      "A_8": "A.8",
      "A_8_1": "A.8.1",
      "A_8_2": "A.8.2",
      "A_8_23": "A.8.23",
      "A_8_5": "A.8.5",
      "A_8_7": "A.8.7",
      "A_8_9": "A.8.9",
      "A_9": "A.9",
      "CC1_1": "CC1.1",
      "CC2_1": "CC2.1",
      "CC3_2": "CC3.2",
      "CC4_1": "CC4.1",
      "CC5_2": "CC5.2",
      "CC6_1": "CC6.1",
      "CC7_2": "CC7.2",
      "CC8_1": "CC8.1",
      "CC9_2": "CC9.2",
      "C_10": "C.10",
      "C_6": "C.6",
      "C_7": "C.7",
      "C_8": "C.8",
      "C_9": "C.9",
      "administration": "Administration",
      "ai_act": "AI Act",
      "customer-support-success": "Kundsupport och kundframgång",
      "data-analytics": "Data och analys",
      "dora": "DORA",
      "education-training": "Utbildning och träning",
      "elevated": "Förhöjd åtkomst",
      "engineering-development": "Teknik och utveckling",
      "executive-leadership": "Verkställande ledning",
      "facilities-services": "Fastigheter och tjänster",
      "finance": "Finans",
      "human-resources": "HR",
      "individual_contributor": "Individuell medarbetare",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "it-systems": "IT och system",
      "leadership": "Ledarskap",
      "legal-compliance": "Juridik och regelefterlevnad",
      "management-team-leadership": "Ledning och teamledarskap",
      "managerial": "Chefskap",
      "marketing-communications": "Marknadsföring och kommunikation",
      "nis2": "NIS2",
      "operations": "Verksamhet",
      "product-design": "Produkt och design",
      "project-program-management": "Projekt- och programledning",
      "quality-process": "Kvalitet och process",
      "research-science": "Forskning och vetenskap",
      "sales": "Försäljning",
      "security": "Säkerhet",
      "soc_2": "SOC 2",
      "standard": "Standardåtkomst",
      "supply-chain-logistics": "Leveranskedja och logistik"
    },
    "industries": {
      "aerospace_defence": "Rymd- och försvarsindustrin",
      "automotive": "Bilindustri",
      "banking": "Bankverksamhet och kapitalmarknader",
      "capital_infrastructure": "Kapitalprojekt och infrastruktur",
      "consumer_markets": "Konsumentmarknader",
      "energy_resources": "Energi, verktyg och resurser",
      "engineering_construction": "Teknik och konstruktion",
      "financial_services": "Finansiella tjänster",
      "government_public": "Regerings- och offentliga tjänster",
      "healthcare": "Hälsovård",
      "hospitality_leisure": "Besöksnäring och fritid",
      "industrial_manufacturing": "Industritillverkning",
      "insurance": "Försäkring",
      "media": "Medier",
      "paper_packaging": "Skog, papper och förpackning",
      "pharmaceuticals": "Läkemedel och livsvetenskaper",
      "private_equity": "Private equity",
      "technology": "Teknik",
      "telecommunications": "Telekommunikationer",
      "transportation": "Transport och logistik",
      "wealth_management": "Förmögenhets- och kapitalförvaltning"
    },
    "integrations": {
      "conzentrate": {
        "description": "Synkronisera träningsdata till Learning Arena",
        "title": "Inlärningsarena"
      },
      "csv": {
        "description": "Importera medarbetare från en CSV-fil",
        "title": "CSV-import"
      },
      "drata": {
        "description": "Synkronisera bevis på kursavslut till Drata",
        "title": "Drata"
      },
      "google": {
        "description": "Synkronisera medarbetare och grupper från Google Workspace",
        "group_description": "Importera grupper från Google Workspace",
        "title": "Google Workspace"
      },
      "google_scim": {
        "title": "Google"
      },
      "microsoft": {
        "description": "Synkronisera medarbetare och grupper från Microsoft Entra ID",
        "group_description": "Importera grupper från Microsoft Entra ID",
        "title": "Microsoft Entra ID"
      },
      "microsoft_scim": {
        "title": "Microsoft Entra ID"
      },
      "microsoft_teams": {
        "description": "Skicka träningsnotiser direkt i Teams",
        "title": "Microsoft Teams"
      },
      "okta_scim": {
        "title": "Okta"
      },
      "sabacloud": {
        "description": "Synkronisera träningsdata till Saba Cloud",
        "title": "Saba Cloud"
      },
      "slack": {
        "description": "Synkronisera anställda och grupper från Slack",
        "group_description": "Importera grupper från Slack",
        "title": "Slack"
      },
      "slack_notifications": {
        "description": "Skicka träningsnotiser direkt i Slack",
        "title": "Slack-notiser"
      },
      "sync_failures": {
        "default": "Synkroniseringen av denna integration har misslyckats.",
        "unauthorized": "Synkronisering misslyckades. Vänligen uppdatera autentiseringsinställningarna för denna integration."
      },
      "vanta": {
        "description": "Synkronisera bevis på kursavslut till Vanta",
        "title": "Vanta"
      }
    },
    "invalid_user": "Det nuvarande lösenordet är fel.",
    "language": {
      "da_DK": "Dansk",
      "de_DE": "Tyska",
      "en_US": "Svenska",
      "es_ES": "Spanska",
      "fi_FI": "Finska",
      "fr_FR": "Franska",
      "nb_NO": "Norsk (Bokmål)",
      "nl_NL": "Nederlands",
      "pl_PL": "Polska",
      "pt_PT": "Portugisiska",
      "sv_SE": "Svenska"
    },
    "learning_profile": {
      "data_privacy": {
        "description": "Säkerställa integriteten och skyddet av känslig data",
        "long": "Dataskydd (GDPR)",
        "short": "Dataskydd"
      },
      "device_security": {
        "description": "Säkerhet för fysiska enheter och ändpunkter",
        "long": "Enhetssäkerhet",
        "short": "Enhetssäkerhet"
      },
      "digital_threats": {
        "description": "Skydd mot olika hot på nätet",
        "long": "Digitala hot",
        "short": "Digital hot"
      },
      "hybrid_work": {
        "description": "Säkerhetsöverväganden för distans- och kontorsarbete",
        "long": "Hybridarbete",
        "short": "Hybridarbete"
      },
      "incidents_breaches": {
        "description": "Hantering och förebyggande av säkerhetsincidenter",
        "long": "Incidenter & Brott",
        "short": "Incidenter och Överträdelser"
      },
      "passwords_accounts": {
        "description": "Styrka och hantering av lösenord och konton",
        "long": "Lösenord & Konton",
        "short": "Lösenord & Konton"
      },
      "phishing": {
        "description": "Medvetenhet och förebyggande av nätfiskeattacker",
        "long": "Nätfiske",
        "short": "Nätfiske"
      },
      "physical_security": {
        "description": "Skydd av fysiska tillgångar och utrymmen",
        "long": "Fysisk säkerhet",
        "short": "Fysisk säkerhet"
      },
      "secure_browsing": {
        "description": "Säkra metoder för internetsurfning",
        "long": "Säkert surfande",
        "short": "Säker webbläsning"
      }
    },
    "onboarding": {
      "data_privacy": {
        "category": "Dataskydd (GDPR)",
        "options": {
          "high": "Vi har tydliga policyer och upprätthåller strikta dataskyddsåtgärder",
          "low": "Vi hanterar inte aktivt efterlevnaden av personuppgifter.",
          "medium": "Vi samlar in data men har inga formella riktlinjer på plats"
        },
        "question": "Hur hanterar ditt företag personuppgifter enligt GDPR-förordningarna?"
      },
      "device_security": {
        "category": "Enhetssäkerhet",
        "options": {
          "high": "Enheter är centralt hanterade, krypterade och övervakade",
          "low": "Anställda använder sina egna enheter utan tillämpade säkerhetspolicyer",
          "medium": "Vissa säkerhetsåtgärder tillämpas, men inte konsekvent"
        },
        "question": "Vilka säkerhetsåtgärder finns på plats för företagets enheter?"
      },
      "digital_threats": {
        "category": "Digitala hot",
        "options": {
          "high": "Vi använder endpoint-säkerhet, brandväggar och utbildning av anställda",
          "low": "Vi litar på att anställda sköter sin egen säkerhet",
          "medium": "Vissa skyddsåtgärder är på plats, men inte företagsomfattande"
        },
        "question": "Hur skyddar ditt företag mot skadlig programvara och cyberhot?"
      },
      "hybrid_work": {
        "category": "Hybridarbete",
        "options": {
          "high": "Anställda använder VPN, säkert Wi-Fi och företagets godkända enheter",
          "low": "Anställda använder personliga enheter och osäkra nätverk",
          "medium": "Vissa säkerhetsåtgärder uppmuntras men krävs inte"
        },
        "question": "Hur hanteras säkerheten för distansanställda?"
      },
      "incidents_breaches": {
        "category": "Incidenter och överträdelser",
        "options": {
          "high": "Vi har en incidentresponsplan och testar den regelbundet",
          "low": "Vi hanterar incidenter reaktivt utan någon formell plan",
          "medium": "Vi har en plan men har aldrig testat den"
        },
        "question": "Vad är ditt företags inställning till incidenthantering?"
      },
      "passwords_accounts": {
        "category": "Lösenord & Konton",
        "options": {
          "high": "Lösenordshanterare och MFA krävs för alla anställda",
          "low": "Anställda hanterar sina egna lösenord utan krav",
          "medium": "MFA är valfritt och lösenordspolicys är inte strikt tillämpade."
        },
        "question": "Hur säkerställer ditt företag lösenordssäkerhet?"
      },
      "phishing": {
        "category": "Nätfiske",
        "options": {
          "high": "Anställda genomgår regelbunden utbildning i phishingmedvetenhet",
          "low": "Ingen formell utbildning om nätfiske är på plats",
          "medium": "Viss utbildning erbjuds, men inte regelbundet"
        },
        "question": "Hur minskar ditt företag riskerna med nätfiskehot?"
      },
      "physical_security": {
        "category": "Fysisk säkerhet",
        "options": {
          "high": "Åtkomstkontroll, besöksloggar och säker lagring är på plats",
          "low": "Det finns inga formella fysiska säkerhetsåtgärder",
          "medium": "Vissa säkerhetsåtgärder finns men tillämpas inkonsekvent"
        },
        "question": "Hur hanteras fysisk säkerhet på ditt kontor?"
      },
      "secure_browsing": {
        "category": "Säker webbläsning",
        "options": {
          "high": "Anställda använder säkra webbläsare med innehållsfiltrering",
          "low": "Inga restriktioner eller säkerhetspolicyer för webbsurfning",
          "medium": "Vissa säkerhetsåtgärder finns på plats, men de är inte genomdrivna"
        },
        "question": "Hur säkerställer ditt företag säker internetanvändning?"
      }
    },
    "organizational_role": {
      "access_level": {
        "elevated": "Förhöjd åtkomst",
        "standard": "Standardåtkomst"
      },
      "responsibility_tier": {
        "individual_contributor": "Individuell medarbetare",
        "leadership": "Ledarskap",
        "managerial": "Chefskap"
      }
    },
    "policies": {
      "audit_notifications_frequency": {
        "intense": "Intensiv",
        "loose": "Lös",
        "normal": "Normal"
      },
      "audit_status": {
        "completed": "Avslutad",
        "draft": "Inaktiv",
        "expired": "Utgangen",
        "running": "Granskning"
      }
    },
    "report": {
      "labels": {
        "assignment": "Tilldelning",
        "assignment_completion": "Slutförande av uppgifter",
        "click_rate": "Klickfrekvens",
        "clicked": "Klickade",
        "company_score": "Företagspoäng",
        "completed": "Slutförd",
        "course": "Kurs",
        "course_completed": "Slutförda kurser",
        "critical": "Kritisk",
        "handling_rate": "Hanteringsfrekvens för hot",
        "handling_time": "Hanteringstid för hot",
        "high": "Hög",
        "in_progress": "Pågår",
        "interventions": "Insatser",
        "low": "Låg",
        "medium": "Medel",
        "missed_deadlines": "Missade deadlines",
        "negative": "Negativ",
        "neutral": "Neutral",
        "notify_admin": "Administratör meddelad",
        "notify_employee": "Medarbetare meddelad",
        "notify_manager": "Chef meddelad",
        "onboarding": "Introduktionsfrekvens",
        "overdue": "Försenad",
        "phishing_quizzes": "Phishingquiz",
        "phishing_susceptibility": "Phishingmottaglighet",
        "policy": "Policy",
        "positive": "Positiv",
        "report_rate": "Rapporteringsfrekvens",
        "reported": "Rapporterade",
        "reporting_behavior": "Rapporteringsbeteende",
        "resilience_score": "Motståndskraftspoäng",
        "score": "Motståndskraftspoäng",
        "sent": "Skickade simuleringar",
        "signals": "Signaler",
        "simulations_received": "Mottagna simuleringar",
        "team_score": "Teampoäng",
        "video": "Video",
        "video_quizzes": "Videoquiz",
        "videos_watched": "Visade videor"
      }
    },
    "reports": {
      "frequencies": {
        "bimonthly": "Varannan månad",
        "monthly": "Månadsvis",
        "quarterly": "Kvartalsvis",
        "weekly": "Veckovis",
        "yearly": "Årligen"
      },
      "periods": {
        "prev_month": "Föregående månad",
        "prev_quarter": "Föregående kvartal",
        "prev_week": "Föregående vecka",
        "prev_year": "Senaste 12 månader",
        "ytd": "År till datum"
      },
      "status": {
        "active": "Aktiv",
        "inactive": "Inaktiv"
      },
      "types": {
        "manager": "Rapport för chef",
        "workspace": "Arbetsytans rapport"
      }
    },
    "risk_categories": {
      "agentic_ai": "Agentisk AI",
      "communication_security": "Kommunikationssäkerhet",
      "data_protection": "Dataskydd",
      "digital_exposure_risk": "Risk för digital exponering",
      "endpoint_device_security": "Säkerhet för slutenheter",
      "engagement_awareness": "Engagemangsmedvetenhet",
      "human_use_of_ai": "Mänsklig användning av AI",
      "identity_access_risk": "Identitets- och åtkomstrisk",
      "incident_response_readiness": "Beredskap för incidenthantering",
      "mobile_security": "Mobilsäkerhet",
      "physical_security": "Fysisk säkerhet",
      "policy_regulatory_compliance": "Policy- och regelefterlevnad",
      "remote_work_risk": "Risker med distansarbete",
      "social_engineering_risks": "Risker med social manipulation",
      "third_party_risk": "Tredjepartsrisk",
      "web_cloud_usage": "Användning av webb och moln"
    },
    "roles": {
      "administration": "Administration",
      "customer-support-success": "Kundsupport och kundframgång",
      "data-analytics": "Data och analys",
      "education-training": "Utbildning och träning",
      "engineering-development": "Teknik och utveckling",
      "executive-leadership": "Högsta ledningen",
      "facilities-services": "Faciliteter och tjänster",
      "finance": "Finans",
      "human-resources": "HR",
      "it-systems": "IT och system",
      "legal-compliance": "Juridik och regelefterlevnad",
      "management-team-leadership": "Ledning och teamledarskap",
      "marketing-communications": "Marknadsföring och kommunikation",
      "operations": "Verksamhet",
      "product-design": "Produkt och design",
      "project-program-management": "Projekt- och programledning",
      "quality-process": "Kvalitet och process",
      "research-science": "Forskning och vetenskap",
      "sales": "Försäljning",
      "security": "Säkerhet",
      "supply-chain-logistics": "Leveranskedja och logistik"
    },
    "saml": {
      "name_id_formats": {
        "emailAddress": "E-postadress",
        "persistent": "Persistent",
        "transient": "Transient",
        "unspecified": "Ospecificerad"
      },
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "scim": {
      "providers": {
        "auth0_scim": "Auth0",
        "google_scim": "Google",
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "services": {
      "category": {
        "authentication": "Autentisering",
        "collaboration": "Samarbete",
        "crm": "Kundrelationshantering",
        "digital_signature": "Digital signatur",
        "document_management": "Dokumenthantering",
        "file_sharing": "Fildelning",
        "hrm": "HRM",
        "marketing": "Marknadsföring",
        "other": "Annat",
        "support": "Kundsupport",
        "survey": "Enkät",
        "video_conferencing": "Videokonferenser"
      },
      "target": {
        "all": "Alla",
        "design": "Design",
        "engineering": "Teknik",
        "finance": "Finans",
        "marketing": "Marknadsföring",
        "sales": "Försäljning",
        "support": "Stöd"
      }
    },
    "signals": {
      "key": {
        "access_level": "Åtkomstnivå",
        "ai_act_reference": "AI Act-referens",
        "breach_found": "Intrång upptäckt",
        "cybersecurity_culture_initiative_participated": "Deltar i cybersäkerhetsinitiativ",
        "dora_reference": "DORA-referens",
        "email_simulation_clicked": "E-postsimulering klickad",
        "email_simulation_credentials_submitted": "Inloggningsuppgifter skickade i e-postsimulering",
        "email_simulation_delivered": "E-postsimulering levererad",
        "email_simulation_reported": "E-postsimulering rapporterad",
        "email_simulation_reported_without_clicking": "E-postsimulering rapporterad utan att klicka",
        "employee_imported": "Anställd importerad",
        "frameworks": "Ramverk",
        "high_confidence_in_phishing_self_assessment": "Svarade upprepade gånger rätt på phishingquizzer",
        "iso27001_reference": "ISO27001-referens",
        "iso27005_reference": "ISO27005-referens",
        "legitimate_email_reported_as_phishing": "Rapporterar legitima e-postmeddelanden som phishing",
        "low_confidence_in_phishing_self_assessment": "Svarade upprepade gånger fel på phishingquizzer",
        "low_score": "Låg poäng",
        "missed_deadline_30_days": "Obligatorisk utbildning 30 dagar försenad",
        "missed_deadline_60_days": "Obligatorisk utbildning 60 dagar försenad",
        "missed_deadline_7_days": "Obligatorisk utbildning 7 dagar försenad",
        "multiple_choice_answered_correctly": "Flervalsfråga besvarad korrekt",
        "multiple_choice_answered_incorrectly": "Flervalsfråga besvarad felaktigt",
        "nis2_reference": "NIS2-referens",
        "optional_training_engaged": "Slutförde frivillig utbildning",
        "real_phishing_email_clicked": "Klickade på ett verkligt phishingmejl",
        "real_phishing_email_opened": "Öppnade verkligt phishingmejl",
        "real_phishing_email_opened_attachment": "Öppnade bilaga i ett verkligt phishingmejl",
        "real_phishing_email_reported": "Rapporterade verkligt phishingmejl",
        "real_phishing_email_targeted": "Utsatt i verkliga phishingmejl",
        "responsibility_tier": "Ansvarsnivå",
        "risk_level": "Risknivå",
        "risk_themes": "Riskteman",
        "risk_threshold": "Risktröskel",
        "role": "Roll",
        "role_fallback_used": "Fallback-roll använd",
        "simulation_not_reported_2_days": "Simulering inte rapporterad efter 2 dagar",
        "simulation_not_reported_7_days": "Simulering inte rapporterad efter 7 dagar",
        "sms_simulation_clicked": "SMS-simulering klickad",
        "sms_simulation_delivered": "SMS-simulering levererad",
        "sms_simulation_reported": "SMS-simulering rapporterad",
        "soc2_reference": "SOC2-referens",
        "threat_reported": "Hot rapporterat",
        "training_completed": "Tilldelad utbildning slutförd",
        "training_completed_after_deadline": "Slutförd efter deadline",
        "training_completed_on_time": "Tilldelad utbildning slutförd i tid",
        "training_inactivity": "Utbildningsinaktivitet",
        "training_video_watched": "Utbildningsvideo visad"
      },
      "sentiment": {
        "negative": "Negativ",
        "neutral": "Neutralt",
        "positive": "Positiv"
      },
      "severity": {
        "critical": "Kritisk",
        "high": "Hög",
        "low": "Låg",
        "medium": "Medel",
        "neutral": "Neutralt"
      }
    },
    "simulations": {
      "delivery_method": {
        "email": "E-post",
        "sms": "Textmeddelande"
      },
      "delivery_rate": {
        "high": "Hög",
        "low": "Låg",
        "medium": "Medelhög"
      },
      "failures": {
        "failed_to_deliver": "Leveringsfel",
        "failed_to_send": "Sändningsfel",
        "invalid_receiver": "Mottagarfel",
        "invalid_template": "Mallfel",
        "no_template_available": "Mallfel"
      },
      "preview": {
        "CampaignClick": "{name} klickade på en länk",
        "CampaignReport": "{name} rapporterade simuleringen",
        "CampaignSent": "Simuleringen skickades till {name}",
        "CampaignSubmission": "{name} skickade in ett inloggningsformulär",
        "activity": "Aktivitet",
        "title": "Förhandsvisning"
      },
      "schedule_type": {
        "missing": "Ingen leveransmetod",
        "one_off": "Engångs",
        "recurring": "Återkommande"
      },
      "status": {
        "cancelled": "Avbruten",
        "completed": "Slutförd",
        "draft": "Utkast",
        "paused": "Pausad",
        "running": "Körs",
        "sending": "Skickar"
      },
      "templates": {
        "editor": {
          "sidebar_blocks": {
            "button": "Knapp",
            "columns": "Kolumner",
            "container": "Container",
            "divider": "Avdelare",
            "heading1": "Rubrik 1",
            "heading2": "Rubrik 2",
            "heading3": "Rubrik 3",
            "image": "Bild",
            "spacer": "Mellanrum",
            "text": "Text"
          }
        }
      }
    },
    "statistics": {
      "activities_by_type": {
        "completed_courses": "Avslutade kurser",
        "phishing_quiz_correct_answers": "Korrekt svar på nätfisketestet",
        "phishing_quiz_incorrect_answers": "Felaktiga svar på nätfiskequiz",
        "quiz_answers": "Quizsvar",
        "quiz_correct_answers": "Korrekt quizsvar",
        "quiz_incorrect_answers": "Felaktiga svar på frågesport",
        "simulations_delivered": "Genomförda simuleringar",
        "simulations_failed": "Misslyckade simuleringar",
        "simulations_passed": "Godkända simuleringar",
        "simulations_reported": "Simuleringar rapporterade",
        "text": "Hur dina anställda tränar",
        "threats_reported": "Rapporterade hot",
        "title": "Slutförda aktiviteter",
        "videos_watched": "Videor som tittats på"
      },
      "benchmarks": {
        "above_benchmark_tooltip": "Värdet är över riktmärket.",
        "below_benchmark_tooltip": "Värdet är under riktmärket.",
        "benchmark_tooltip": "Prestandatest"
      },
      "breaches": {
        "critical": "Kritisk",
        "noncritical": "Icke-kritisk"
      },
      "employees": {
        "beginner": "Nybörjare",
        "expert": "Expert",
        "intermediate": "Mellanliggande"
      },
      "onboarding": {
        "not_onboarded": "Inte ombordstigen",
        "onboarded": "Ombordstigen"
      },
      "participant_partition": {
        "active": "Aktiv",
        "completed": "Slutförd",
        "halted": "Stoppad"
      },
      "threats": {
        "status_partition": {
          "forwarded": "Vidarebefordrad",
          "fraudulent": "Bedräglig",
          "legitimate": "Legitim",
          "spam": "Skräppost"
        }
      },
      "time_units": {
        "days": "Dag | Dagar",
        "hours": "Timme | Timmar",
        "minutes": "Minut | Minuter",
        "seconds": "Sekund | Sekunder",
        "weeks": "Vecka | Veckor"
      },
      "training": {
        "quizzing": {
          "correct": "Korrekt",
          "incorrect": "Felaktigt"
        }
      }
    },
    "tables": {
      "columns": {
        "actor": "Aktör",
        "app": "App",
        "automation_status": "Status",
        "available_at": "Tillgänglig",
        "breached_at": "Läckt",
        "click_rate": "@:simulations.click_rate.title",
        "completed": "Slutförd",
        "completed_at": "Slutförd",
        "content_id": "Innehåll",
        "content_type": "Innehållstyp",
        "created_at": "Skapad",
        "data_class": "Dataklass",
        "deadline_at": "Deadline",
        "delivery": "@:simulations.summary.schedule_type",
        "delivery_type": "@:tables.delivery_method",
        "deselect_all": "Avmarkera alla",
        "employee_id": "Medarbetare",
        "employee_status": "Status",
        "event": "Händelse",
        "group_id": "Grupp",
        "key": "Signal",
        "last_learning_interaction": "Senaste interaktion",
        "published_at": "Publicerad",
        "report_rate": "@:simulations.report_rate.title",
        "risk_matrix": "Riskmatris",
        "role": "Roll",
        "sentiment": "Sentiment",
        "severity": "Allvarlighetsgrad",
        "signal_group": "Signalgrupp",
        "submission_rate": "@:simulations.submission_rate.title",
        "test": "@:simulations.summary.test",
        "translations": "Översättningar",
        "type": "Type",
        "zone": "Zon"
      },
      "date_operators": {
        "<": "före",
        "<=": "på eller före",
        "<>": "inte på",
        "=": "på",
        ">": "efter",
        ">=": "på eller efter"
      },
      "enum_values": {
        "access": "Åtkomst",
        "access_revoke": "Åtkomst borttagen",
        "active": "Aktiv",
        "admin": "Administratör",
        "all": "Alla",
        "analyst": "Analytiker",
        "api_token_create": "API-token skapad",
        "api_token_delete": "API-token borttagen",
        "assignment": "Tilldelning",
        "auth_activity": "Autentiseringsaktivitet",
        "authenticate": "Autentisering",
        "authentication_activity": "Autentiseringsaktivitet",
        "authorized_integration": "Auktoriserade integration",
        "breach_config": "Intrångsinställningar uppdaterade",
        "breach_exposure": "Intrångsexponering",
        "breach_found": "Läcka hittad",
        "cancelled": "@:dynamic_keys.simulations.status.cancelled",
        "change": "Ändring",
        "changed_data": "Ändrade data",
        "completed": "@:dynamic_keys.simulations.status.completed",
        "course": "Kurs",
        "course_delete": "Kurs raderad",
        "created_campaign_domain": "Skapade kampändomän",
        "created_integration": "Skapade integration",
        "created_warehouse_token": "Skapade datalager-token",
        "credential_update": "Autentiseringsuppgifter uppdaterade",
        "critical": "Kritisk",
        "critical_phishing_interactions": "Inskickade phishing-inloggningsuppgifter",
        "cybersecurity_culture_initiative_participated": "Deltar i cybersäkerhetsinitiativ",
        "data_change": "Data ändrades",
        "deleted_warehouse_token": "Raderade datalager-token",
        "domain_create": "Domän skapad",
        "draft": "@:dynamic_keys.simulations.status.draft",
        "email": "@:dynamic_keys.simulations.delivery_method.email",
        "email_simulation_clicked": "Klickade på e-postsimulering",
        "email_simulation_credentials_submitted": "Skickade in inloggningsuppgifter i e-postsimulering",
        "email_simulation_delivered": "E-postsimulering levererad",
        "email_simulation_reported": "E-postsimulering rapporterad",
        "email_simulation_reported_without_clicking": "E-postsimulering rapporterad utan att klicka",
        "employee_training_exclude": "Anställd exkluderad från utbildning",
        "employee_training_exclusion_expire": "Den anställdas utbildningsundantag har löpt ut",
        "employee_training_include": "Anställd inkluderad i utbildning",
        "high": "Hög",
        "high-somewhat_likely": "Hög påverkan / Något sannolikt",
        "high-very_likely": "Hög påverkan / Mycket sannolikt",
        "high-very_unlikely": "Hög påverkan / Mycket osannolikt",
        "high_confidence_in_phishing_self_assessment": "Svarade upprepade gånger rätt på phishingquizzer",
        "hub": "Hub",
        "inactive": "Inaktiv",
        "integration_auth": "Integration auktoriserad",
        "integration_config": "Integrationsinställningar uppdaterade",
        "integration_create": "Integration skapad",
        "integration_delete": "Integration raderad",
        "integration_update": "Integration uppdaterad",
        "intel_config": "Human risk intelligence-inställningar uppdaterade",
        "invited_user": "Bjöd in användare",
        "legitimate_email_reported_as_phishing": "Rapporterar legitima e-postmeddelanden som phishing",
        "login": "Loggade in",
        "login_verify": "Verifierad inloggning",
        "logout": "Loggade ut",
        "low": "Låg",
        "low-somewhat_likely": "Låg påverkan / Något sannolikt",
        "low-very_likely": "Låg påverkan / Mycket sannolikt",
        "low-very_unlikely": "Låg påverkan / Mycket osannolikt",
        "low_confidence_in_phishing_self_assessment": "Svarade upprepade gånger fel på phishingquizzer",
        "manage": "Administration",
        "med-somewhat_likely": "Moderat påverkan / Något sannolikt",
        "med-very_likely": "Moderat påverkan / Mycket sannolikt",
        "med-very_unlikely": "Moderat påverkan / Mycket osannolikt",
        "medium": "Moderat",
        "missed_deadline_30_days": "Obligatorisk utbildning 30 dagar försenad",
        "missed_deadline_60_days": "Obligatorisk utbildning 60 dagar försenad",
        "missed_deadline_7_days": "Obligatorisk utbildning 7 dagar försenad",
        "multiple_choice_answered_correctly": "Flervalsfråga besvarad korrekt",
        "multiple_choice_answered_incorrectly": "Flervalsfråga besvarad felaktigt",
        "negative": "Negativa",
        "neutral": "Neutral",
        "notification": "Avisering",
        "notify_admin": "Meddela administratörer",
        "notify_employee": "Meddela anställd",
        "notify_manager": "Meddela chef",
        "one_off": "@:dynamic_keys.simulations.schedule_type.one_off",
        "optional_training_engaged": "Slutförde frivillig utbildning",
        "paused": "Pausad",
        "phishing_interactions": "Phishing-interaktioner",
        "policy": "Policy",
        "positive": "Positiva",
        "privacy_config": "Integritetsinställningar uppdaterade",
        "quiz": "Frågesport",
        "real_phishing_email_opened": "Öppnade verkligt phishingmejl",
        "real_phishing_email_reported": "Rapporterade verkligt phishingmejl",
        "real_phishing_email_targeted": "Utsatt i verkliga phishingmejl",
        "recurring": "@:dynamic_keys.simulations.schedule_type.recurring",
        "register": "Registrering",
        "removed_user_access": "Tog bort användaråtkomst",
        "running": "@:dynamic_keys.simulations.status.running",
        "sending": "@:dynamic_keys.simulations.status.sending",
        "signed_in": "Loggade in",
        "signed_out": "Loggade ut",
        "simulation_config": "Simuleringsinställningar uppdaterade",
        "simulation_non_reporting": "Ej rapporterad simulering",
        "simulation_not_reported_2_days": "Simulering inte rapporterad efter 2 dagar",
        "simulation_not_reported_7_days": "Simulering inte rapporterad efter 7 dagar",
        "sms": "@:dynamic_keys.simulations.delivery_method.sms",
        "sms_simulation_clicked": "Klickade på sms-simulering",
        "sms_simulation_delivered": "Sms-simulering levererad",
        "started": "Startad",
        "support": "Support",
        "switched_workspace": "Bytte arbetsyta",
        "threat_analyst": "Hotanalytiker",
        "threat_config": "Threat management-inställningar uppdaterade",
        "threat_reported": "Hot rapporterat",
        "training_completed": "Tilldelad utbildning slutförd",
        "training_completed_after_deadline": "Slutförande efter deadline",
        "training_completed_on_time": "Tilldelad utbildning slutförd i tid",
        "training_config": "Utbildningsinställningar uppdaterade",
        "training_inactivity": "Utbildningsinaktivitet",
        "training_video_watched": "Utbildningsvideo visad",
        "updated_breach_settings": "Uppdaterade inställningar för läckor",
        "updated_gdpr_settings": "Uppdaterade GDPR-inställningar",
        "updated_human_risk_intelligence_settings": "Uppdaterade human risk intelligence-inställningar",
        "updated_integration": "Uppdaterade integration",
        "updated_integration_settings": "Uppdaterade integrationsinställningar",
        "updated_integration_token": "Uppdaterade integrationstoken",
        "updated_simulation_settings": "Uppdaterade simuleringsinställningar",
        "updated_threat_management_settings": "Uppdaterade inställningar för hothantering",
        "updated_training_settings": "Uppdaterade utbildningsinställningar",
        "updated_workspace_settings": "Uppdaterade arbetsyteinställningar",
        "user_invite": "Användare inbjuden",
        "verified_sign_in": "Verifierad inloggning",
        "video": "Video",
        "video_delete": "Video raderad",
        "viewed_resource": "Visade resurs",
        "workspace_config": "Arbetsyteinställningar uppdaterade",
        "workspace_switch": "Arbetsyta bytt"
      },
      "operators": {
        "<>": "är inte",
        "=": "är"
      }
    },
    "threats": {
      "status": {
        "all": "Alla",
        "forwarded": "Vidarebefordrad",
        "fraudulent": "Bedräglig",
        "legitimate": "Legitim",
        "spam": "Skräppost",
        "unhandled": "Ohanterad"
      }
    },
    "training": {
      "type": {
        "course-type": "Kurs",
        "policy-type": "Policy",
        "quiz-type": "Frågesport",
        "video-type": "Video"
      }
    },
    "types": {
      "boolean": "Boolesk",
      "date": "Datum",
      "number": "Nummer",
      "string": "Sträng"
    },
    "users": {
      "roles": {
        "admin": {
          "text": "Administratörer kan hantera inställningar, bjuda in användare och konfigurera produkter.",
          "title": "Administratör"
        },
        "analyst": {
          "text": "Analytiker kan se och analysera data.",
          "title": "Analytiker"
        },
        "threat_analyst": {
          "text": "Hotanalytiker kan hantera hot och visa/analysera data.",
          "title": "Hotanalytiker"
        }
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "title": "Avancerad",
          "tooltip": "Bli en hackningsexpert på nolltid"
        },
        "ai": {
          "title": "AI och cybersäkerhet",
          "tooltip": "Utforska den komplexa rollen för AI inom cybersäkerhet"
        },
        "compliance": {
          "title": "Certifieringar och regelefterlevnad",
          "tooltip": "Förstå vikten av certifieringar och efterlevnad"
        },
        "gdpr": {
          "title": "GDPR",
          "tooltip": "Lär dig de viktigaste kraven och reglerna i GDPR och hur du kan följa dem i din vardag"
        },
        "hacking": {
          "title": "En hackers liv",
          "tooltip": "Lär känna personerna bakom cyberattacker, världens hackare"
        },
        "money_laundering": {
          "title": "Penningtvätt",
          "tooltip": "Lär dig de olika metoder som kriminella använder för att tvätta pengar och hur man upptäcker och förhindrar penningtvätt"
        },
        "phishing": {
          "title": "Nätfiske",
          "tooltip": "Upptäck aspekterna av den vanligaste cyberattacken i världen"
        },
        "physical_security": {
          "title": "Fysisk säkerhet",
          "tooltip": "Lär dig varför fysisk säkerhet är ett avgörande inslag i god cybersäkerhet"
        },
        "tips_and_tricks": {
          "title": "Tips och tricks",
          "tooltip": "Lär dig hur du kan öka din personliga cybersäkerhet"
        },
        "types_of_hacking": {
          "title": "Typer av hacking",
          "tooltip": "Få insikter i de olika metoder som används av hackare"
        },
        "uploads": {
          "title": "Uppladdningar",
          "tooltip": "Titta på videor uppladdade av din organisation för dina specifika säkerhetsbehov"
        }
      }
    },
    "workspace_onboarding": {
      "kick_off": {
        "validation": {
          "employee_import": "Minst 1 AD-integrering är korrekt konfigurerad",
          "invite_admins": "Bjud in administratörer",
          "reporting_add_in": "Konfigurera rapporterings-tillägget",
          "simulation": "Konfigurera simuleringar",
          "training": "Konfigurera utbildning",
          "verify_domain": "Minst 1 domän är verifierad",
          "whitelisting": "Allowlisting är slutförd"
        }
      }
    }
  },
  "editor": {
    "loading": "Laddar"
  },
  "employees": {
    "active_directory": "Aktivt katalog",
    "add_employees": "Lägg till anställda",
    "anonymous_name": "Anonym",
    "bulk_actions": {
      "activate": "Aktivera användare | Aktivera användare",
      "deactivate": "Inaktivera användare | Inaktivera användare",
      "success": "Statusar uppdaterade",
      "x_of_n_selected": "{x} av {n} valda"
    },
    "current_manager": "Nuvarande chef",
    "deleted_user": "Raderad användare",
    "department": "Avdelning",
    "filter": {
      "status": {
        "active": "Endast aktiva anställda",
        "all": "Alla anställda",
        "inactive": "Endast inaktiva anställda"
      }
    },
    "form": {
      "department": "Avdelning",
      "edit_title": "Inställningar",
      "email": "E-post",
      "first_name": "Förnamn",
      "language": "Språk",
      "last_name": "Efternamn",
      "manager": "Chef",
      "organisational_role": "Roll",
      "placeholder": {
        "manager": "Välj chef",
        "role": "Välj roll",
        "timezone": "Välj tidszon"
      },
      "save_settings": "Spara inställningar",
      "scim_enabled_info": "Du kan inte redigera medarbetarens inställningar eftersom SCIM är aktiverat för den här arbetsytan.",
      "timezone": "Tidszon"
    },
    "manual": "Manual",
    "no_email_found": "Ingen e-post hittades",
    "preview": {
      "close_edit": "Stäng",
      "edit": "Redigera",
      "email": "E-post",
      "groups": "Grupper",
      "locale": "Språk",
      "manager": {
        "active_directory": "Aktiv katalog",
        "button": "Visa profil",
        "email": "E-post",
        "manual": "Handbok",
        "name": "Namn",
        "source": "Källa",
        "subtitle": "Översikt över chefens detaljer",
        "title": "Chef"
      },
      "phone_number": "Telefonnummer",
      "profile": "Visa profil",
      "provider": "Leverantör",
      "provider_id": "Leverantörs-ID",
      "source": "Källa",
      "status": "Status",
      "tags": "Taggar",
      "title": "Förhandsvisning"
    },
    "recent_activity": "Senaste aktivitet",
    "resilience_score": {
      "text": "Nuvarande motståndskraftspoäng baserat på prestationer de senaste 90 dagarna.",
      "title": "Motståndspoäng"
    },
    "search": {
      "button": "Sök",
      "empty": "Sök efter medarbetare...",
      "no_results": "Inga anställda hittades"
    },
    "settings": {
      "settings_saved": "Inställningar sparade",
      "status": {
        "active": {
          "description": "Den här medarbetaren kommer att få simuleringar och träningsövningar",
          "title": "Aktiv"
        },
        "inactive": {
          "description": "Denna anställde kommer INTE att få simuleringar och träningsövningar",
          "title": "Inaktiv"
        }
      }
    },
    "simulations": {
      "click_rate": {
        "title": "Klickfrekvens",
        "tooltip": "Procentandel av simuleringar som har klickats på."
      },
      "email_validated": "E-post validerad: {date}",
      "received": {
        "title": "Simuleringar mottagna",
        "tooltip": "Totalt antal mottagna simuleringar.",
        "unit": "Simuleringar"
      },
      "report_rate": {
        "title": "Rapportfrekvens",
        "tooltip": "Procentandel av rapporterade simuleringar."
      },
      "submission_rate": {
        "title": "Inloggningsfrekvens",
        "tooltip": "Procentandel av inloggningsformulär som skickats in.",
        "x_received": "{count} mottagna"
      }
    },
    "status": "Status",
    "training": {
      "reminder": {
        "reminder_sent": "Påminnelse skickad",
        "subject": "Cybersäkerhetsutbildning",
        "text": "Hotet från hackare ökar och du behöver hålla dig uppdaterad för att skydda dig själv och ditt företag.",
        "title": "Hej!"
      }
    },
    "videos": {
      "title": "Videor",
      "unit": "Videor tittade på"
    }
  },
  "empty": {
    "activity": {
      "title": "Ingen aktivitet"
    },
    "assigned_learning": {
      "description": "Användaren har inte tilldelats någon utbildning.",
      "title": "Inget tilldelat lärande"
    },
    "automations": {
      "button": "Skapa en sekvens",
      "description": "Kom igång genom att skapa en sekvens.",
      "title": "Inga automatiseringar"
    },
    "breaches": {
      "description": "Eventuella överträdelser kopplade till e-postadresser som lagts till i navet kommer att synas här.",
      "title": "Inga överträdelser"
    },
    "custom_uploads": {
      "button": "Skapa video",
      "description": "Kom igång genom att skapa en video",
      "title": "Inga videor hittades"
    },
    "domains": {
      "button": "Lägg till domän",
      "description": "Kom igång genom att lägga till en domän.",
      "title": "Inga domäner"
    },
    "employee_simulations": {
      "button": "Gå till simulationer",
      "description": "Kom igång genom att lägga till en simulering.",
      "title": "Inga simuleringar"
    },
    "employees": {
      "button": "Lägg till medarbetare",
      "description_with_button": "Kom igång genom att lägga till en anställd.",
      "description_without_button": "Inga anställda hittades.",
      "title": "Inga anställda"
    },
    "employees_activity": {
      "description": "Det har inte förekommit någon aktivitet för denna anställd.",
      "title": "Ingen aktivitet"
    },
    "employees_group": {
      "description": "Denna grupp har inga associerade anställda.",
      "title": "Inga anställda"
    },
    "employees_training": {
      "description": "Denna {type} har inte slutförts av några anställda.",
      "title": "Inga deltagare"
    },
    "generic": {
      "description": "Inga poster hittades.",
      "title": "Inga poster"
    },
    "groups": {
      "button": "Skapa grupp",
      "description_with_button": "Kom igång genom att lägga till en grupp.",
      "description_without_button": "Inga grupper hittades.",
      "title": "Inga grupper"
    },
    "imports": {
      "description": "Det finns synkroniseringar för denna integration.",
      "title": "Inga synkroniseringar"
    },
    "participants": {
      "description": "Inga deltagare hittades.",
      "title": "Inga deltagare"
    },
    "policies": {
      "description": "Kom igång genom att skapa en policy.",
      "title": "Inga policys"
    },
    "reports": {
      "description": "Kom igång genom att skapa en ny schemalagd rapport",
      "title": "Inga schemalagda rapporter"
    },
    "scim_connections": {
      "description": "Skapa en anslutning för Microsoft Entra ID eller Okta.",
      "title": "Inga SCIM-anslutningar"
    },
    "scim_tokens": {
      "description": "Inga SCIM-token har skapats för den här arbetsytan.",
      "title": "Inga SCIM-token"
    },
    "simulation_events": {
      "description": "Inga händelser hittades för denna simulering.",
      "title": "Inga händelser"
    },
    "simulations": {
      "description": "Börja genom att lägga till en simulering.",
      "title": "Inga simuleringar"
    },
    "simulations_custom_templates": {
      "description": "Kom igång genom att lägga till en mall.",
      "title": "Inga mallar"
    },
    "simulations_sequence": {
      "button": "Redigera sekvens",
      "description": "Lägg till åtgärder för att bygga automationsflödet",
      "title": "Denna sekvens är tom"
    },
    "threats": {
      "attachments": "Inga bilagor hittades",
      "description": "Kom igång genom att rapportera misstänkta e-postmeddelanden med Moxso e-posttillägget",
      "title": "Inga hot hittades"
    },
    "tokens": {
      "description": "Kom igång genom att skapa en token.",
      "title": "Inga tokens"
    },
    "training": {
      "button": "Rensa filter",
      "description": "Inga utbildningsmaterial som matchar sökningen hittades.",
      "title": "Inga utbildningsmaterial hittades"
    },
    "training_deadlines": {
      "description": "Inga utbildningsdeadlines hittades.",
      "title": "Inga utbildningsdeadliner"
    },
    "user_courses": {
      "description": "Inga kurser har tilldelats ännu.",
      "title": "Inga kurser"
    },
    "users": {
      "description": "Inga användare hittades.",
      "title": "Inga användare"
    }
  },
  "error": {
    "button": "Gå tillbaka hem",
    "text": "Ett okänt fel inträffade, och vi kunde inte slutföra din begäran. Vi är verkligen ledsna för besväret. Försök igen senare.",
    "title": "Något gick fel"
  },
  "forgot_password": {
    "button": "Skicka instruktioner",
    "heading": "Återställ ditt lösenord",
    "instructions": {
      "heading": "E-post skickad",
      "text": "Instruktionerna har skickats till din e-postadress"
    },
    "text": "Ange e-postadressen du använde när du registrerade dig så skickar vi instruktioner för att återställa ditt lösenord."
  },
  "forms": {
    "employee": {
      "add_employees": "Lägg till anställda",
      "buttons": {
        "add": "Lägg till anställd | Lägg till anställda",
        "add_row": "Lägg till rad",
        "send_reminder": "Skicka träningspåminnelse",
        "settings": "Inställningar"
      },
      "delete_row": "Ta bort rad",
      "employee_added": "Anställd tillagd | Anställda tillagda",
      "import": {
        "text": "Importera medarbetare från en CSV-fil.",
        "title": "Importera anställda"
      },
      "labels": {
        "email": "E-post",
        "first_name": "Förnamn",
        "language": "Språk",
        "last_name": "Efternamn",
        "phone_number": "Telefonnummer"
      },
      "manual": {
        "text": "Skapa anställda och deras detaljer manuellt.",
        "title": "Skapa medarbetare manuellt"
      },
      "placeholders": {
        "email": "name{'@'}company.com",
        "first_name": "Förnamn",
        "last_name": "Efternamn",
        "phone_number": "Ange telefonnummer"
      }
    },
    "filters": {
      "all": "Alla anställda",
      "completed": "Slutförd",
      "completed_default": "Alla",
      "incomplete": "Ofullständig",
      "only_active": "Endast aktiva anställda",
      "only_inactive": "Alla inaktiva anställda"
    },
    "group": {
      "adaptive": {
        "text": "Medlemmar registreras automatiskt baserat på regler.",
        "title": "Skapa en adaptiv grupp"
      },
      "add_group": "Lägg till grupp",
      "buttons": {
        "add": "Skapa grupp",
        "back": "Tillbaka",
        "import": "Importera grupper",
        "next": "Nästa steg",
        "save": "Spara inställningar"
      },
      "group_added": "Grupp tillagd",
      "group_updated": "Grupp uppdaterad",
      "import": {
        "text": "Importera grupper från integrationer.",
        "title": "Importera grupper"
      },
      "labels": {
        "groups": "Grupper",
        "import_from_provider": "Importera från leverantör",
        "name": "Namn",
        "provider": "Leverantör",
        "provider_id": "Leverantörsgrupp id"
      },
      "manual": {
        "text": "Medlemmar kommer att läggas till manuellt.",
        "title": "Skapa en manuell grupp"
      },
      "placeholders": {
        "name": "Gruppnamn",
        "provider": "Välj leverantör",
        "provider_id": "ABC-123",
        "search_groups": "Sök grupper"
      },
      "scim_enabled_info": "Du kan inte redigera gruppens inställningar eftersom SCIM är aktiverat för den här arbetsytan."
    },
    "login": {
      "buttons": {
        "reset_password": "Återställ lösenord"
      },
      "labels": {
        "email": "E-post",
        "password": "Lösenord",
        "password_repeat": "Upprepa lösenordet"
      },
      "placeholders": {
        "email": "namn{'@'}company.com"
      }
    },
    "search": "Sök"
  },
  "general": {
    "locked_feature": "Den här funktionen är låst"
  },
  "go_back": "Gå tillbaka",
  "goals": {
    "actions": {
      "delete_are_you_sure": "Är du säker på att du vill avbryta detta mål?",
      "delete_goal": "Avbryt mål",
      "deleted": "Mål avbrutet",
      "edit_goal": "Redigera mål",
      "edit_goal_title": "Redigera mål för {metric}",
      "new_goal": "Nytt mål för {metric}",
      "save_goal": "Spara mål",
      "target_description": "Ange ett målvärde och det datum du vill nå det."
    },
    "chart": {
      "lifetime": "Hela perioden",
      "recent": "Senaste"
    },
    "detail": {
      "achieved": "Uppnått",
      "active_and_scheduled": "Aktiva och schemalagda mål",
      "actual_at_date": "Faktiskt värde vid datumet",
      "in_progress": "Pågår",
      "missed": "Missat",
      "no_past_goals": "Inga tidigare mål ännu",
      "outcome": "Resultat",
      "past_goals": "Tidigare mål",
      "scheduled": "Schemalagd",
      "trajectory": "Utveckling",
      "trajectory_description": "Faktiska framsteg mot varje mål som satts för det här mätvärdet. Punkterna är färgkodade efter utfall — grönt för uppnått, rött för missat, blått för pågående och grått för schemalagt."
    },
    "form": {
      "target": {
        "label": "Mål",
        "placeholder": "Mål"
      },
      "target_date": {
        "label": "Måldatum",
        "placeholder": "Välj måldatum"
      }
    },
    "legend": {
      "actual": "Faktiskt",
      "projected": "Prognostiserad"
    },
    "no_data": "Inga data",
    "overview": {
      "add_goal": "Lägg till mål",
      "current": "nuvarande",
      "description": "Definiera tidsbundna mål för varje mätvärde och skapa en mätbar förbättringskurva.",
      "employees_behind_tooltip": "Medarbetare med minst en tilldelning vars förfallodatum har passerat.",
      "from_now": "från nu",
      "gap_from_previous_target": "Skillnad från föregående mål",
      "next_target": "Nästa mål",
      "no_goal_description": "Det här mätvärdet följs utan mål. Lägg till ett för att mäta framsteg.",
      "no_goals": "Inga aktiva mål angivna",
      "time_elapsed": "Förfluten tid",
      "title": "Mål",
      "view": "Visa"
    }
  },
  "groups": {
    "adaptive_conditions": {
      "boolean_operators": {
        "and": "och",
        "or": "eller"
      },
      "empty": "Inga regler ännu. Lägg till en regel för att definiera vem som tillhör den här gruppen.",
      "preview_count_label": "medarbetare matchar kriterierna",
      "subtitle": "Medlemskap bestäms av regler i stället för att anges manuellt.",
      "title": "Adaptiv grupp"
    },
    "assign_manager": {
      "button": "Tilldela chef",
      "description": "Tilldela en chef till alla gruppmedlemmar på en gång",
      "form": {
        "overwrite_managers": {
          "help": "Om aktiverad, kommer anställda som redan har en chef att tilldelas den valda chefen.",
          "label": "Skriv över befintliga chefer"
        },
        "select_manager": {
          "help": "Välj en chef som ska tilldelas alla medlemmar i denna grupp.",
          "label": "Chef",
          "placeholder": "Välj chef"
        }
      },
      "manager_assigned": "Chef tilldelad till gruppmedlemmar",
      "message": "Manuell uppdatering av medarbetares chefer kommer att stoppa Active Directory-synkroniseringen från att uppdatera dem.",
      "title": "Massutnämning av chef"
    },
    "assign_role": {
      "button": "Tilldela roll",
      "form": {
        "overwrite_roles": {
          "help": "Om aktiverad, kommer anställda som redan har en roll att tilldelas den valda rollen på nytt.",
          "label": "Skriv över befintliga roller"
        },
        "select_role": {
          "help": "Välj en roll som ska tilldelas alla medlemmar i denna grupp.",
          "label": "Roll",
          "placeholder": "Välj roll"
        }
      },
      "role_assigned": "Roll tilldelad till gruppmedlemmar",
      "title": "Tilldela roll i bulk"
    },
    "assign_timezone": {
      "button": "Tilldela tidszon",
      "description": "Tilldela en tidszon till alla gruppmedlemmar på en gång",
      "form": {
        "overwrite_timezones": {
          "help": "Om aktiverad, kommer anställda som redan har en tidszon att tilldelas den valda tidszonen på nytt.",
          "label": "Skriv över befintliga tidszoner"
        },
        "select_timezone": {
          "help": "Välj en tidszon som ska tilldelas alla medlemmar i denna grupp.",
          "label": "Tidszon",
          "placeholder": "Välj tidszon"
        }
      },
      "timezone_assigned": "Tidszon tilldelad till gruppmedlemmar",
      "title": "Tilldela tidszon i bulk"
    },
    "average_resilience_score_text": "Genomsnittlig motståndskraftspoäng för anställda i denna grupp",
    "average_resilience_score_title": "Genomsnittlig resilienspoäng",
    "buttons": {
      "add_rule": "Lägg till regel",
      "assign_manager": "Tilldela chef",
      "assign_role": "Tilldela roll",
      "assign_timezone": "Tilldela tidszon",
      "cancel": "Avbryt",
      "manage_group": "Hantera medlemmar",
      "remove_managers": "Ta bort cheferna",
      "update_group": "Uppdatera medlemmar"
    },
    "delete": {
      "are_you_sure": "Är du säker på att du vill ta bort den här gruppen? Den här åtgärden kan inte ångras.",
      "button": "Ta bort",
      "group_deleted": "Grupp borttagen"
    },
    "manage_members": "Redigera gruppmedlemmar",
    "members_count": "En medlem | {count} medlemmar",
    "membership_rules": "Medlemskapsregler",
    "provider": {
      "error": {
        "back": "Välj en annan leverantör",
        "button": "Konfigurera integration",
        "text": "Grupper kunde inte hämtas",
        "title": "Kunde inte kontakta integrationsleverantören"
      },
      "group_copied": "Leverantörs-ID kopierat till urklipp",
      "heading": "Leverantör",
      "hide_id": "Dölj id",
      "id": "ID",
      "latest_sync": "Senaste synkronisering",
      "never_synced": "Aldrig synkroniserad",
      "provider_id": "Provider-ID",
      "refresh": "Uppdatera data",
      "show_id": "Visa id",
      "sync_started": "Synkronisering tillagd i kö",
      "synced": "Synkroniserad",
      "text": "Data synkroniserad med leverantör"
    },
    "remove_managers": {
      "button": "Ta bort alla chefer",
      "description": "Ta bort chefen från varje medlem i den här gruppen.",
      "managers_removed": "Chefer borttagna från gruppmedlemmar",
      "message": "Du håller på att ta bort chefen från alla medlemmar i den här gruppen. Är du säker på att du vill fortsätta? Den här åtgärden kan inte ångras.",
      "title": "Ta bort alla chefer"
    },
    "risk_level": {
      "calculated": "Ärvd Risknivå",
      "country": "Land",
      "group": "Grupp",
      "organisation": "Organisation",
      "text": "Översikt över risknivåer",
      "title": "Risknivå"
    },
    "search": {
      "empty": {
        "title": "Inga grupper hittades"
      }
    },
    "segment_members": "Gruppsegmentering",
    "segmentation": "Segmentering",
    "segments": {
      "create": "Skapa ett segment",
      "create_success": "Segment skapad",
      "empty": "Inga segment hittades",
      "form": {
        "all": "Alla",
        "any": "Vilken som helst",
        "exclude": "Exkludera medlemmar med följande taggar:",
        "include": "Inkludera medlemmar med följande taggar:",
        "name": "Namn",
        "operator": "Operatör",
        "select": "Välj taggar"
      },
      "heading": "Segment",
      "members_count": "En medlem | {count} medlemmar",
      "text": "Använd segment för att filtrera medlemmar",
      "update": "Uppdatera segment",
      "update_success": "Segmentet uppdaterat"
    },
    "settings": {
      "caution": "Varning",
      "provider_change_warning": "{caution}: Ändring av leverantörsinformationen för denna grupp kommer att utlösa en ny gruppsynkronisering. Var medveten om att anställda som för närvarande är tilldelade till denna grupp kan tas bort om de inte ingår i den uppdaterade Active Directory-gruppen. Var försiktig för att förhindra oavsiktliga ändringar.",
      "subtitle": "Konfigurera dina gruppinställningar.",
      "title": "Gruppinställningar"
    },
    "sync_failed": {
      "button": "Inställningar",
      "recommended_action": "Rekommenderad åtgärd",
      "title": "Synkronisering misslyckades",
      "tooltip": "Synkroniseringen av denna grupp har misslyckats."
    },
    "tags": {
      "create": "Skapa en tagg",
      "create_success": "Tagg skapad",
      "delete_success": "Taggen har tagits bort",
      "empty": "Inga taggar hittades",
      "heading": "Taggar",
      "text": "Använd taggar för att gruppera medlemmar"
    }
  },
  "human_risk_intelligence": {
    "assignment": {
      "associated_risk_categories": "Tillhörande riskkategorier",
      "available": "Tillgänglig",
      "completed": "Slutförd",
      "contextual_risk_factors": "Kontextuella riskfaktorer",
      "deadline": "Deadline",
      "details": "Detaljer",
      "details_title": "Tilldelningsdetaljer",
      "osint": "OSINT",
      "osint_sources_summary": {
        "label": "Analyserade källor: {count}",
        "results_count": "{count} resultat | {count} resultat"
      },
      "passed": "Godkänd",
      "rules": "Regler",
      "signals": "Signaler",
      "signals_description": "Signaler som utlöste denna tilldelning",
      "strategy": "Strategi",
      "title": "Tilldelning"
    },
    "common": {
      "powered_by": "Drivs av {risk_framework}"
    },
    "content_preview": {
      "title": "Förhandsvisning av innehåll"
    },
    "dashboard_card": {
      "assignments_90_days": "Tilldelningar",
      "enable_button": "Aktivera mänsklig riskintelligens",
      "interventions_90_days": "Interventioner",
      "score_90_days": "Poäng",
      "signals_90_days": "Signaler",
      "title": "Mänsklig riskintelligens"
    },
    "dashboard_signal_collection": {
      "average_day": "Genomsnittsdag",
      "avg_daily": "Snitt per dag",
      "last_90_days": "Senaste 90 dagarna",
      "less": "Mindre",
      "lowest_day": "Lägsta dag",
      "more": "Mer",
      "negative": "Negativa",
      "negative_count": "Negativa: {count}",
      "no_signals_in_range": "Inga signaler i det här intervallet",
      "peak_day": "Toppdag",
      "positive": "Positiva",
      "positive_count": "Positiva: {count}",
      "signal_count": "1 signal | {count} signaler",
      "signal_count_on_date": "{count} den {date}",
      "signal_range": "{min}-{max} signaler",
      "signals_on_date": "Signaler den {date}",
      "title": "Signalinsamling",
      "total_signals": "totala signaler"
    },
    "employee_preview": {
      "access_level": "Åtkomstnivå",
      "info": "Info",
      "organizational_role": "Organisatorisk roll",
      "resilience_score": "Resilienspoäng",
      "responsibility_tier": "Ansvarsnivå",
      "role": "Roll",
      "title": "Medarbetare"
    },
    "filters": {
      "back": "Tillbaka",
      "data": "Filtrera data",
      "filter_by": "Filtrera efter",
      "search": "Sök",
      "select_date": "Välj datum"
    },
    "group_breakdown": {
      "columns": {
        "assignments": "Tilldelningar",
        "avg_score": "Snittpoäng",
        "employees": "Medarbetare",
        "group": "Grupp",
        "interventions": "Interventioner",
        "signals": "Signaler"
      },
      "description": "Aggregerade signaler, tilldelningar och interventioner per grupp",
      "signals_slideover": {
        "activity_links_title": "Aktivitet",
        "links_title": "Signaler",
        "member_count": "{count} medlemmar",
        "title": "Signalfördelning",
        "view_assignments": "Visa tilldelningar",
        "view_interventions": "Visa interventioner",
        "view_signals": "Visa {sentiment} signaler"
      },
      "title": "Gruppfördelning"
    },
    "intervention": {
      "details_title": "Intervention",
      "preview_body": "I produktion innehåller detta mejl beteendebaserad kontext och vägledning för nästa steg.",
      "preview_cta": "Gå igenom din säkerhetsaktivitet och slutför eventuell uppföljande utbildning.",
      "preview_from_name": "Moxso säkerhetsteam",
      "preview_greeting": "Hej {name},",
      "preview_intro": "Detta är en exempelvisning av en interventionsavisering.",
      "preview_subject": "Säkerhetsavisering",
      "sent_at": "Skickad",
      "signals_description": "Signaler som utlöste denna intervention",
      "title": "Intervention"
    },
    "navigation": {
      "assignments": "Tilldelningar",
      "interventions": "Interventioner",
      "osint": "OSINT",
      "overview": "Översikt",
      "risk_framework": "Riskramverk",
      "signals": "Signaler"
    },
    "notification_title": "Avisering",
    "notification_type": "Aviseringstyp",
    "onboarding": {
      "common": {
        "back": "Tillbaka",
        "cancel": "Avbryt",
        "next": "Nästa"
      },
      "glance": {
        "assignment_limits": "Upp till {max} lektioner per anställd, med minst {cooldown} dagar mellan tilldelningar",
        "eligibility": "Anställda är berättigade att få utbildning {min_days} dagar efter start.",
        "lesson_selection": "Lektioner tilldelas automatiskt: {selection}",
        "notifications_disabled": "Aviseringar inaktiverade",
        "notifications_enabled": "Aviseringar aktiverade med frekvensen {frequency}. {behavior}"
      },
      "interventions": {
        "heading": "Beteendebaserade interventioner",
        "subheading": "Definiera vilka beteendesignaler som utlöser en omedelbar åtgärd utanför den ordinarie takten: en korrigerande utbildningstilldelning, ett meddelande till medarbetarens chef eller en avisering till era säkerhetsadministratörer."
      },
      "intro": {
        "benefits": {
          "better_outcomes": {
            "description": "Fokusera resurser där de gör störst nytta",
            "title": "Bättre resultat"
          },
          "continuous_adaptation": {
            "description": "Systemet lär sig och anpassar sig baserat på löpande beteende",
            "title": "Kontinuerlig anpassning"
          },
          "personalized_experience": {
            "description": "Varje anställd får utbildning anpassad efter sina behov",
            "title": "Personlig upplevelse"
          }
        },
        "description": "Human Risk Intelligence omvandlar beteendesignaler till individuella riskprofiler och tilldelar sedan den utbildning och de simuleringar som varje anställd faktiskt behöver. Innehållet kalibreras efter var varje person befinner sig i Moxso Risk Framework och kalibreras om när nya signaler kommer in. Risken minskar utan att utbildningsvolymen ökar.",
        "heading": "Vad är Human Risk Intelligence?",
        "setup_button": "Konfigurera Human Risk Intelligence",
        "subheading": "Utbilda varje anställd i de risker som faktiskt gäller dem och sluta utbilda dem i sådant som inte gör det."
      },
      "review": {
        "at_a_glance": "I korthet",
        "enable_button": "Aktivera Human Risk Intelligence",
        "heading": "Redo att aktivera",
        "next": {
          "heading": "Vad händer härnäst",
          "items": {
            "analysis_starts_immediately": "Moxso börjar omedelbart samla in beteendesignaler i hela organisationen.",
            "no_lessons_assigned_immediately_prefix": "Utbildning levereras efter 24 timmar.",
            "no_lessons_assigned_immediately_suffix": "Då har systemet lärt sig tillräckligt för att bygga en tillförlitlig riskprofil för varje anställd.",
            "settings_can_be_changed_anytime": "Dessa inställningar kan ändras, eller Human Risk Intelligence inaktiveras, när som helst."
          }
        },
        "settings_link": "Behöver du mer kontroll? Anpassa avancerade inställningar",
        "subheading": "Det här händer när du aktiverar Human Risk Intelligence."
      },
      "selection": {
        "heading": "Utbildningsstrategi",
        "subheading": "Välj hur Moxso prioriterar och tilldelar kontinuerlig utbildning i hela organisationen."
      },
      "signals": {
        "heading": "Signaler",
        "subheading": "Konfigurera hur signaler påverkar beslut i mänsklig riskintelligens"
      },
      "steps": {
        "interventions": "Interventioner",
        "introduction": "Introduktion",
        "review": "Granska och aktivera",
        "training_strategy": "Utbildningsstrategi"
      }
    },
    "osint_explanation": {
      "description": "Moxso OSINT-motorn övervakar kontinuerligt det globala hotlandskapet och omvandlar offentlig cybersäkerhetsintelligens till handlingsbar insikt om mänsklig risk.",
      "title": "Moxso OSINT-motorn (Open-Source Intelligence)"
    },
    "osint_news": {
      "empty": {
        "description": "Ingen OSINT-data hittades för denna risk",
        "heading": "OSINT-data otillgängliga"
      },
      "title": "Hotinformationsflöde"
    },
    "pages": {
      "assignments": {
        "heading": "Adaptiva tilldelningar",
        "subheading": "Visa och hantera tilldelningar i mänsklig riskintelligens."
      },
      "interventions": {
        "heading": "Interventioner",
        "subheading": "Interventioner som utlöses av medarbetares beteende i säkerhetsaktiviteter."
      },
      "osint": {
        "article": {
          "associated_risk_indicators": "Associerade riskindikatorer",
          "hide": "Dölj",
          "indicator_count": "{count} indikator | {count} indikatorer",
          "neutral_count": "{count} neutral | {count} neutrala",
          "risky_count": "{count} riskfylld | {count} riskfyllda",
          "show": "Visa",
          "vigilant_count": "{count} vaksam | {count} vaksamma"
        },
        "breaches": "Läckor",
        "current": "Nuvarande",
        "heading": "Hotinformationsflöde",
        "indicators": {
          "description": "Topp under de senaste 24 timmarna",
          "empty": {
            "description": "Indikatoraktivitet visas här när flödet har taggade risker.",
            "heading": "Inga indikatorer ännu"
          },
          "title": "Riskindikatorer"
        },
        "negative_neutral": "Uppmärksamhet krävs: Signalaktiviteten försämras",
        "negative_risky": "Varning: Hotaktiviteten ökar",
        "negative_vigilant": "Uppmärksamhet krävs: Säkerhetsåtgärderna försämras",
        "news": {
          "description": "Senaste 24 timmarna",
          "title": "Nyheter"
        },
        "no_change": "Ingen förändring i signalaktiviteten",
        "positive_neutral": "Positiv trend: Signalaktiviteten förbättras",
        "positive_risky": "Positiv trend: Hotaktiviteten minskar",
        "positive_vigilant": "Positiv trend: Säkerhetsläget förbättras",
        "previous": "Föregående",
        "risk_themes": "Riskteman",
        "signal_change": "Signalförändring",
        "sources": {
          "description": "Aktiva källor under de senaste 24 timmarna",
          "empty": {
            "description": "Källaktivitet visas här när flödet har artiklar.",
            "heading": "Inga källor ännu"
          },
          "title": "Källor"
        },
        "subheading": "Följ externa signaler som är kopplade till dina övervakade riskteman."
      },
      "overview": {
        "subheading": "Översikt över aktivitet och insikter i mänsklig riskintelligens."
      },
      "risk_framework": {
        "heading": "Riskramverk",
        "subheading": "Moxso-ramverket för att bedöma och hantera mänsklig säkerhetsrisk."
      },
      "signals": {
        "heading": "Beteendesignaler",
        "subheading": "Visa alla signaler som samlats in från anställdas beteende."
      }
    },
    "risk_category": {
      "change": "Förändring",
      "consequences": "Konsekvenser",
      "details_title": "Detaljer om riskkategori",
      "importance": "Betydelse",
      "indicators": "Indikatorer",
      "overview_title": "Översikt över riskkategori",
      "relevance": "Relevans",
      "tabs": {
        "details": "Detaljer",
        "indicators": "Indikatorer"
      }
    },
    "risk_framework": {
      "change_tooltip": "Förändring de senaste 90 dagarna",
      "description_1": "Moxso Risk Framework är en datadriven modell för att identifiera, kvantifiera och operationalisera mänsklig cyberrisk i moderna företag.",
      "description_2": "I linje med branschstandarder som MITRE ATT&CK och NIST Cybersecurity Framework utökar det traditionella kontrollbaserade modeller genom att särskilt fokusera på mänskligt beteende som en angreppsvektor. Ramverket omvandlar verkliga beteendedata, signaler om hotexponering och strukturella riskfaktorer till mätbara och granskningsbara riskindikatorer.",
      "description_3": "Ramverket är organiserat över och strukturerat i 16 människocentrerade riskkategorier (R.01-R.16) och ger konsekvent poängsättning, handlingsbara insikter och efterlevnadsanpassad rapportering.",
      "references": "Ramverksreferenser",
      "short_description": "Moxso Risk Framework är en datadriven modell för att identifiera, kvantifiera och operationalisera mänsklig cyberrisk i moderna företag.",
      "title": "Riskramverk"
    },
    "risk_matrix": {
      "axes": {
        "impact": "Påverkan",
        "likelihood": "Sannolikhet"
      },
      "legend": {
        "high": "Hög",
        "low": "Låg",
        "med": "Medel"
      },
      "title": "Signalriskmatris",
      "tooltip": {
        "change": "Förändring",
        "current": "Nuvarande",
        "high": "Högrisksignaler",
        "low": "Lågrisksignaler",
        "medium": "Mellanrisksignaler",
        "previous": "Föregående"
      }
    },
    "sections": {
      "recent_assignments": "Senaste tilldelningar",
      "recent_interventions": "Senaste interventionerna",
      "recent_signals": "Senaste signaler"
    },
    "settings": {
      "common": {
        "days": "{days} dagar",
        "disabled": "Inaktiverad",
        "enabled": "Aktiverad",
        "every_days": "Var {days}:e dag",
        "no": "Nej",
        "none": "Ingen",
        "yes": "Ja"
      },
      "eligibility": {
        "criteria_title": "Behörighetskriterier",
        "description": "Definiera vem som är behörig för mänsklig riskintelligens",
        "excluded_groups": "Exkluderade grupper",
        "excluded_groups_help": "Exkludera specifika grupper från automatiserade utbildningsflöden",
        "excluded_roles": "Exkluderade roller",
        "excluded_roles_help": "Exkludera specifika organisatoriska roller från automatiserade utbildningsflöden",
        "minimum_employment_duration_help": "Anställda måste ha varit anställda minst så här många dagar för att vara behöriga",
        "minimum_employment_duration_label": "Minsta anställningstid (dagar)",
        "targeting_title": "Inriktning",
        "title": "Behörighet"
      },
      "interventions": {
        "actions": {
          "add_action": "Lägg till åtgärd",
          "assign_new_lesson": "Tilldela ny lektion",
          "assignment_description": "Tilldela korrigerande utbildning till den berörda medarbetaren.",
          "empty": "Inga åtgärder ännu. Lägg till en för att definiera vad som ska hända när den här gruppen utlöses.",
          "heading": "Åtgärder när det utlöses",
          "notify_admin": "Meddela administratörer",
          "notify_admin_description": "Skicka e-post till en behörig Moxso-administratör för arbetsytan.",
          "notify_employee": "Meddela anställd",
          "notify_employee_description": "Skicka e-post till den berörda medarbetaren om det upptäckta beteendet.",
          "notify_manager": "Meddela chef",
          "notify_manager_description": "Skicka e-post till medarbetarens aktiva chef.",
          "remove_action": "Ta bort {action}"
        },
        "enable_subtitle": "Låt mänsklig riskintelligens bryta normala tilldelningsregler när hög-riskbeteende upptäcks och eskalera till chefer och säkerhetsadministratörer.",
        "enable_title": "Aktivera interventioner",
        "excluded_groups": "Exkluderade grupper",
        "excluded_groups_help": "Anställda i dessa grupper riktas aldrig av interventionsöverskrivningar.",
        "excluded_roles": "Exkluderade roller",
        "excluded_roles_description": "Anställda i dessa roller riktas aldrig av interventionsöverskrivningar.",
        "groups_description": "Välj vilka signalgrupper som ska övervakas och konfigurera responsen för varje grupp.",
        "groups_title": "Interventionssignalgrupper",
        "severity_label": "Förseningsgrad",
        "threshold_label": "Aktiveringströskel",
        "threshold_occurrences": "{count} händelse | {count} händelser",
        "timeframe_days": "Var {days}:e dag",
        "timeframe_label": "Tidsperiod",
        "timeframe_within_90_days": "Inom 90 dagar",
        "triggers": {
          "breach_exposure": {
            "description": "Tillåt omedelbar tilldelning när en anställd förekommer i ett känt intrång.",
            "title": "Intrångsexponering"
          },
          "phishing_failures": {
            "description": "Tillåt omedelbar tilldelning efter att anställda misslyckas med en simulering.",
            "title": "Misslyckade phishing-simuleringar"
          },
          "training_non_compliance": {
            "description": "Tillåt omedelbar tilldelning när obligatorisk utbildning är försenad.",
            "title": "Bristande utbildningsefterlevnad"
          }
        },
        "triggers_description": "Välj vilka händelser som kan utlösa omedelbar utbildning och eskalering till chefer eller säkerhetsadministratörer, även om en anställd nyligen fått annan utbildning.",
        "triggers_title": "Intervention utlösare"
      },
      "notifications": {
        "continuous_sending_subtitle": "Skicka påminnelseaviseringar tills utbildningen är slutförd",
        "continuous_sending_title": "Kontinuerlig skickning",
        "enable_subtitle": "Skicka e-postaviseringar för nya tilldelningar",
        "enable_title": "Aktivera aviseringar",
        "frequency": {
          "intense": "Intens",
          "loose": "Lätt",
          "normal": "Normal (Per tilldelning)",
          "per_assignment": "Per tilldelning"
        },
        "frequency_label": "Aviseringsfrekvens",
        "title": "Aviseringar"
      },
      "review": {
        "enable_subtitle": "Starta personliga utbildningstilldelningar baserat på anställdas beteende",
        "enable_title": "Aktivera mänsklig riskintelligens",
        "frequency": "Frekvens",
        "max_assignments_per_run": "Max tilldelningar per körning: {value}",
        "notifications": "Aviseringar",
        "reminders_until_completion": "Påminnelser tills slutförd",
        "save_settings": "Spara inställningar",
        "selection": "Urval",
        "title": "Granska och aktivera"
      },
      "selection_strategy": {
        "avoid_repetition_help": "Återtilldela inte samma lektion under denna period.",
        "avoid_repetition_label": "Undvik att upprepa samma utbildning (dagar)",
        "cooldown_help": "Vänta innan ny Human Risk Intelligence tilldelas efter utbildning.",
        "cooldown_label": "Karensperiod (dagar)",
        "enable_subtitle": "Låt Human Risk Intelligence tilldela kontinuerlig utbildning baserat på anställdas riskprofiler.",
        "enable_title": "Aktivera Human Risk Intelligence",
        "excluded_videos": "Exkluderade videor",
        "excluded_videos_description": "Dessa videor tilldelas aldrig av Human Risk Intelligence.",
        "excluded_videos_placeholder": "Välj videor",
        "frameworks_help": "Välj ett eller flera ramverk för att prioritera utbildning som är kopplad till dina efterlevnadsmål.",
        "frameworks_label": "Ramverk",
        "frameworks_placeholder": "Välj ramverk",
        "hide_advanced_settings": "Dölj avancerade inställningar",
        "interval_help": "Minsta antal dagar mellan slutförda utbildningar och nya tilldelningar.",
        "interval_label": "Intervall (dagar)",
        "label": "Urvalsstrategi",
        "max_assignments_per_run_help": "Max antal nya utbildningar per anställd i en utvärdering.",
        "max_assignments_per_run_label": "Max tilldelningar per körning",
        "show_advanced_settings": "Visa avancerade inställningar"
      },
      "signals": {
        "failed_simulation": "Misslyckad simulering",
        "failed_simulation_help": "Vikt som tillämpas när en anställd klickar på en phishing-simulering",
        "low_score": "Låg poäng",
        "low_score_help": "Vikt som tillämpas när utbildningsquizresultat ligger under tröskeln"
      },
      "summary_eligibility": {
        "description": "Avgör vem som är behörig för mänsklig riskintelligens",
        "excluded_roles": "Exkluderade roller",
        "minimum_employment_duration": "Minsta anställningstid",
        "title": "Behörighet"
      },
      "summary_selection": {
        "description": "Avgör hur lektioner väljs och hur anställda meddelas",
        "email_notifications": "E-post aviseringar",
        "lesson_selection": "Lektionsurval",
        "maximum_lessons_per_employee": "Max antal lektioner per anställd",
        "minimum_time_between_lessons": "Minsta tid mellan lektioner",
        "notification_settings": "Aviseringsinställningar",
        "notification_style": "Aviseringsstil",
        "prioritize_mandatory_training": "Prioritera obligatorisk utbildning",
        "selection_approach": "Urvalsmetod",
        "send_reminders_until_complete": "Skicka påminnelser tills slutförd",
        "standard_training_interval": "Standard utbildning intervall",
        "title": "Urval och aviseringar"
      },
      "summary_signals": {
        "description": "Avgör hur signaler påverkar beslut i mänsklig riskintelligens",
        "impact": {
          "high": "Hög påverkan",
          "low": "Låg påverkan",
          "medium": "Medel påverkan"
        },
        "signal_labels": {
          "failed_simulation": "Misslyckad phishing-simulering",
          "low_score": "Låg utbildningspoäng"
        },
        "title": "Signaler"
      }
    },
    "signal": {
      "associated_risk_categories": "Associerade riskkategorier",
      "behaviour": "Beteende",
      "category": "Kategori",
      "indicator": "Indikator",
      "intel": "Underrättelse",
      "no": "Nej",
      "polarity": "Polaritet",
      "sentiment": "Känsla",
      "title": "Risksignal",
      "value": "Värde",
      "yes": "Ja"
    },
    "signal_preview": {
      "breach": {
        "title": "Dark web-övervakning"
      },
      "multiple_choice_quiz_answer": {
        "answer": "Svar",
        "question": "Fråga",
        "title": "Quizsvar"
      },
      "phishing_quiz_answer": {
        "correct": "Korrekt",
        "incorrect": "Fel",
        "question": "Fråga",
        "result": "Resultat",
        "subject": "Ämne",
        "time": "Tid",
        "title": "Svar på phishingquiz"
      }
    },
    "stats": {
      "assignments": "Tilldelningar",
      "completed_assignments": "Slutförda tilldelningar",
      "interventions": "Interventioner",
      "negative_signals": "Negativa signaler",
      "positive_signals": "Positiva signaler",
      "risk_level": {
        "country_risk": "Landsrisk",
        "industry_risk": "Branschrisk",
        "levels": {
          "high": "Hög",
          "loading": "Laddar",
          "low": "Låg",
          "medium": "Moderat"
        },
        "title": "Risknivå"
      },
      "signals": "Signaler"
    },
    "tables": {
      "negative": "Negativ",
      "neutral": "Neutralt",
      "sentiment": "Känsla",
      "severity": "Allvarlighetsgrad",
      "signal_count": "1 signal | {count} signaler",
      "signal_type": "Risksignal"
    },
    "title": "Human Risk Intelligence",
    "tooltips": {
      "compared_to_prior_period": "Jämfört med föregående period av samma längd.",
      "previous_value": "Föregående värde"
    },
    "trending_risk_indicators": "Trendande riskindikatorer"
  },
  "image_library": {
    "empty_button": "Ladda upp bild",
    "empty_description": "Ladda upp din första bild för att börja bygga ett återanvändbart bibliotek.",
    "empty_title": "Inga bilder ännu",
    "image_format": "JPG/JPEG/PNG · Upp till 1MB",
    "image_uploaded": "Bilden har laddats upp",
    "insert_button": "Infoga bild",
    "library_tab": "Bildbibliotek",
    "refresh": "Uppdatera",
    "show_more": "Visa mer",
    "title": "Infoga bild",
    "upload_tab": "Ladda upp",
    "upload_title": "Ladda upp en ny bild"
  },
  "locale": {
    "current": "Svenska",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "french": "Français",
    "norwegian": "Norwegian",
    "polish": "Polski",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "back_to_login": "Tillbaka till inloggning",
    "button": "Logga in",
    "change_email": "Ändra e-post?",
    "continue": "Fortsätt",
    "forgot_password": {
      "link": "Återställ det nu",
      "text": "Glömt lösenord?"
    },
    "heading": "Välkommen tillbaka",
    "loading": "Läser in",
    "preparing_session": "Förbereder session",
    "sso": {
      "provider_found": "SSO är tillgängligt för {provider}. Fortsätt för att logga in via din identitetsleverantör.",
      "redirecting": "Omdirigerar till SSO",
      "redirecting_text": "Vi förbereder din inloggningsbegäran.",
      "validating": "Validerar SSO",
      "validating_text": "Vi slutför din inloggning."
    },
    "text": "Logga in på din arbetsyta"
  },
  "manager_report": {
    "assignment": "Uppgift",
    "assignments": "Uppgifter",
    "company_average": "Företagsgenomsnitt",
    "compared_against": "Jämfört med {period}",
    "completed": "Slutförd",
    "date": "Datum",
    "days_overdue": "Dagar försenad",
    "deadline": "Deadline",
    "deadlines_description": "{count} uppgifter passerade sin deadline under {period}.",
    "department": "Avdelning",
    "employee": "Medarbetare",
    "employees_affected": "Berörda medarbetare",
    "employees_at_risk": "Medarbetare i riskzonen",
    "gap_to_company": "Skillnad mot företaget",
    "generated": "Genererad {date}",
    "human_risk_intelligence": "Human Risk Intelligence",
    "individual_reports": "Individuella utbildnings- och riskrapporter · {count} medarbetare | Individuell utbildnings- och riskrapport · {count} medarbetare | Individuella utbildnings- och riskrapporter · {count} medarbetare",
    "interventions": "Senaste åtgärder utlösta av Moxso",
    "loading": "Läser in chefsrapport…",
    "missed_deadlines": "Missade deadlines",
    "missed_team_deadlines": "Teamets missade deadlines",
    "most_dangerous_signals": "Periodens 3 farligaste signaler",
    "no_assignments": "Inga uppgifter",
    "no_dangerous_signals": "Inga farliga signaler",
    "no_employees_at_risk": "Inga medarbetare i riskzonen",
    "no_interventions": "Inga åtgärder utlöstes",
    "no_missed_deadlines": "Inga missade deadlines",
    "no_recent_signals": "Inga senaste signaler",
    "no_sentiment_data": "Ingen sentimentdata",
    "no_severity_data": "Ingen data om allvarlighetsgrad",
    "oldest_deadline": "Äldsta deadline",
    "overdue_assignments": "Försenade uppgifter",
    "period_over_period": "Jämfört med föregående period",
    "points": "{points} poäng",
    "recent_signals": "Senaste signalerna",
    "risk_indicator": "Riskindikator",
    "score": "Poäng",
    "sentiment": "Sentiment",
    "severity": "Allvarlighetsgrad",
    "signal": "Signal",
    "signals": "Signaler",
    "signals_by_sentiment": "Signaler efter sentiment",
    "signals_by_severity": "Signaler efter allvarlighetsgrad",
    "sorted_by_deadline": "Sorterad efter deadline",
    "status": "Status",
    "summary": "Sammanfattning",
    "team_average": "Teamgenomsnitt",
    "threshold": "Gräns {value}% · lägsta först",
    "title": "Chefsrapport",
    "total": "{count} totalt",
    "training_report": "Utbildningsrapport",
    "trend_title": "Motståndskraft, klick- och rapporteringsfrekvens",
    "type": "Typ",
    "unavailable": "Rapporten är inte tillgänglig",
    "unavailable_description": "Rapporten kunde inte läsas in. Kontrollera att rapportlänken är giltig och inte har gått ut."
  },
  "navigation": {
    "assigned_learning": "Tilldelad inlärning",
    "at_risk": "Anställda i riskzonen",
    "audit": {
      "index": "Revision",
      "settings": "Inställningar"
    },
    "automation": {
      "flow_builder": "Sekvensbyggare",
      "index": "Automation",
      "sequence": "Sekvens",
      "settings": "Inställningar"
    },
    "breaches": "Överträdelser",
    "configuration": "Konfiguration",
    "custom_upload": {
      "edit": "Redigera",
      "quiz": "Frågesport"
    },
    "dashboard": "Analys",
    "employees": "Anställda",
    "goals": "Mål",
    "groups": {
      "index": "Grupper",
      "settings": "Inställningar",
      "single": "Grupp"
    },
    "human_risk_intelligence": "Mänsklig riskintelligens",
    "integration": {
      "activity": "Aktivitet",
      "settings": "Inställningar"
    },
    "integrations": "Integrationer",
    "knowledge_base": "Kunskapsbas",
    "lessons_courses": "Kurser",
    "lessons_deadlines": "Sista datum",
    "lessons_videos": "Videor",
    "no_workspaces": "Inga arbetsytor hittades",
    "overview": "Översikt",
    "policies": "Policyer",
    "policy": {
      "edit": "Redigera",
      "quiz": "Frågesport"
    },
    "resilience": "Motståndskraft",
    "search_workspaces": "Sök arbetsytor",
    "settings": {
      "administration": "Administration",
      "admins": "Administratörer",
      "apis_and_data": "API:er och data",
      "audit_logs": "Granskningsloggar",
      "authentication": "Autentisering",
      "back_to_app": "Tillbaka till appen",
      "breaches": "Överträdelser",
      "close_navigation": "Stäng navigering",
      "compliance": "Efterlevnad",
      "domains": "Domäner",
      "e_learning": "Utbildning",
      "export": "Exportera",
      "exports": "Exporter",
      "goals": "Mål",
      "human_risk_intelligence": "Mänsklig riskintelligens",
      "import": "Importera",
      "index": "Inställningar",
      "interventions": "Insatser",
      "personal": "Personligt",
      "reporting": "Rapportering",
      "risk": "Risken",
      "simulations": "Simulationer",
      "threats": "Hot",
      "workspace": "Arbetsyta"
    },
    "sign_out": "Logga ut",
    "simulations": {
      "custom_templates": "Anpassade mallar",
      "index": "Simuleringar",
      "scheduled": "Schemalagd",
      "single": "Aktivitet",
      "single_settings": "Inställningar"
    },
    "team": "Anställda",
    "threats": "Hot",
    "training": "E-lärande",
    "user_settings": "Säkerhet och åtkomst",
    "your_workspaces": "Dina arbetsytor"
  },
  "oauth": {
    "back_to_home": "Tillbaka till startsidan",
    "error": "Integrationen kunde inte konfigureras",
    "login": "Logga in",
    "success": "Leverantören sparades framgångsrikt"
  },
  "onboarding": {
    "building_training_paths": "Bygga träningsvägar",
    "calculating_risk_score": "Beräknar riskscore",
    "choose_provider": "Välj din identitetsleverantör",
    "continue_button": "Fortsätt",
    "exit": "Stäng",
    "gmail_integration": "Gmail-integration",
    "google_manual_setup": {
      "access_google_admin_console_heading": "Öppna Google administratörskonsol",
      "access_google_admin_console_text": "Logga in på administratörskonsolen för Google Workspace: {google_admin_console_link}",
      "allow_moxso_ip_addresses_bullet_1": "Expandera avsnittet {email_allowlist}.",
      "allow_moxso_ip_addresses_bullet_2": "Ange följande Moxso IP-adresser: {ip_1} {ip_2}",
      "allow_moxso_ip_addresses_bullet_3": "Klicka på {save_button}.",
      "allow_moxso_ip_addresses_heading": "Tillåt Moxso IP-adresser",
      "configure_inbound_gateway_bullet_1": "Expandera avsnittet {inbound_gateway}.",
      "configure_inbound_gateway_bullet_2": "Aktivera gateway genom att växla reglaget.",
      "configure_inbound_gateway_bullet_3": "Ange följande Moxso IP-adresser under {gateway_ips}: {ip_1} {ip_2}",
      "configure_inbound_gateway_bullet_4": "Aktivera {require_tls}.",
      "configure_inbound_gateway_bullet_5": "I avsnittet {message_tagging_section} aktiverar du {message_spam_eval_header}.",
      "configure_inbound_gateway_bullet_6": "Ange följande värde i fältet {regexp_field}: {uuid}",
      "configure_inbound_gateway_bullet_7": "Aktivera {disable_gmail_spam_eval}.",
      "configure_inbound_gateway_bullet_8": "Klicka på {save_button} för att tillämpa inställningarna.",
      "configure_inbound_gateway_heading": "Konfigurera inkommande gateway",
      "configure_spam_rule_bullet_1": "Gå till {spam_settings}: I samma meny {menu_path}, hitta avsnittet Spam.",
      "configure_spam_rule_bullet_2": "Lägg till en ny regel: Klicka på {add_rule} (eller redigera en befintlig Moxso-regel) och ge den ett namn som {rule_name}.",
      "configure_spam_rule_bullet_3": "Konfigurera kringgåendet: Välj {bypass_option}",
      "configure_spam_rule_bullet_4": "Dölj varningar (kritiskt): Se till att du markerar {hide_warnings_option}",
      "configure_spam_rule_bullet_5": "Se till att simuleringsdomänerna läggs till i adresslistan för den här regeln genom att ladda ner CSV-filen:",
      "configure_spam_rule_bullet_6": "Spara regeln.",
      "configure_spam_rule_heading": "Konfigurera spamregel (kringgå varningar)",
      "disable_gmail_spam_eval": "Inaktivera Gmails spamutvärdering för e-post från denna gateway; använd endast headervärdet.",
      "email_allowlist": "E-posttillåtelselista",
      "gateway_ips": "Gateway-IP-adresser",
      "google_admin_console": "Google Admin-konsol",
      "inbound_gateway": "Inkommande gateway",
      "inbound_gateway_warning_not_checked": "inte markerad",
      "inbound_gateway_warning_text": "Se till att {reject_option} är {not_checked}. Om detta alternativ förblir aktiverat kan du bara ta emot e-post från Moxso och inte från externa avsändare.",
      "message_spam_eval_header": "Meddelandet betraktas som spam om följande header-regexp matchar",
      "message_tagging": "Meddelandemärkning",
      "navigate_spam_phishing_malware_heading": "Navigera till inställningar för skräppost, nätfiske och skadlig programvara",
      "navigate_spam_phishing_malware_text": "Gå till Gmail-inställningarna för skräppost, nätfiske och skadlig programvara: {spam_phishing_link}",
      "regexp": "Regexp",
      "require_tls": "Kräv TLS för anslutningar från e-postgateways som listas ovan.",
      "save": "Spara",
      "spam_phishing_malware_settings": "Inställningar för skräppost, nätfiske och skadlig programvara",
      "whitelisting_moxso_ip_addresses_in_gw": "Godkänna Moxso IP-adresser i Google Workspace"
    },
    "import_employees": "Importera anställda",
    "integration_error": "Ett fel uppstod vid konfigurationen av integrationen till {provider}.",
    "integration_error_title": "Ett fel inträffade",
    "invite": {
      "button": "Bjud in användare",
      "text": "Vi skickar ett e-postmeddelande till dem för att komma igång.",
      "title": "Bjud in teammedlemmar till din instrumentpanel"
    },
    "microsoft_bypass_junk_by_header": {
      "bypass_junk_by_header": "Kringgå skräppost via huvud.",
      "finish": "färdig",
      "step_1_heading": "Exchange administratörscenter",
      "step_1_text": "Gå till Regler för e-postflöde i administrationscentret för Exchange genom att besöka följande URL: {url}",
      "step_2_heading": "Skapa en ny regel",
      "step_2_text": "Skapa en ny regel och ge den ett namn. Till exempel: {copyField}",
      "step_2b_heading": "Konfigurera regel",
      "step_2b_list_1": "Välj \"Meddelandets rubriker...\"",
      "step_2b_list_2": "Matchar dessa textmönster.",
      "step_2b_p1": "Klicka på den första länken \"Skriv in text\" och skriv in rubriknyckeln: {copyField}",
      "step_2b_p2": "Klicka på nästa \"Ange text\" länk och ange följande huvudervärde: {copyField}",
      "step_2b_text": "I rullgardinsmenyn \"Använd den här regeln om\":",
      "step_3_heading": "Konfigurera meddelandehuvud",
      "step_3_list_1": "Välj \"Ändra meddelandets egenskaper\"",
      "step_3_list_2": "Välj sedan \"Ange ett meddelandehuvud\".",
      "step_3_list_3": "Klicka på den första länken \"Ange text\" och ställ in rubriken till: {copyField}",
      "step_3_list_4": "Klicka på den andra länken \"Ange text\" och ställ in värdet på: {copyField}",
      "step_3_text": "I rullgardinsmenyn \"Gör följande\":",
      "step_4_heading": "Regelinställningar",
      "step_4_list_1": "Klicka på \"nästa\" och fortsätt till regelinställningarna.",
      "step_4_list_2": "Under \"Regelläget\" välj \"Genomdriv\".",
      "step_4_list_3": "Klicka på \"nästa\" och granska regelkonfigurationen.",
      "step_5_heading": "Spara regeln",
      "step_5_text": "Klicka på {finish} för att spara och tillämpa regeln."
    },
    "microsoft_bypass_junk_by_ip": {
      "bypass_junk_by_ip": "Bypassa skräppost efter IP",
      "configure_message_header_heading": "Konfigurera meddelanderubrik",
      "configure_message_header_text_bullet_1": "Välj {modify_message_props}",
      "configure_message_header_text_bullet_2": "Välj sedan {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klicka på den första länken \"Ange text\" och ställ in rubriken till: {header}",
      "configure_message_header_text_bullet_4": "Klicka på den andra länken \"Ange text\" och ställ in värdet till: {value}",
      "configure_message_header_text_intro": "I rullgardinsmenyn \"Gör följande\":",
      "configure_rule_heading": "Konfigurera regel",
      "configure_rule_text_bullet_1": "Välj {the_sender}",
      "configure_rule_text_bullet_2": "Välj sedan {ip_range}",
      "configure_rule_text_bullet_3": "Ange följande IP-adresser en efter en i popup-fönstret och klicka på \"Lägg till\". När du är klar klickar du på \"Spara\".",
      "configure_rule_text_intro": "I rullgardinsmenyn \"Tillämpa denna regel om\":",
      "create_new_rule_heading": "Skapa en ny regel",
      "create_new_rule_text": "Skapa en ny regel och ge den ett namn. Till exempel: {example}",
      "exchange_admin_center_heading": "Exchange-administrationscenter",
      "exchange_admin_center_text": "Navigera till regler för e-postflöde i administrationscentret för Exchange genom att besöka följande URL: {url}",
      "rule_settings_bullet_1": "Klicka på \"nästa\" och fortsätt till regelinställningar.",
      "rule_settings_bullet_2": "Under \"Rule mode\" select \"Tillämpa\".",
      "rule_settings_bullet_3": "Klicka på \"nästa\" och granska regelkonfigurationen.",
      "rule_settings_heading": "Regelinställningar",
      "save_the_rule_heading": "Spara regeln",
      "save_the_rule_text": "Klicka på {finish} för att spara och tillämpa regeln."
    },
    "microsoft_bypass_safe_links_by_header": {
      "bypass_safe_links_by_header": "Omdirigera Safe Links via rubrik",
      "configure_message_header_heading": "Konfigurera meddelandehuvud",
      "configure_message_header_text_bullet_1": "Välj {modify_message_properties}",
      "configure_message_header_text_bullet_2": "Välj sedan {set_a_message_header}",
      "configure_message_header_text_bullet_3": "Klicka på den första länken \"Ange text\" och ställ in rubriken till: {header}",
      "configure_message_header_text_bullet_4": "Klicka på den andra länken \"Ange text\" och ställ in värdet till: {value}",
      "configure_message_header_text_intro": "I rullgardinsmenyn \"Gör följande\":",
      "configure_rule_heading": "Konfigurera regel",
      "configure_rule_text_bullet_1": "Välj {the_message_headers}",
      "configure_rule_text_bullet_2": "Välj sedan {matches_text_patterns}",
      "configure_rule_text_intro": "I rullgardinsmenyn \"Tillämpa denna regel om\":",
      "configure_rule_text_paragraph_1": "Klicka på den första länken \"Enter text\" och ange header-nyckeln: {header_key}",
      "configure_rule_text_paragraph_2": "Klicka på nästa \"Ange text\"-länk och ange följande rubrikvärde: {header_value}",
      "create_new_rule_heading": "Skapa en ny regel",
      "create_new_rule_text": "Skapa en ny regel och ge den ett namn. Till exempel: {example}",
      "exchange_admin_center_heading": "Exchange-administrationscenter",
      "exchange_admin_center_text": "Navigera till regler för e-postflöde i Exchange-administratörscenter genom att besöka följande URL: {url}",
      "rule_settings_bullet_1": "Klicka på \"nästa\" och fortsätt till regelinställningarna.",
      "rule_settings_bullet_2": "Under \"Regelläge\" välj \"Verkställ\".",
      "rule_settings_bullet_3": "Klicka på \"nästa\" och granska reglens konfiguration.",
      "rule_settings_heading": "Regelinställningar",
      "save_the_rule_heading": "Spara regeln",
      "save_the_rule_text": "Klicka på {finish} för att spara och tillämpa regeln."
    },
    "microsoft_bypass_safe_links_by_ip": {
      "bypass_safe_links_by_ip": "Bypass Safe Links efter IP",
      "configure_message_header_heading": "Konfigurera meddelandehuvud",
      "configure_message_header_text_bullet_1": "Välj {modify_message_props}",
      "configure_message_header_text_bullet_2": "Välj sedan {set_msg_header}",
      "configure_message_header_text_bullet_3": "Klicka på den första länken \"Ange text\" och ange rubriken till: {header}",
      "configure_message_header_text_bullet_4": "Klicka på den andra länken \"Ange text\" och ställ in värdet till: {value}",
      "configure_message_header_text_intro": "I rullgardinsmenyn \"Gör följande\":",
      "configure_rule_heading": "Konfigurera regel",
      "configure_rule_text_bullet_1": "Välj {the_sender}",
      "configure_rule_text_bullet_2": "Välj sedan {ip_range}",
      "configure_rule_text_bullet_3": "Ange följande IP-adresser en efter en i popup-fönstret och klicka på \"Lägg till\". När du är klar klickar du på \"Spara\".",
      "configure_rule_text_intro": "I rullgardinsmenyn \"Tillämpa denna regel om\":",
      "create_new_rule_heading": "Skapa en ny regel",
      "create_new_rule_text": "Skapa en ny regel och ge den ett namn. Till exempel: {example}",
      "exchange_admin_center_heading": "Exchange-administrationscenter",
      "exchange_admin_center_text": "Navigera till regler för e-postflöde i administrationscentret för Exchange genom att besöka följande URL: {url}",
      "rule_settings_bullet_1": "Klicka på \"nästa\" och fortsätt till regelinställningar.",
      "rule_settings_bullet_2": "Under \"Rule mode\" välj \"Enforce\".",
      "rule_settings_bullet_3": "Klicka på \"nästa\" och granska reglernas konfiguration.",
      "rule_settings_heading": "Regelinställningar",
      "save_the_rule_heading": "Spara regeln",
      "save_the_rule_text": "Klicka på {finish} för att spara och tillämpa regeln."
    },
    "microsoft_integration": "Microsoft-säkerhetsgodkännande",
    "microsoft_tenant_allow_block": {
      "add_moxso_ips_to_tabl": "Lägg till Moxso-IP-adresser till listorna Tillåt/Blockera hyresgäst",
      "add_new_entry_bullet_1": "Klicka på knappen {add_button}.",
      "add_new_entry_bullet_2": "I avsnittet domänpar anger du följande: {domain_pair_1} {domain_pair_2}",
      "add_new_entry_bullet_3": "Ställ in Spoof-typ till {spoof_internal}.",
      "add_new_entry_bullet_4": "Ställ in åtgärd på {allow_action}.",
      "add_new_entry_heading": "Lägg till en ny post",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Navigera till Tenant Allow/Block Lists i Microsoft Defender genom att besöka följande URL: {url}",
      "save_the_domain_pair_heading": "Spara domänparet",
      "save_the_domain_pair_text": "Klicka på {add} för att spara det nya domänparet."
    },
    "microsoft_third_party": {
      "add_moxso_ips_domains_title": "Lägg till Moxso's IP-adresser och domäner i phishing-simuleringen från tredje part i Microsoft Defender",
      "download_simulation_heading": "Ladda ner simuleringsdomäner/IP-adresser",
      "download_simulation_text": "Ladda ner simuleringsdomäner/IP genom att klicka på knappen nedan: {csv_export_button}",
      "edit_entries_bullet_1": "Klicka på knappen {edit_button}.",
      "edit_entries_bullet_2": "I avsnittet {domain_section}, mata in varje domän som anges som {domain_text} i den nedladdade CSV-filen.",
      "edit_entries_bullet_3": "I avsnittet {sending_ip_section}, ange följande: {ip_1} {ip_2}",
      "edit_entries_heading": "Redigera poster",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Navigera till inställningarna för Tredjeparts Phishing-simulering i Microsoft Defender genom att besöka följande URL: {url}",
      "save_the_domain_pair_heading": "Spara domänparet",
      "save_the_domain_pair_text": "Klicka på {save_button} för att spara inställningarna för tredje parts phishing-simuleringsinställningar."
    },
    "redirecting": "Omdirigerar",
    "results": {
      "button": "Gå till instrumentpanelen",
      "text": "Välkommen ombord! Baserat på dina svar har vi tilldelat träningsnivåer som passar dig bäst. Du kan justera dessa när som helst i inställningarna.",
      "title": "Din sammanfattning"
    },
    "risk": {
      "approx_training_time_per_month": "Ungefärlig träningstid per månad",
      "more_training_more_time": "Högre mål för motståndskraft ökar träningstiden exponentiellt",
      "targeted_resilience_score": "Målinriktat motståndskraftspoäng",
      "text": "Använd skjutreglaget för att ange företagets totala riskexponering och tolerans. Tänk på din bransch, verksamhetens natur och känsligheten hos den information du hanterar när du väljer en risknivå.",
      "title": "Ställ in organisationsrisknivå"
    },
    "select_your_email_provider": "Välj din e-postleverantör för steg-för-steg-instruktioner om allowlisting.",
    "setting_up_workspace": "Ställa in arbetsyta",
    "skip_button": "Hoppa över allowlisting",
    "skip_this_step": "Hoppa över det här steget",
    "sync_started": "Synkronisering har startat",
    "toggle_gmail_api_integration": "Använd Gmail API-integrering",
    "try_integration_again": "Försök igen",
    "use_powershell": "Använd Powershell",
    "verifying_integration": "Verifierar integrering",
    "we_are_now_importing_employees": "Vi synkroniserar anställda från {provider}.",
    "welcome": {
      "graphic": {
        "text": "Du kan också hoppa över detta steg för nu.",
        "title": "Välj din identitetsleverantör för att komma igång"
      },
      "text": "To get the most out of Moxso we recommend that you complete this onboarding.",
      "title": "Welcome to Moxso"
    }
  },
  "pagination": "Sida {page} av {lastPage}",
  "policies": {
    "approve_button": "Godkänn policy",
    "approve_warning": "Att slutföra denna policy kommer att inaktivera framtida redigeringar. Vill du fortsätta?",
    "approve_warning_title": "Godkänn policy",
    "audit": {
      "cancel": {
        "audit_canceled": "Granskning avbruten",
        "button": "Avbryt granskning",
        "title": "Avbryt granskning",
        "warning": "Alla väntande aviseringar stoppas omedelbart och tilldelade användare förlorar åtkomst till denna policy. Vill du fortsätta?"
      },
      "details": {
        "all_completed_tooltip": "Alla {count} medarbetare har bekräftat granskningen",
        "completed_tooltip": "Inga medarbetare har bekräftat granskningen | {count} av {total} medarbetare har bekräftat granskningen",
        "created_at": "Skapad den",
        "end_date": "Slutdatum",
        "enrolling_participants_heading": "Registrera deltagare",
        "enrolling_participants_text": "Deltagare registreras. Var god vänta.",
        "group": "Grupp",
        "groups_heading": "Publik",
        "groups_text": "Uppgiftsgruppers detaljer",
        "heading": "Revision",
        "included_members_count_new_members_tooltip": "Nya medlemmar som lagts till i gruppen efter att denna granskning startades inkluderas inte.",
        "included_members_count_tooltip": "Anställda som redan har bekräftat denna policy och nya medlemmar som lagts till i gruppen efter att denna granskning startades exkluderas.",
        "members": "Medlemmar",
        "no_participants_text": "Inga deltagare för denna granskning",
        "no_participants_title": "Inga deltagare",
        "not_active_yet_text": "Starta revision för att registrera deltagare.",
        "not_active_yet_title": "Granskning inte aktiv",
        "start_date": "Startdatum",
        "status": "Status",
        "text": "Granskningsdetaljer"
      },
      "filters": {
        "acknowledged": "Bekräftad",
        "acknowledged_at": "Bekräftad den",
        "acknowledged_default": "Alla",
        "acknowledged_label": "Bekräftelse",
        "not_acknowledged": "Väntar"
      },
      "launch": {
        "audit_started": "Revision påbörjad",
        "button": "Starta granskning",
        "input_label": "Antal mottagare",
        "title": "Starta granskning",
        "warning": "Du håller på att starta en granskning som kommer att distribuera policyn till medlemmarna i följande grupper. Vill du fortsätta?"
      },
      "single": {
        "settings": "Inställningar",
        "title": "Granskning"
      }
    },
    "audit_draft": "Inaktiv",
    "audit_running": "Granskning",
    "audits": {
      "create": {
        "buttons": {
          "back": "Gå tillbaka",
          "continue": "Fortsätt",
          "submit": "Skapa granskning"
        },
        "date_range": "Revisionsperiod",
        "date_range_placeholder": "Välj start- och slutdatum för granskning",
        "error": "Ett fel inträffade vid skapandet av granskningen",
        "select_groups": "Välj grupper",
        "title": "Skapa granskning"
      },
      "create_new_button": "Lägg till granskning",
      "created": "Granskning skapad framgångsrikt",
      "edit_button": "Redigera",
      "empty": "Inga granskningar tillgängliga för denna policy",
      "help": {
        "include_previously_signed": "Anställda som redan har bekräftat denna policy inkluderas i granskningen.",
        "notification_flow_enabled": "Aktivera automatiska aviseringar för anställda som ännu inte har bekräftat policyn",
        "notification_prelude_enabled": "Skicka en avisering till anställda när en ny policy tilldelas dem."
      },
      "labels": {
        "include_previously_signed": "Inkludera anställda som redan har bekräftat",
        "notification_flow_enabled": "Aktivera notifieringsflöde",
        "notification_frequency": "Notifikationsfrekvens",
        "notification_prelude_enabled": "Aktivera preludieavisering"
      },
      "policy_not_approved_yet": "Godkänn policyn för att påbörja en granskning.",
      "save_settings": "Spara inställningar",
      "title": "Revisionshistorik",
      "updated": "Revisionen uppdaterades"
    },
    "create": {
      "create_button": "Skapa policy",
      "duplicate": "Duplicera",
      "duplicated": "Policyn har duplicerats!",
      "from_template": {
        "text": "Välj från ett bibliotek av vanliga policyer.",
        "title": "Skapa policy från mall"
      },
      "labels": {
        "locale": "Språk",
        "title": "Titel"
      },
      "manual": {
        "text": "Skapa policy utan att fylla i något.",
        "title": "Skapa policy från grunden"
      },
      "placeholders": {
        "locale": "Välj primärt språk för policyn",
        "title": "Policynamn"
      },
      "success": "Policyn skapad!",
      "title": "Skapa policy"
    },
    "delete": {
      "are_you_sure": "Är du säker på att du vill radera denna policy? Denna åtgärd kan inte ångras.",
      "button": "Ta bort",
      "policy_deleted": "Policyn har raderats."
    },
    "edit": {
      "subtitle": "Redigera innehåll och detaljer för policyn",
      "title": "Redigera policy",
      "title_updated": "Titel ändrad framgångsrikt"
    },
    "editor": {
      "add_column_after": "Lägg till kolumn efter",
      "add_column_before": "Lägg till kolumn före",
      "add_row_after": "Lägg till rad under",
      "add_row_before": "Lägg till rad ovanför",
      "delete_column": "Ta bort kolumn",
      "delete_image": "Ta bort bild",
      "delete_row": "Ta bort rad",
      "delete_table": "Ta bort tabell",
      "insert_image": "Infoga bild",
      "insert_table": "Infoga tabell",
      "merge_cells": "Sammanfoga celler",
      "split_cell": "Dela cell",
      "table": "Tabell",
      "toggle_header_row": "Växla rubrikrad"
    },
    "list": {
      "create_new": "Skapa policy",
      "subtitle": "Översikt över alla policys",
      "title": "Policyer"
    },
    "policy_approved": "Policyn godkänd.",
    "quiz": {
      "create_button": "Skapa quiz",
      "done_translate_button": "Klar",
      "edit_button": "Redigera quiz",
      "empty": "Inga frågesporter",
      "other_translations_have_quizzes": "Andra översättningar har quiz",
      "other_translations_have_quizzes_want_to_translate": "Andra översättningar har redan frågesporter. Vill du automatiskt översätta detta quiz till dessa språk?",
      "processing_n_languages": "Bearbetar ett språk | Bearbetar {count} språk",
      "quiz": "Frågesport",
      "quiz_now_available_in": "Ditt quiz är nu tillgängligt på ytterligare ett språk | Ditt quiz är nu tillgängligt på {count} ytterligare språk",
      "quiz_translate_success": "Framgång!",
      "quizzes_translated": "Quiz översatta.",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Välj de språk du vill översätta din quiz till",
      "some_translations_have_no_quizzes": "Vissa översättningar har för närvarande inga quiz. Översätt nu?",
      "subtitle": "Tillgängliga quiz",
      "this_translation_has_quizzes_in_other_languages_translate_automatically": "Denna översättning har frågesporter på andra språk. Översätt automatiskt?",
      "title": "Frågesporter",
      "translate_button": "Översätt",
      "translate_from": "Översätt från",
      "translate_multiple_choice_quiz": "Översätt flervalsfrågesport",
      "translate_quiz": "Översätt",
      "translating_your_quiz": "Översätter din quiz",
      "update_this_quiz_and_translate_others": "Uppdatera denna quiz och översätt andra quizzer",
      "update_this_quiz_only": "Uppdatera endast den här quizzen",
      "view_button": "Visa quiz"
    },
    "single": {
      "audits": "Revisioner",
      "audits_subtitle": "Revisionshistorik",
      "details": {
        "heading": "Detaljer",
        "text": "Policydetaljer"
      },
      "labels": {
        "acknowledgement_rate": "Bekräftelsegrad",
        "approval": "Godkännandestatus",
        "approved_at": "Godkänd den {approved_at}",
        "approved_by": "Godkänd av {user}",
        "created_at": "Skapad den",
        "edit": "Redigera",
        "id": "ID",
        "latest_audit_status": "Senaste granskningsstatus",
        "not_approved": "Ej godkänd",
        "updated_at": "Uppdaterad den"
      },
      "subtitle": "Tillgängliga översättningar",
      "title": "Policy"
    },
    "tables": {
      "approved_at": "Godkänd vid",
      "created_at": "Skapad den",
      "has_active_audit": "Revisionsstatus",
      "status_approved": "Godkänd",
      "status_draft": "Utkast",
      "title": "Titel"
    },
    "translations": {
      "ai": {
        "done_translate_button": "Klar",
        "policy_now_available_in": "Din policy är nu tillgänglig på ytterligare ett språk | Din policy är nu tillgänglig på {count} ytterligare språk",
        "policy_translate_success": "Framgång!",
        "processing_n_languages": "Bearbetar ett språk | Bearbetar {count} språk",
        "text": "Använd DeepL för att automatiskt översätta policyn till ett valt språk.",
        "title": "Översätt policy med AI",
        "translate_button": "Översätt",
        "translate_from": "Översätt från",
        "translating_your_policy": "Översätter din policy"
      },
      "create": "Översätt",
      "create_deepl_new_button": "Översätt med AI",
      "create_new_button": "Lägg till översättning",
      "create_success": "Översättning skapad framgångsrikt",
      "create_title": "Lägg till översättning",
      "created_at": "Skapad",
      "default_badge": "Standard",
      "delete_are_you_sure": "Är du säker på att du vill ta bort denna översättning? Denna åtgärd kan inte ångras.",
      "delete_button": "Radera",
      "edit_button": "Redigera",
      "edit_views": {
        "edit": "Redigera",
        "preview": "Förhandsgranska"
      },
      "empty": "Inga översättningar för denna policy",
      "empty_sections_overview": {
        "subtitle": "# Skapa en ny sektion\n\nPolicyn {policy_name} saknar innehåll i följande sektion{\"@\"}:",
        "title": "Inga avsnitt tillagda"
      },
      "language": "Språk",
      "last_updated": "Senast uppdaterad",
      "locked": "Redigering låst eftersom policyn är godkänd.",
      "make_default": "Ange som standard",
      "manual": {
        "first_translation_text": "Kom igång genom att skapa en översättning från grunden",
        "first_translation_title": "Skapa policyöversättning",
        "text": "Skriv om översättningen från grunden till ett nytt språk.",
        "title": "Manuell översättning av policy"
      },
      "save": "Spara ändringar",
      "save_success": "Översättningen har sparats framgångsrikt",
      "save_success_title": "Titel ändrad framgångsrikt",
      "select_locale": "Målspråk",
      "select_locale_placeholder": "Välj språket för din översättning",
      "subtitle": "Hantera översättningar för denna policy",
      "title": "Översättningar",
      "title_label": "Översättningstitel",
      "title_placeholder": "Ange översättningstitel",
      "translation_deleted": "Översättning borttagen.",
      "view_button": "Visa"
    }
  },
  "quiz_builder": {
    "buttons": {
      "add_ai_question": "Lägg till AI-fråga",
      "add_option": "Lägg till alternativ",
      "add_question": "Lägg till fråga",
      "close": "Stäng",
      "edit": "Redigera",
      "save_quiz": "Spara quiz"
    },
    "delete_question_confirmation": {
      "are_you_sure": "Är du säker på att du vill ta bort den här frågan?",
      "button": "Radera fråga"
    },
    "empty": {
      "ai_create_button": "Knappen \"Skapa med AI\" kommer snart att finnas tillgänglig för quiz.",
      "ai_description": "Kom igång genom att antingen lägga till den första frågan eller använda Moxso AI för att skapa ett quiz.",
      "create_button": "Skapa quiz",
      "description": "Kom igång genom att lägga till den första frågan.",
      "manually_create_button": "Skapa quiz manuellt",
      "title": "Inga frågor än"
    },
    "labels": {
      "answer_options": "Svarsalternativ",
      "question": "Fråga"
    },
    "placeholders": {
      "answer_option": "Ange alternativ",
      "question": "Ange fråga"
    },
    "quiz_saved": "Frågesport sparad",
    "quizzes_translated": "Frågesporter översatta.",
    "titles": {
      "question": "Fråga {number}"
    }
  },
  "report": {
    "click_rate": "Klickfrekvens",
    "from_value": "från {value}",
    "last_12_months": "Senaste 12 månaderna",
    "last_six_months": "Senaste sex månaderna",
    "no_data": "Ingen data",
    "polarity": "Polaritet",
    "report_rate": "Rapporteringsfrekvens",
    "resilience": "Motståndskraft",
    "simulations": "Simuleringar",
    "training": "Utbildning",
    "vs_previous_period": "mot föregående period"
  },
  "reset_password": {
    "heading": "Återställ lösenord",
    "success_message": "Lösenordet sparades framgångsrikt",
    "text": "Vänligen välj ett nytt lösenord"
  },
  "seo_titles": {
    "automation": {
      "action": "Automatiseringsdeltagare",
      "edit": "Redigera automatisk process",
      "index": "Automationer",
      "single": "Sekvens"
    },
    "breach": {
      "index": "Överträdelser",
      "single": "Intrång"
    },
    "campaign": {
      "index": "Simulationer",
      "single": "Simulering",
      "templates": "Anpassade mallar"
    },
    "dashboard": {
      "breaches": "Instrumentbräda – Överträdelser",
      "human_risk_intelligence": "Instrumentpanel - Mänsklig riskintelligens",
      "overview": "Kontrollpanel",
      "resilience": "Instrumentpanel – Resiliens",
      "simulations": "Dashboard – Simulationer",
      "threats": "Instrumentpanel – Hot",
      "training": "Instrumentpanel – Träning"
    },
    "employee": {
      "index": "Anställda",
      "single": "Anställd"
    },
    "forgot_password": "Återställ lösenord",
    "group": {
      "index": "Grupper",
      "single": "Grupp"
    },
    "impersonate": "Impersonera",
    "integration": "Integration",
    "invite": {
      "id": "Acceptera inbjudan",
      "index": "Acceptera inbjudan"
    },
    "login": "Logga in",
    "policies": {
      "audit": "Granskning",
      "index": "Policys",
      "single": "Redigera policyöversättning",
      "translations": "Policyöversättningar"
    },
    "reset_password": "Återställ lösenord",
    "settings": {
      "breaches": "Inställningar – Överträdelser",
      "domains": "Inställningar – Domäner",
      "e_learning": "Inställningar – Utbildning",
      "export": "Inställningar – Exportera data till CSV",
      "import": "Inställningar – Importera från CSV",
      "index": "Inställningar – Arbetsyta",
      "integrations": {
        "index": "Inställningar – Integrationer",
        "single": "Inställningar – Redigera integration"
      },
      "risk": "Inställningar – Risk",
      "simulations": "Inställningar – Simulationer",
      "threats": "Inställningar – Hot"
    },
    "threat": {
      "index": "Hot",
      "single": "Hot"
    },
    "training": {
      "deadlines": "Deadlines",
      "index": "E-lärande",
      "participation": "Deltagande"
    },
    "two_factor": "Tvåfaktorsautentisering",
    "user_settings": "Användarinställningar",
    "validate_domain": "Validera domän"
  },
  "settings": {
    "breaches": {
      "enable_breaches": {
        "help": "Aktivera överträdelser för denna arbetsyta.",
        "title": "Aktivera överträdelser"
      },
      "enable_notifications": {
        "help": "Informera anställda direkt när de är inblandade i nya överträdelser.",
        "title": "Aktivera aviseringar"
      },
      "subtitle": "Konfigurera dina inställningar för intrång.",
      "title": "Överträdelser"
    },
    "buttons": {
      "add_domain": "Lägg till domän",
      "add_report": "Lägg till rapport",
      "add_user": "Lägg till användare",
      "resend_invitation": "Skicka om e-post",
      "revoke_access": "Återkalla åtkomst",
      "save_settings": "Spara inställningar",
      "verify_domain": "Verifiera"
    },
    "data": {
      "subtitle": "När den är aktiverad kommer poster att anonymiseras 90 dagar efter deras senaste relevanta åtgärd.",
      "title": "Dataanonymisering"
    },
    "domains": {
      "domain_added": "Domän skapad",
      "domain_required": "Vänligen ange ett domännamn",
      "subtitle": "Hantera domännamn som ägs av din arbetsyta.",
      "title": "Verifierade domäner",
      "verification_email_sent": "Verifieringsmejl skickat",
      "verification_required": "Verifiering väntar",
      "verified": "Verifierad",
      "verified_on": "Verifierad den:",
      "verify_new_domain": "Verifiera ny domän"
    },
    "e_learning": {
      "alert": {
        "not_allowed": "Inte tillåtet",
        "optional_courses": "Valfria kurser",
        "optional_courses_description": "Kurser utanför obligatorisk utbildning",
        "optional_quiz_questions": "Quizfrågor",
        "optional_quiz_questions_description": "Valfria phishing-quizfrågor",
        "optional_videos": "Valfria videor",
        "optional_videos_description": "Videor utanför obligatorisk utbildning",
        "quiz_limit_value": "15 per vecka",
        "title": "Begränsningar som gäller när aktiverat",
        "video_limit_value": "2 per vecka"
      },
      "modes": {
        "automatic": {
          "description": "Moxso sköter hela utbildningsprogrammet automatiskt.",
          "recommended": "Rekommenderas",
          "title": "Automatisk utbildning"
        },
        "confirmation": {
          "automatic": {
            "description": "Moxso börjar tilldela utbildning automatiskt.",
            "title": "Byt till automatisk utbildning?"
          },
          "manual": {
            "description": "Moxso slutar tilldela utbildning. Befintliga tilldelningar behålls.",
            "title": "Byt till schemalagd utbildning?"
          },
          "switch": "Byt"
        },
        "help": "Välj hur utbildning tilldelas i din organisation.",
        "label": "Utbildningsläge",
        "manual": {
          "description": "Administratörer schemalägger och tilldelar utbildning själva.",
          "title": "Schemalagd utbildning"
        },
        "will_be_hidden": "Döljs efter bytet"
      },
      "subtitle": "Konfigurera dina utbildningsinställningar.",
      "title": "Utbildning"
    },
    "exports": {
      "custom": "Anpassad",
      "default": "Standard",
      "download_export": "Ladda ner export",
      "export_type": {
        "automation": "Automationsrapport",
        "employee": "Anställdrapport",
        "text": "Välj vilken typ av export du vill generera.",
        "title": "Exporttyp",
        "training": "Träningsrapport"
      },
      "form": {
        "deselect_all": "Avmarkera alla fält",
        "select_all": "Välj alla fält"
      },
      "reports": {
        "delete_button": "Radera",
        "deleted_success": "Rapport raderad",
        "download_button": "Ladda ner",
        "edit_button": "Redigera",
        "search": "Sök",
        "subtitle": "Konfigurera schemalagda rapporter för din arbetsyta.",
        "title": "Schemalagda rapporter"
      },
      "selected_columns": "Fält({count}): {columns}",
      "subtitle": "Välj de data du vill exportera.",
      "title": "Ladda ner export"
    },
    "forms": {
      "company": {
        "label": "Företag",
        "placeholder": "Företag"
      },
      "custom_deeplink_url": {
        "description": "Använd ::content_id:: som en obligatorisk platshållare för innehålls-ID:t.",
        "label": "Anpassad innehålls-URL",
        "placeholder": "https://example.com/launch/something-::content_id::"
      },
      "custom_lms_url": {
        "label": "Anpassad LMS-URL",
        "placeholder": "https://example.com/launch/"
      },
      "data_enrichment": {
        "subtitle": "Tilldela roller till anställda baserat på deras data.",
        "title": "Berikning av anställdas data",
        "tooltip": "Berikning av anställdas data använder AI för att tilldela roller till anställda baserat på deras avdelning och grupper."
      },
      "enhanced_scoring": {
        "subtitle": "Vikta resilienspoäng baserat på medarbetarroller.",
        "title": "Förbättrad poängsättning",
        "tooltip": "Förbättrad poängsättning tillämpar olika vikter beroende på hur säkerhetskritisk en roll är, så individer med större tillgång eller ansvar måste göra mer för att nå samma motståndspoäng."
      },
      "gdpr": {
        "employees": {
          "help": "Anonymisera automatiskt inaktiva anställda.",
          "title": "Anonymisera inaktiva anställda"
        },
        "threats": {
          "help": "Anonymisera hotdata automatiskt.",
          "title": "Anonymisera hanterade hot"
        }
      },
      "hotline": {
        "description": "Detta kommer att vara den primära kontakten för ditt team vid potentiella hot eller medarbetarbegäranden.",
        "label": "Journummer",
        "placeholder": "it{'@'}company.com"
      },
      "industry": {
        "label": "Bransch"
      },
      "labels": {
        "active_status": "Status",
        "automation": "Automatisering",
        "custom_fields": "Fält",
        "date_range": "Välj datum",
        "domain": "Domän",
        "email": "E-post",
        "first_name": "Förnamn",
        "group": "Grupp",
        "last_name": "Efternamn",
        "report_frequency": "Frekvens",
        "report_period": "Period",
        "report_recipient": "Mottagare",
        "report_status": "Status",
        "report_type": "Rapporttyp",
        "role": "Roll",
        "training_type": "Typ"
      },
      "leaderboard": {
        "enabled": {
          "subtitle": "Visa en topplista i hubben och välj hur medarbetare rankas.",
          "title": "Topplista"
        },
        "options": {
          "point_leaderboard": "Poängtopplista",
          "score_leaderboard": "Topplista för motståndspoäng"
        },
        "setting": {
          "label": "Topplistetyp"
        }
      },
      "placeholders": {
        "date_range": "Välj datum",
        "domain": "företag.com",
        "email": "name{'@'}company.com",
        "first_name": "Förnamn",
        "last_name": "Efternamn",
        "report_recipient": "Sök efter anställd",
        "search_employee": "Sök anställd"
      },
      "reports": {
        "add_scheduled_report": "Lägg till schemalagd rapport",
        "choose_report_type": "Välj en annan rapporttyp",
        "description": "Ställ in schemalagda rapporter för att skickas automatiskt.",
        "edit_scheduled_report": "Redigera schemalagd rapport",
        "hierarchy_level": {
          "description": "När det är aktiverat inkluderar rapporten medarbetare längre ned i hierarkin, inte bara direktrapporter.",
          "label": "Inkludera underställda teammedlemmar"
        },
        "manager_report": {
          "text": "En rapport för chefer om deras anställda.",
          "title": "Rapport för chef"
        },
        "workspace_report": {
          "text": "En rapport för hela arbetsytan.",
          "title": "Arbetsplatsrapport"
        }
      },
      "scim": {
        "add_title": "Skapa SCIM-token",
        "connection_add_title": "Skapa SCIM-anslutning",
        "connection_created": "SCIM-anslutning skapad.",
        "connection_deleted": "SCIM-anslutning borttagen.",
        "connection_name_label": "Anslutningsnamn",
        "connection_name_placeholder": "Microsoft Entra ID",
        "connection_saved": "SCIM-anslutning sparad.",
        "connection_token_name_placeholder": "{name}-provisionering",
        "create_connection_button": "Skapa anslutning",
        "create_token_button": "Skapa token",
        "create_token_header": "Skapa token",
        "created_title": "SCIM-token skapat",
        "default_mapping_marker": "Standard",
        "delete_connection_body": "Detta tar bort anslutningen och återkallar alla SCIM-token som är kopplade till den. Provisionering från den här leverantören stoppas omedelbart.",
        "delete_connection_button": "Ta bort anslutning",
        "delete_connection_title": "Ta bort SCIM-anslutning?",
        "done": "Klar",
        "edit_connection_button": "Redigera anslutning",
        "enabled_label": "Aktiverad",
        "name_help": "Ge tokenet ett beskrivande namn så att du kan identifiera det senare.",
        "name_label": "Tokennamn",
        "name_placeholder": "Microsoft Entra-provisionering",
        "note_cannot_view": "Detta token visas bara en gång. Spara det i din identitetsleverantör innan du stänger dialogen.",
        "provider_label": "Leverantör",
        "reset_mapping_button": "Återställ till standardvärden",
        "revoke_body": "Provisioneringsförfrågningar som använder detta token stoppas omedelbart. Befintliga medarbetare och grupper tas inte bort.",
        "revoke_button": "Återkalla token",
        "revoke_title": "Återkalla SCIM-token",
        "save_connection_button": "Spara anslutning",
        "save_mapping_button": "Spara mappning",
        "secret_token_label": "Hemligt token",
        "show_mapping_details": "Mappningsdetaljer",
        "success_token_added": "SCIM-token tillagt.",
        "success_token_revoked": "SCIM-token återkallat.",
        "sync_type_employee": "Medarbetare",
        "sync_type_employee_description": "Provisionera medarbetare och medarbetargrupper från den här identitetsleverantören.",
        "sync_type_label": "Provisioneringstyp",
        "sync_type_user": "Adminanvändare",
        "sync_type_user_description": "Provisionera adminanvändare som kan komma åt administrationspanelen."
      },
      "select_automation": "Välj automatisering",
      "select_group": "Välj grupp",
      "settings_saved": "Inställningar sparade",
      "success": {
        "invitation_resent": "E-postbekräftelsen har skickats om",
        "report_added": "Rapporten har lagts till framgångsrikt",
        "report_edited": "Rapport sparad",
        "user_added": "Användare tillagd"
      },
      "timezone": {
        "label": "Tidszon",
        "placeholder": "Välj tidszon"
      },
      "tokens": {
        "add_title": "Skapa token",
        "are_you_sure_you_want_to_delete": "Är du säker på att du vill ta bort denna token? Den här åtgärden kan inte ångras.",
        "close": "Stänga",
        "create_token_button": "Skapa token",
        "documentation": "Dokumentation",
        "name_help": "Ge ditt token ett beskrivande namn för att hjälpa dig identifiera det senare.",
        "name_label": "Namn",
        "name_placeholder": "Namn på token",
        "note_cannot_view": "Denna token kommer endast att visas en gång. Spara den på en säker plats.",
        "success_token_added": "Token tillagd.",
        "success_token_deleted": "Token borttaget.",
        "token_created": "Token skapad"
      },
      "training_restrictions": {
        "enabled": {
          "subtitle": "Begränsa hur mycket ej tilldelad utbildning medarbetare kan genomföra på egen hand.",
          "title": "Utbildningsbegränsningar",
          "tooltip": "Aktivera standardbegränsningarna för valfri utbildning i hubben."
        },
        "unassigned_quiz_limit": {
          "help": "Maximalt antal ej tilldelade quiz en medarbetare kan genomföra.",
          "label": "Quizgräns"
        },
        "unassigned_video_limit": {
          "help": "Maximalt antal ej tilldelade videor en medarbetare kan genomföra.",
          "label": "Videogräns"
        }
      },
      "training_type": {
        "course": "Kurs",
        "video": "Video"
      },
      "users": {
        "add_employee": "Lägg till användare"
      }
    },
    "imports": {
      "back": "Tillbaka",
      "button": "{klicka} eller dra och släpp",
      "click_to_upload": "Klicka för att ladda upp",
      "completed": "Slutförd",
      "done": "Klar",
      "failed": "Misslyckades",
      "file_requirements": "Filen måste innehålla följande kolumner: <b>first_name</b>, <b>last_name</b>, <b>email</b> och <b>locale</b> (t.ex. da_DK, en_US, de_DE).<br/>Valfritt kan filen innehålla <b>timezone</b> (t.ex. Europe/Copenhagen), <b>phone_number</b> och <b>phone_country_code</b>.<br/><b>CSV-filer måste använda komma som avgränsare.</b><br/>Accepterade format: .csv eller .txt (Filen bör sparas i UTF-8-format för att säkerställa korrekt teckenkodning)",
      "formats": "CSV eller TXT upp till 10 MB",
      "import_type": {
        "employees": "{count} anställd | {count} anställda",
        "groups": "{count} grupp | {count} grupper"
      },
      "pending": "Synkroniserar",
      "upload_another": "Ladda upp en annan fil"
    },
    "integrations": {
      "account": {
        "subtitle": "Synkronisera användarkonton med Moxso.",
        "title": "Användare och kommunikation"
      },
      "add_our_domains_and_setup_guides": "Lägg till våra domäner och följ Gmail/Outlook-guiderna.",
      "addin_setup_guide": "Installationsguide",
      "coming_soon": "Kommer snart",
      "compliance": {
        "subtitle": "Synkronisera med överensstämmelseverktyg.",
        "title": "Verktyg för efterlevnad"
      },
      "connected": {
        "subtitle": "För närvarande anslutna integrationer.",
        "title": "Aktiva integrationer"
      },
      "delete": {
        "button": "Ta bort integration",
        "confirmation": "Är du säker på att du vill ta bort den här integrationen? Den här åtgärden kan inte ångras.",
        "description": "Om du tar bort den här integrationen stoppas framtida synkronisering. Den här åtgärden kan inte ångras.",
        "subtitle": "Ta bort den här integrationen från din arbetsyta.",
        "success": "Integration borttagen",
        "title": "Ta bort integration"
      },
      "edit": {
        "auth_settings": {
          "subtitle": "Uppdatera autentiseringsinställningar",
          "title": "Autentiseringsinställningar"
        },
        "filtering": {
          "text": "Emailfiltrering tar automatiskt bort delade e-postadresser från din integration, detta kan vara e-postkonton som: admin{'@'}domain.com, contact{'@'}domain.com etc.",
          "title": "Generisk och rollbaserad e-postfiltrering"
        },
        "groups": {
          "text": "Välj om grupper ska synkroniseras varje gång din integration uppdateras.",
          "title": "Grupper"
        },
        "managers": {
          "text": "Välj om administratörer ska synkroniseras varje gång din integration uppdateras.",
          "title": "Chefer"
        },
        "offboarding": {
          "text": "Välj om du vill inaktivera medarbetare automatiskt när de tas bort från din integration.",
          "title": "Offboarding"
        },
        "settings": {
          "enable_notifications": {
            "title": "Aktivera träningsaviseringar"
          },
          "enable_sync": "Aktivera synkronisering",
          "select_sync_frequency": "Välj hur ofta du vill att din integration ska synkroniseras.",
          "subtitle": "Uppdatera integreringskonfiguration",
          "sync_frequency": "Synkroniseringsfrekvens",
          "title": "Redigera integration"
        },
        "sync_phone_numbers": {
          "text": "Välj om telefonnummer ska importeras vid synkronisering med denna integration.",
          "title": "Importera telefonnummer"
        },
        "title": "Senaste synkroniseringarna"
      },
      "enabled": "Aktiverad",
      "first_sync": "Första synkronisering",
      "form": {
        "access_token": {
          "help": "API-nyckeln används för att autentisera integrationen.",
          "label": "API-nyckel"
        },
        "api_route": {
          "label": "Api-rutt",
          "placeholder": "Ange API-route"
        },
        "password": {
          "help": "Lösenordet används för att autentisera integrationen.",
          "label": "Lösenord",
          "placeholder": "Ange lösenord"
        },
        "region": {
          "help": "Välj vilken dataregion du använder för den här leverantören.",
          "label": "Dataregion",
          "options": {
            "eu": "EU",
            "global": "Global"
          }
        },
        "username": {
          "help": "Användarnamnet används för att autentisera integrationen.",
          "label": "Användarnamn",
          "placeholder": "Ange användarnamn"
        }
      },
      "frequency": {
        "daily": {
          "description": "Dina data kommer att synkroniseras varje dag.",
          "title": "Dagligen"
        },
        "monthly": {
          "description": "Dina data kommer att synkroniseras varje månad på den första dagen.",
          "title": "Månatligen"
        },
        "realtime": {
          "description": "Dina data kommer att synkas varje minut.",
          "title": "I realtid"
        },
        "weekly": {
          "description": "Dina data kommer att synkroniseras varje vecka på måndag.",
          "title": "Veckovis"
        }
      },
      "gmail_addin": {
        "apps_marketplace_apps": "Appar → Google Workspace Marketplace-appar",
        "click_install_review_deploy": "Klicka på {install}, granska de begärda behörigheterna och välj {deploy_to_organisation} (eller en testgrupp) för att göra tillägget tillgängligt för användare.",
        "deploy_to_organisation": "Distribuera till din organisation",
        "find_moxso_add_in": "Hitta tillägget “Moxso Report”",
        "in_admin_console_navigate_to": "I administratörskonsolen för Google Workspace navigerar du till {marketplace_apps}.",
        "install": "Installera",
        "install_and_deploy": "Installera och distribuera tillägget",
        "moxso_report": "Moxso-rapport",
        "open_workspace_marketplace": "Öppna Google Workspace Marketplace",
        "report_threats_directly_from_gmail": "Rapportera hot till Moxso direkt från Gmail.",
        "search_to_locate": "Använd sökfältet för att hitta {moxso_report} och öppna dess informationssida.",
        "title": "Installera Gmail-tillägg"
      },
      "gmail_whitelisting_guide": "Gmail-allowlistingguide",
      "hri": {
        "connected": "Ansluten",
        "directory_description": "Anslut Microsoft Entra eller Google Workspace för att matcha medarbetar-ID:n och låsa upp andra HRI-integrationer. Denna HRI-anslutning är separat från din vanliga integration.",
        "directory_title": "Anslut din medarbetarkatalog först",
        "enable": "Aktivera",
        "explore_description": "Du kan utforska integrationerna nedan. Konfiguration kräver en aktiv HRI-anslutning till Microsoft Entra eller Google Workspace.",
        "explore_title": "Utforska integrationer",
        "recommended": "Rekommenderas",
        "recommended_tooltip": "Du använder redan den här katalogen",
        "setup_locked": "Konfiguration låst",
        "setup_prerequisite": "Konfigurera först HRI för Microsoft Entra eller Google Workspace."
      },
      "integration_stored": "Integrering sparad",
      "last_sync": "Senaste synkronisering",
      "last_update": "Senaste uppdatering: {time}",
      "lms": {
        "subtitle": "Synkronisera med lärplattformar.",
        "title": "Lärplattformar"
      },
      "never": "Aldrig",
      "not_connected": "Inte ansluten",
      "notifications": {
        "subtitle": "Skicka aviseringar via samarbetsverktyg.",
        "title": "Aviseringar"
      },
      "open_guide": "Öppna guide",
      "outlook_addin": {
        "accept_permissions": "Acceptera behörigheter",
        "add_ins": "Tillägg",
        "app_type": "Apptyp",
        "assign_access": "Tilldela åtkomst",
        "assign_users": "Tilldela användare",
        "choose_who_get_add_in": "Under {assign_users} väljer du vem som ska få tillägget. Vi rekommenderar att du väljer {specific_users} och väljer de relevanta grupperna.",
        "chose_manifest_url": "Välj {provide_link} och klistra in manifest-URL:en:",
        "click": "Klicka {next}.",
        "click_next_then_finish": "Klicka på {next}, sedan {finish}.",
        "click_you_should_see_message": "Klicka på {validate}. Du bör se meddelandet \"{file_validated}\".",
        "complete": "Slutför",
        "confirm_slot_is_selected": "I {app_type}-listan, bekräfta att {add_in} är markerad.",
        "done": "Klart",
        "examine_permissions": "Granska de begärda behörigheterna. Om allt ser korrekt ut, välj {accept_permissions} och bekräfta uppmaningarna.",
        "finalize_deployment": "Slutför distribution",
        "finish_deployment": "Slutför distribution",
        "integrated_apps": "Integrerade appar",
        "manifest_file_validated": "Manifestfilen har validerats",
        "navigate_to_admin_center": "Navigera till administratörscenter för Microsoft 365 > Inställningar > {link}",
        "next": "Nästa",
        "office_add-in": "Office-tillägg",
        "open_integrated_apps": "Öppna integrerade appar",
        "proceed_to_assignment": "Fortsätt till tilldelning",
        "process_indicator_then_complete": "Du kommer att se en framstegsindikator; detta steg överstiger sällan en minut. Därefter, tryck på {done} för att fullfölja inställningen.",
        "provide_link_to_manifest_file": "Tillhandahåll länk till manifestfilen",
        "provide_manifest": "Tillhandahåll manifestet",
        "report_threats_directly_from_outlook": "Rapportera hot till Moxso direkt från Outlook.",
        "restart_outlook": "Starta om Outlook för att säkerställa att tillägget initieras, skicka sedan en testmejlrapport. Observera att det kan ta upp till 24 timmar innan tillägget visas efter distribution.",
        "review_permissions": "Granska behörigheter",
        "select_upload_custom_apps": "Välj {bold}.",
        "specific_users_groups": "Specifika användare/grupper",
        "specify_app_type": "Ange appens typ",
        "start_the_upload": "Starta uppladdningsprocessen",
        "title": "Installera Outlook-tillägg",
        "upload_custom_apps": "Överför anpassade appar",
        "use_powershell": "Använd powershell",
        "validate": "Validera",
        "validate_manifest": "Validera manifestet",
        "verify_add_in": "Verifiera tillägget i Outlook"
      },
      "outlook_whitelisting_guide": "Outlook-guide för allowlisting",
      "overview": {
        "active": "Aktiva",
        "active_subtitle": "För närvarande anslutna integrationer.",
        "active_title": "Aktiva integrationer",
        "all": "Alla",
        "all_subtitle": "Anslut tjänster för att samla medarbetarnas säkerhetsaktivitet i Human Risk Intelligence.",
        "all_title": "Alla integrationer",
        "attention": "Kräver åtgärd",
        "attention_subtitle": "Integrationer som kräver åtgärd innan de kan synkroniseras.",
        "attention_title": "Kräver åtgärd",
        "empty": "Inga integrationer hittades.",
        "hri": "Human risk intelligence",
        "search": "Sök efter integrationer..."
      },
      "refresh": "Uppdatera data",
      "refresh_data": "Uppdatera data",
      "report_threats_directly_from_inbox": "Rapportera hot direkt från inkorgen.",
      "settings_saved": "Inställningar sparade",
      "setup": "Anslut",
      "setup_integration": "Ställ in integration",
      "setup_text": "Vi använder enkel inloggning (SSO) för att ansluta säkert med {provider}. Du kommer att omdirigeras till din leverantörs inloggningssida för autentisering. Observera att ett administratörskonto krävs för att konfigurera integrationen.",
      "simulation_deliverability": "Simuleringsleveransduglighet",
      "single": {
        "provider_title": "Redigera {provider}",
        "subtitle": "Uppdatera integrationskonfiguration",
        "title": "Redigera integration"
      },
      "status": "Integrationsstatus",
      "step_by_step": "Steg-för-steg guide för att släppa igenom e-postmeddelanden.",
      "sync_already_enabled_tooltip": "Medarbetarsynkronisering är redan aktiverad i en annan integration. Vänligen inaktivera den för att använda detta alternativ.",
      "sync_started": "Synkronisering har lagts till i kön",
      "teams_guide": {
        "description": "Följ installationsguiden i vårt {help_center} för instruktioner om hur du lägger till Moxso i Microsoft Teams.",
        "download_zip": "Ladda ned ZIP-fil",
        "help_center": "hjälpcenter"
      },
      "title": "Integrationer",
      "token_error": "Vi kunde inte upprätta en anslutning med {provider} åt dig. Vårt senaste försök var den: {date}. Vänligen bekräfta dina kontouppgifter igen.",
      "whitelisting_guide": "Guide för allowlisting"
    },
    "magic_links": {
      "description": "Låt medarbetare logga in automatiskt via Hub-länkar i aviseringar. När funktionen är avstängd öppnar länkarna Hubs inloggningssida och behåller den ursprungliga destinationen.",
      "label": "Aktivera magiska länkar",
      "title": "Magiska länkar till Hub"
    },
    "risk": {
      "organisation_risk_subtitle": "Övergripande risknivå för {organisation}",
      "organisation_risk_text": "Ju högre risknivån är, desto mer utbildning kommer medarbetarna att få. Överväg att balansera utbildningsbehov med medarbetarnas arbetsbelastning.",
      "organisation_risk_title": "Organisationens risk",
      "subtitle": "Justera utbildningsnivån för varje kategori.",
      "title": "Träningsnivåer"
    },
    "saml": {
      "acs_url": "ACS-URL",
      "add_provider": "Lägg till provider",
      "attribute_mapping": {
        "description": "Mappa SAML assertion-attribut till de adminprofilfält som Moxso förväntar sig.",
        "title": "Assertion-attributmappning"
      },
      "cancel_edit": "Avbryt redigering",
      "create": {
        "manual": {
          "description": "Konfigurera providern manuellt",
          "title": "Skapa manuellt"
        },
        "metadata": {
          "description": "Importera IdP-inställningar från provider",
          "title": "Skapa från metadata-URL"
        }
      },
      "delete": {
        "cancel": "Avbryt",
        "confirm": "Ta bort anslutning",
        "description": "Användare kommer inte längre kunna logga in via denna identitetsleverantör. Befintliga länkade SAML-identiteter för denna leverantör tas också bort.",
        "title": "Ta bort SAML-anslutning"
      },
      "deleted": "SAML-anslutning borttagen",
      "disabled": "Inaktiverad",
      "edit_provider": "Redigera provider",
      "empty": {
        "description": "Lägg till en SAML-provider så att inbjudna administratörer kan starta SSO från inloggningssidan.",
        "title": "Inga SAML-providers"
      },
      "enabled": "Aktiverad",
      "entity_id": "Entity ID",
      "entity_id_instruction": "Använd entityID-värdet från metadata-URL:en.",
      "existing_users_only": "SAML-inloggning fungerar bara för befintliga inbjudna administratörer i denna arbetsyta.",
      "form": {
        "app_federation_metadata_url": "App federation metadata-URL",
        "app_federation_metadata_url_placeholder": "https://example.com/federationmetadata.xml",
        "email_attribute": "E-postattribut",
        "email_attribute_placeholder": "email",
        "enabled": "Aktivera provider",
        "enabled_help": "Aktiverade providers kan användas från inloggningssidan.",
        "first_name_attribute": "Förnamnsattribut",
        "first_name_attribute_placeholder": "firstName",
        "idp_entity_id": "IdP entity ID",
        "idp_entity_id_placeholder": "https://idp.example.com/entity",
        "idp_login_url": "IdP-login-URL",
        "idp_logout_url": "IdP-logout-URL",
        "idp_x509_certificate": "IdP X.509-certifikat",
        "idp_x509_certificate_help": "Det aktuella certifikatet kan inte visas igen. Lämna fältet tomt för att behålla det, eller klistra in ett nytt certifikat för att uppdatera det.",
        "idp_x509_certificate_placeholder": "Klistra in certifikatet från identitetsleverantören",
        "idp_x509_certificate_update": "Uppdatera certifikat",
        "last_name_attribute": "Efternamnsattribut",
        "last_name_attribute_placeholder": "lastName",
        "login_type": "Kräv SAML för",
        "login_type_employee": "Hubbanvändare",
        "login_type_employee_description": "Använd SAML för medarbetares inloggning till utbildningshubben.",
        "login_type_user": "Adminanvändare",
        "login_type_user_description": "Använd SAML för administratörsinloggning till adminområdet.",
        "name": "Namn",
        "name_id_format": "Name ID-format",
        "name_placeholder": "Microsoft Entra ID",
        "provider": "Provider",
        "url_placeholder": "https://idp.example.com/sso"
      },
      "idp_entity_id": "IdP entity ID",
      "login_url": "Login-URL",
      "metadata_url": "Metadata-URL",
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      },
      "read": {
        "description": "Kopiera dessa värden till din identitetsleverantörskonfiguration.",
        "title": "SAML-konfiguration"
      },
      "save_provider": "Spara provider",
      "saved": "SAML-provider sparad",
      "subtitle": "Konfigurera identitetsleverantörer för SSO.",
      "table": {
        "delete": "Ta bort",
        "edit": "Redigera",
        "name": "Namn",
        "provider": "Provider",
        "provider_id": "Provider-ID",
        "status": "Status"
      },
      "title": "SAML single sign-on"
    },
    "simulation": {
      "ceo_fraud": {
        "ceo": {
          "text": "Ange kontaktuppgifterna för din VD (eller motsvarande)",
          "title": "Verkställande direktör (VD)"
        },
        "cfo": {
          "text": "Ange kontaktuppgifterna till din CFO (eller motsvarande)",
          "title": "Ekonomichef (CFO)"
        },
        "cto": {
          "text": "Ange kontaktuppgifterna för din CTO (eller motsvarande)",
          "title": "Teknisk chef (CTO)"
        },
        "info": "Vi använder informationen nedan för att anpassa våra VD-bedrägerisimuleringar för din organisation. Om du inte har informationen tillgänglig, kommer vi att använda standardvärden.",
        "subtitle": "Inställningar för VD-bedrägeri i simuleringar.",
        "title": "VD-bedrägeri"
      },
      "dmi": {
        "google": {
          "alert_text": "Se till att konfigurera DMI i Google Workspace innan du aktiverar det här.",
          "subtitle": "Konfigurera DMI i Google Workspace för att injicera simuleringse-postmeddelanden direkt till Gmail-inkorgar.",
          "title": "DMI for Google Workspace",
          "toggle": {
            "help": "Konfigurera DMI i Google Workspace och aktivera det sedan här när installationen är klar.",
            "label": "Aktivera DMI"
          }
        }
      },
      "search": {
        "placeholder": "Sök efter tjänster",
        "results": "Sökresultat för: {query}"
      },
      "services": {
        "credential_harvest": "Inloggningssida",
        "selector": {
          "dialog_title": "Redigera tjänster",
          "edit_button": "Redigera tillgängliga tjänster",
          "title": "Inga tjänster aktiverade | En tjänst aktiverad | {count} tjänster aktiverade",
          "update_services": "Uppdatera tjänster"
        },
        "subtitle": "Inställningar för inriktning baserat på programvara.",
        "title": "Mjukvarianpassning"
      },
      "training": {
        "download": {
          "subtitle": "Ladda ner domäner som används i våra nätfiske-simuleringar.",
          "title": "Ladda ner simuleringsdomäner"
        },
        "local_ratio": {
          "help": "Vid 70 % får en tysktalande anställd 70 % tyska mallar och 30 % engelska.",
          "subtitle": "Bestäm hur mallar fördelas mellan varje anställds språk och engelska. När detta är avstängt finns ingen fast fördelning.",
          "title": "Mallar på de anställdas språk"
        },
        "subtitle": "Justera känslighet och spårningsinställningar för dina simuleringar.",
        "title": "Allmän",
        "toggle": {
          "subtitle": "Skicka åtgärdande utbildning när en anställd visar sig vara sårbar.",
          "title": "E-lärande"
        }
      }
    },
    "simulations": {
      "ceo_fraud": {
        "ceo_email": {
          "label": "E-post"
        },
        "ceo_name": {
          "label": "Namn"
        },
        "cfo_email": {
          "label": "E-post"
        },
        "cfo_name": {
          "label": "Namn"
        },
        "cto_email": {
          "label": "E-post"
        },
        "cto_name": {
          "label": "Namn"
        }
      },
      "enable_ceo_fraud": "Aktivera VD-bedrägeri",
      "enable_module_help": "Aktivera den här modulen för arbetsytan.",
      "enable_software_targeting": "Aktivera programvaruinriktning"
    },
    "tables": {
      "reports": {
        "frequency": "Frekvens",
        "period": "Period",
        "recipient": "Mottagare",
        "status": "Status",
        "type": "Typ"
      },
      "scim": {
        "actions": "Åtgärder",
        "created": "Skapat",
        "default_mapping": "Standardmappning",
        "effective_mapping": "Effektiv mappning",
        "last_used": "Senast använt",
        "name": "Namn",
        "provider": "Leverantör",
        "status": "Status",
        "sync_type": "Typ"
      },
      "tokens": {
        "created": "Skapad",
        "last_used": "Senast använd",
        "name": "Namn"
      },
      "users": {
        "created": "Skapad",
        "role": "Roll",
        "status": "Status",
        "two_factor": "2FA",
        "user": "Användare"
      }
    },
    "threats": {
      "advanced_settings": {
        "hide": "Dölj avancerade inställningar",
        "show": "Visa avancerade inställningar"
      },
      "alias_email": {
        "help": "Vi föreslår att skapa en mer användarvänlig aliasversion av den inkommande e-postadressen. Till exempel security{'@'}example.com",
        "label": "Alias-e-postadress",
        "placeholder": "säkerhet{'@'}example.com"
      },
      "clustering": {
        "title": "Hotklustring"
      },
      "enable_defender_integration": {
        "help": "Vidarebefordra rapporterade nätfiskemejl till Microsoft Defender.",
        "label": "Aktivera integration med Microsoft Defender",
        "title": "Microsoft Defender"
      },
      "enable_forwarding": {
        "help": "Aktivera vidarebefordran av hot till en specifik e-postadress.",
        "title": "Aktivera vidarebefordran av hot"
      },
      "enable_grouped_threat_status_transitions": {
        "help": "När funktionen är aktiverad får nyskapade hot samma status som det relaterade hotet",
        "title": "Aktivera automatisk statusövergång för hot i kluster"
      },
      "enable_notifications": {
        "help": "Ta emot en avisering varje gång ett potentiellt hot rapporteras",
        "title": "Aktivera aviseringar"
      },
      "enable_third_party_submission": {
        "help": "Aktivera inlämning från tredje part av nätfiskeförsök till Microsoft och Google.",
        "title": "Aktivera inlämning från tredje part"
      },
      "enable_threat_management": {
        "help": "Aktivera hot hantering för detta arbetsutrymme.",
        "title": "Aktivera hotadministration"
      },
      "forward_reported_emails_to": {
        "label": "Vidarebefordra rapporterade e-postmeddelanden till:",
        "placeholder": "rapporterad{'@'}company.com"
      },
      "forward_to": {
        "label": "Vidarebefordra till:",
        "placeholder": "phishing{'@'}company.com"
      },
      "forwarding": {
        "defender": {
          "description": "Vidarebefordra rapporterade nätfiskemejl till Microsoft Defender.",
          "title": "Vidarebefordra till Defender"
        },
        "disabled": {
          "description": "Vidarebefordra inte rapporterade hot.",
          "title": "Inaktivera vidarebefordran"
        },
        "email": {
          "description": "Skicka rapporterade hot till en specifik e-postadress.",
          "title": "Vidarebefordra till e-post"
        },
        "title": "Vidarebefordran av hot"
      },
      "forwarding_warning": "När vidarebefordran av hot är aktiverad kommer rapporterade hot att vara skrivskyddade i administrationspanelen. Ingen analys kommer att utföras av Moxso.",
      "inbound_email": {
        "help": "Denna e-postadress är din personliga rapporteringsadress. Alla e-postmeddelanden som skickas till denna adress kommer att analyseras av Moxso.",
        "label": "Inkommande e-post"
      },
      "save_forwarded_emails": {
        "help": "När detta är aktiverat kommer vidarebefordrade e-postmeddelanden att sparas.",
        "label": "Spara vidarebefordrade hot"
      },
      "subtitle": "Konfigurera dina inställningar för hotmanagement.",
      "threat_grouping_confidence": {
        "help": "Styr hur väl hot måste matcha innan de samlas i ett kluster.",
        "label": "Konfidensnivå för hotkluster",
        "options": {
          "high": "Hög",
          "low": "Låg",
          "medium": "Medel"
        }
      },
      "title": "Hot hantering"
    },
    "two_factor": {
      "actions": {
        "disable": "Inaktivera tvåfaktorsautentisering",
        "enable": "Aktivera tvåfaktorsautentisering",
        "regenerate_recovery_codes": "Generera nya återställningskoder",
        "view_recovery_codes": "Visa återställningskoder"
      },
      "disabled": {
        "badge": "Av",
        "text": "Skydda det här adminkontot med en kod från en autentiseringsapp eller lösenordshanterare.",
        "title": "Tvåfaktorsautentisering är avstängd"
      },
      "enabled": {
        "badge": "På",
        "text": "Det här adminkontot kräver en andra faktor vid inloggning.",
        "title": "Tvåfaktorsautentisering är aktiverad"
      },
      "password_dialog": {
        "cancel": "Avbryt",
        "cancel-setup": {
          "button": "Avbryt konfigurering",
          "description": "Bekräfta ditt nuvarande lösenord för att avbryta den pågående tvåfaktorskonfigureringen.",
          "title": "Avbryt tvåfaktorskonfigurering"
        },
        "current_password": "Nuvarande lösenord",
        "disable": {
          "button": "Inaktivera",
          "description": "Bekräfta ditt nuvarande lösenord för att inaktivera tvåfaktorsautentisering för det här kontot.",
          "title": "Inaktivera tvåfaktorsautentisering"
        },
        "enable": {
          "button": "Fortsätt",
          "description": "Bekräfta ditt nuvarande lösenord innan du konfigurerar tvåfaktorsautentisering.",
          "title": "Aktivera tvåfaktorsautentisering"
        },
        "regenerate-recovery-codes": {
          "button": "Generera nya koder",
          "description": "Bekräfta ditt nuvarande lösenord för att ersätta dina befintliga återställningskoder.",
          "title": "Generera nya återställningskoder"
        },
        "show-recovery-codes": {
          "button": "Visa koder",
          "description": "Bekräfta ditt nuvarande lösenord för att visa dina återställningskoder.",
          "title": "Visa återställningskoder"
        }
      },
      "recovery_codes": {
        "copied": "Kopierat",
        "copy": "Kopiera koder",
        "text": "Spara dessa engångskoder i din lösenordshanterare. De visas inte här igen när du har stängt dem.",
        "title": "Återställningskoder"
      },
      "setup": {
        "cancel": "Avbryt konfigurering",
        "code_label": "Autentiseringskod",
        "code_placeholder": "123456",
        "confirm": "Bekräfta",
        "manual_key": "Manuell konfigureringsnyckel",
        "qr_alt": "QR-kod för tvåfaktorskonfigurering",
        "text": "Skanna QR-koden med din autentiseringsapp eller lösenordshanterare och ange sedan den 6-siffriga kod som genereras.",
        "title": "Konfigurera din autentiserare"
      },
      "subtitle": "Kräv en andra faktor vid inloggning till ditt adminkonto.",
      "title": "Tvåfaktorsautentisering"
    },
    "workspace": {
      "lms": {
        "subtitle": "Konfigurera en anpassad innehålls-URL för att omdirigera användare till en extern lärplattform.",
        "title": "Externt LMS"
      },
      "logging": {
        "activity": "Aktivitet",
        "columns": {
          "action_time": "Åtgärdstid",
          "action_type": "Åtgärdstyp",
          "actor": "Aktör",
          "zone": "Zon"
        },
        "moxso_support": "Moxso support",
        "partner": "Partner",
        "slideover": {
          "actor": "Aktör",
          "app": "App",
          "audit_log": "Granskningslogg",
          "created": "Skapad",
          "email": "E-post",
          "event": "Händelse",
          "impersonated_by_support": "Imiterad av support",
          "ip_address": "IP-adress",
          "name": "Namn",
          "no": "Nej",
          "path": "Sökväg",
          "request": "Begäran",
          "summary": "Sammanfattning",
          "tabs": {
            "request": "Begäran",
            "summary": "Sammanfattning och aktör"
          },
          "title": "Händelse",
          "type": "Typ",
          "user_agent": "User agent",
          "yes": "Ja"
        },
        "subtitle": "Se historiken över ändringar som gjorts inom det här kontot.",
        "title": "Granskningsloggar"
      },
      "scim": {
        "attribute_mapping": {
          "subtitle": "Åsidosätt stödda SCIM-attributmål för den här anslutningen. Tomma rader använder backendens standardmappning.",
          "title": "Attributmappning"
        },
        "connection_settings": {
          "subtitle": "Hantera leverantör, namn och aktiverad status för den valda SCIM-anslutningen.",
          "title": "Anslutningsinställningar"
        },
        "connections": {
          "disabled": "Inaktiverad",
          "enabled": "Aktiverad",
          "subtitle": "Konfigurera identitetsleverantörsanslutningar för automatiserad SCIM-provisionering av användare och grupper.",
          "title": "SCIM-anslutningar"
        },
        "endpoint": {
          "label": "Tenant-URL",
          "subtitle": "Använd denna bas-URL i din identitetsleverantör. Lägg inte till Users, Groups eller ServiceProviderConfig i URL:en.",
          "title": "Provisioneringsendpoint"
        },
        "tokens": {
          "subtitle": "Skapa bearer-token för Microsoft Entra ID, Okta eller en annan SCIM v2-identitetsleverantör.",
          "title": "SCIM-provisioneringstoken"
        }
      },
      "subtitle": "Konfigurera dina arbetsyta inställningar.",
      "title": "Arbetsytans inställningar",
      "tokens": {
        "subtitle": "Åtkomst till Moxso-datalagret från dina appar och tjänster på ett säkert sätt.",
        "title": "Datavaruhus"
      },
      "user": {
        "two_factor_disabled": "Inaktiverad",
        "two_factor_enabled": "Aktiverad",
        "verification_required": "Verifiering väntar",
        "verified": "Verifierad"
      },
      "users": {
        "subtitle": "Hantera användare i din arbetsyta",
        "title": "Användare"
      }
    }
  },
  "simulations": {
    "audience_missing_phone_numbers_all": "Inga av de anställda i den valda målgruppen har telefonnummer. Vänligen ändra målgruppen eller lägg till telefonnummer och försök igen.",
    "audience_missing_phone_numbers_some": "En anställd av {total} i den valda målgruppen saknar ett telefonnummer. | {count} anställda av {total} i den valda målgruppen saknar telefonnummer.",
    "click_rate": {
      "title": "Klickfrekvens"
    },
    "clicked": "Klickad",
    "count": {
      "title": "Behandlade simuleringar",
      "unit": "Simulationer"
    },
    "create": {
      "button": "Skapa simulering",
      "configuration": {
        "choose_type": "Tillbaka",
        "text": "Definiera målgruppen och inställningarna för denna simulering.",
        "title": "Konfigurera din simulering",
        "token": "Ange en anpassad e-posthuvud för allowlistingändamål. Din token kommer att skickas som en {token} huvudinmatning på varje e-post som skickas från denna simulation."
      },
      "credential_harvest": {
        "description": "När aktiverad, kommer anställda enbart att få simulationer som inkluderar inloggningssidor. Moxso övervakar formulärinmatningar men lagrar aldrig några inmatade inloggningsuppgifter.",
        "enable_label": "Aktivera inhämtning av autentiseringsuppgifter",
        "title": "Credential harvest"
      },
      "delivery_rate": {
        "high": {
          "email_description": "1-2 veckor mellan e-postmeddelanden",
          "sms_description": "1-2 veckor mellan textmeddelanden",
          "title": "Hög"
        },
        "low": {
          "email_description": "1–6 veckor mellan e-postmeddelanden",
          "sms_description": "1-6 veckor mellan textmeddelanden",
          "title": "Låg"
        },
        "medium": {
          "email_description": "1-4 veckor mellan e-postmeddelanden",
          "sms_description": "1–4 veckor mellan textmeddelanden",
          "title": "Mellan"
        }
      },
      "help": {
        "audience": "Avgör vilken målgrupp som ska ta emot denna simulering.",
        "email_delivery_rate": "Definierar tiden mellan simuleringsmail. Frekvensen anpassas inom leveransområdets interval beroende på medarbetarens prestation.",
        "sms_delivery_rate": "Definierar tiden mellan simulerings-SMS. Frekvensen anpassar sig inom leveranshastighetsintervallet baserat på medarbetarens prestation.",
        "staggered_delivery": "Simuleringar levereras slumpmässigt på vardagar inom det valda antalet dagar.",
        "test": "Testsimuleringar påverkar inte användarens träningsregister eller rapporteringsstatistik."
      },
      "labels": {
        "audience": "Publik",
        "delivery_rate": "Leveranshastighet",
        "name": "Namn",
        "preview": "Förhandsgranska",
        "schedule_type": "Schema typ",
        "staggered_delivery": "Förskjuten leverans",
        "template": "Mall",
        "test": "Markera som testsimulering",
        "token": "Tecken",
        "token_header": "Ange en anpassad tokenrubrik för simulering",
        "use_template": "Använd anpassad mall"
      },
      "placeholders": {
        "audience": "Vänligen välj målgrupp",
        "name": "Simuleringsnamn",
        "token": "ABC-123"
      },
      "random_template": "Slumptemplate",
      "remove_template": "Ta bort mall",
      "step_current_of_last": "Steg {current_step} av {last_step}",
      "type": {
        "button": "Nästa",
        "email": {
          "text_plural": "Skicka simuleringar som e-post",
          "text_singular": "Skicka simulering som e-post",
          "title": "E-post"
        },
        "help": {
          "delivery_method": "Välj hur simuleringen ska levereras",
          "schedule_type": "Välj hur ofta denna simulering ska köras"
        },
        "labels": {
          "delivery_method": "Leveransmetod",
          "schedule_type": "Schema typ"
        },
        "one_off": {
          "text": "Alla attacker kommer att skickas när simuleringen startas",
          "title": "Simulering engångs"
        },
        "recurring": {
          "text": "Attacker kommer att skickas varje månad tills simuleringen avaktiveras.",
          "title": "Automatiserad simulering"
        },
        "sms": {
          "text_plural": "Skicka simuleringar som textmeddelanden",
          "text_singular": "Skicka simulering som ett textmeddelande",
          "title": "Textmeddelande"
        },
        "text": "Välj schema och leveransmetod för denna simulering.",
        "title": "Ställ in leverans av simulering"
      }
    },
    "delete": {
      "are_you_sure": "Är du säker på att du vill ta bort den här simuleringen? Den här åtgärden kan inte ångras.",
      "button": "Ta bort simulering",
      "simulation_deleted": "Simulering borttagen"
    },
    "details": {
      "heading": "Sammanfattning",
      "text": "Simuleringsöversikt"
    },
    "edit": {
      "button": "Redigera inställningar",
      "button_save": "Spara inställningar",
      "campaign_updated": "Simulering uppdaterad",
      "title": "Redigera simulering"
    },
    "filter": {
      "status": {
        "all": "Status: Alla",
        "click": "Status: Klickad",
        "report": "Status: Rapporterad",
        "submission": "Status: Inloggning"
      }
    },
    "launch": {
      "button": "Starta simulering",
      "input_label": "Ange det totala antalet mottagare",
      "launched": "Simulering startad",
      "no_recipients": "Den valda målgruppen har inga medlemmar. Justera målgruppen och försök igen.",
      "no_recipients_title": "Inga medlemmar",
      "title": "Starta simulering",
      "warning": "Du är på väg att starta en simulering som kommer att skickas till {count} mottagare. Är du säker på att du vill fortsätta?"
    },
    "opened": "Öppna",
    "pause": "Pausa simulering",
    "pause_confirmation": {
      "results": "Resultat från simuleringar som redan har skickats behålls.",
      "title": "Pausa simuleringen?",
      "warning": "När du pausar simuleringen avbryts {count} schemalagt utskick. När du återupptar den ersätter ett nytt schema de ursprungliga utskicksdatumen. Medarbetarna kan därför behöva vänta längre på sin nästa simulering. | När du pausar simuleringen avbryts {count} schemalagda utskick. När du återupptar den ersätter ett nytt schema de ursprungliga utskicksdatumen. Medarbetarna kan därför behöva vänta längre på sin nästa simulering."
    },
    "play": "Återuppta simulering",
    "received": "Mottagen",
    "report_rate": {
      "title": "Rapporteringsfrekvens"
    },
    "reported": "Rapporterade",
    "scheduled": "Schemalagd",
    "send_test": "Skicka test",
    "send_test_tooltip": "Detta kommer att skicka ett testmail till {userEmail}",
    "staggered_delivery": {
      "days": "{count} dag | {count} dagar",
      "off": "Av"
    },
    "stop": {
      "button": "Stoppa simulering",
      "simulation_stopped": "Simulering stoppad",
      "title": "Stoppa simuleringen?",
      "warning": "Om du stoppar simuleringen avbryts alla återstående schemalagda leveranser. Resultat från simuleringar som redan har skickats behålls. Är du säker på att du vill fortsätta?"
    },
    "submission_disabled": "Inaktiverad",
    "submission_enabled": "Aktiverad",
    "submission_rate": {
      "title": "Inloggningsfrekvens"
    },
    "submitted": "Logga in",
    "summary": {
      "credential_harvest": "Uppsamling av inloggningsuppgifter",
      "delivery_method": "Leveransmetod",
      "delivery_rate": "Leveransfrekvens",
      "group": "Publik",
      "schedule_type": "Schematyp",
      "staggered_delivery": "Förskjuten leverans",
      "test": "Testsimulering",
      "type": "Typ"
    },
    "templates": {
      "create": {
        "button": "Skapa mall",
        "success_text": "Mall skapad",
        "title": "Skapa simuleringsmall"
      },
      "duplicate": {
        "button": "Duplicera",
        "subject": "Kopia",
        "success_text": "Mall duplicerad",
        "title": "Duplicera simuleringsmall"
      },
      "edit": {
        "button": "Spara mall",
        "success_text": "Mallen sparad",
        "title": "Redigera simuleringsmall"
      },
      "editor": {
        "ai_modal": {
          "button": "Generera",
          "placeholder": "Beskriv den simuleringsmall du vill skapa...",
          "title": "Generera mall med AI"
        },
        "attack_link": "Angreppslänk",
        "attack_link_already_applied": "Angreppslänkar används automatiskt på knappar.",
        "buttons": {
          "generate": "Generera",
          "send_preview": "Skicka mig en förhandsvisning"
        },
        "change_image": "Byt bild",
        "default_block_content": {
          "button": "Granska nu",
          "container_text": "Lägg till ditt innehåll här.",
          "footer_text": "Du får det här e-postmeddelandet eftersom du är anställd hos ::workspace.name::.",
          "heading_1": "Rubrik 1",
          "heading_2": "Rubrik 2",
          "heading_3": "Rubrik 3",
          "image_alt": "Bild",
          "text": "Skriv ditt meddelande här.",
          "unsubscribe": "Avregistrera"
        },
        "generating_template": "Genererar mall",
        "google_dmi_enabled": "Direct message injection är aktiverat",
        "insert_image": "Infoga bild",
        "labels": {
          "custom_domain": "Anpassad domän",
          "email": "E-post",
          "select_domain": "Välj en domän",
          "sender": "Avsändare",
          "string_templates": {
            "date_last_month": "Samma dag förra månaden",
            "date_last_week": "Samma dag förra veckan",
            "date_last_year": "Samma dag förra året",
            "date_next_month": "Samma dag nästa månad",
            "date_next_week": "Samma dag nästa vecka",
            "date_next_year": "Samma dag nästa år",
            "date_today": "Idag",
            "date_tomorrow": "Imorgon",
            "date_yesterday": "Igår",
            "department": "Avdelning",
            "email": "E-post",
            "first_name": "Förnamn",
            "last_name": "Efternamn",
            "manager_email": "Manager e-post",
            "manager_first_name": "Manager förnamn",
            "manager_last_name": "Manager efternamn",
            "workspace_address": "Företagsadress",
            "workspace_city": "Företagsstad",
            "workspace_name": "Företagsnamn",
            "workspace_postal_code": "Företagets postnummer"
          },
          "subject": "Ämne"
        },
        "no_image_selected": "Ingen bild vald",
        "placeholders": {
          "custom_domain": "example.com",
          "email": "Avsändarens namn",
          "sender_name": "Alice Smith",
          "subject": "Ange ämne här"
        },
        "preview_sent_success": "Förhandsgranskningsmail skickat framgångsrikt.",
        "qr_code": "QR-kod",
        "sidebar": {
          "blocks": "Block",
          "no_tags_found": "Inga taggar hittades",
          "settings": "Inställningar",
          "settings_title": "Inställningar för valt block",
          "style": "Design",
          "style_title": "Malldesign",
          "tags": "Taggar",
          "variables_title": "Sammanslagningsfält"
        },
        "sidebar_field_options": {
          "center": "Centrerad",
          "fixed": "Fast bredd",
          "full_width": "Full bredd",
          "left": "Vänster",
          "right": "Höger"
        },
        "sidebar_fields": {
          "alt_text": "Alt-text",
          "auto": "Automatiskt",
          "background_color": "Bakgrundsfärg",
          "border_radius": "Hörnradie",
          "button_dimensions_hint": "Måtten anges i pixlar. Sätt bredd eller höjd till 0 för att anpassa till texten.",
          "button_min_height": "Minsta höjd",
          "color": "Färg",
          "columns": "Kolumner",
          "content_alignment": "Justering",
          "content_width_mode": "Bredd",
          "font_size": "Teckenstorlek",
          "gap": "Mellanrum",
          "height": "Höjd",
          "image_url": "Bild",
          "padding": "Utfyllnad",
          "text_color": "Textfärg",
          "thickness": "Tjocklek",
          "width": "Bredd"
        },
        "sidebar_placeholders": {
          "alt_text": "Describe the image",
          "button_label": "Review now",
          "legal_copy": "You are receiving this email because you are an employee of ::workspace.name::."
        },
        "tooltip_fill_out_all_fields": "Fyll i alla fält för att skicka en förhandsvisning",
        "tooltip_this_will_save_the_template": "Detta kommer att spara mallen",
        "unsaved_changes": {
          "confirm_exit": "Du har osparade ändringar. Är du säker på att du vill avsluta?",
          "description": "Du har osparade ändringar. Om du lämnar sidan utan att spara går dina ändringar förlorade.",
          "discard": "Kassera ändringar",
          "save_and_exit": "Spara och lämna",
          "subtile": "Spara innan du lämnar sidan?",
          "title": "Osparade ändringar"
        },
        "unsaved_changes_badge": "Osparade ändringar"
      }
    },
    "test_sent": "Testmeddelande skickat till {userEmail}",
    "tooltip": {
      "click": "En länk klickades på",
      "open": "Denna simulering öppnades",
      "report": "Simuleringen rapporterades",
      "submit": "Ett inloggningsförsök gjordes"
    },
    "updated": "Simulering uppdaterad"
  },
  "statistics": {
    "activities_by_type": {
      "completed_courses": "Avslutade kurser",
      "phishing_quiz_correct_answers": "Korrekt svar på nätfiskequiz",
      "phishing_quiz_incorrect_answers": "Felaktiga svar i nätfiskequiz",
      "quiz_answers": "Quizsvar",
      "quiz_correct_answers": "Korrekt svar på quiz",
      "quiz_incorrect_answers": "Felaktiga svar på quiz",
      "simulations_delivered": "Simuleringar levererade",
      "simulations_failed": "Misslyckade simuleringar",
      "simulations_passed": "Godkända simuleringar",
      "simulations_reported": "Rapporterade simuleringar",
      "text": "Hur dina anställda tränar",
      "threats_reported": "Rapporterade hot",
      "title": "Avslutade aktiviteter",
      "videos_watched": "Videor sedda"
    },
    "benchmarks": {
      "above_benchmark_tooltip": "Värdet är över riktmärket.",
      "average": "Nätverksgenomsnitt",
      "below_benchmark_tooltip": "Värdet är under riktmärket.",
      "benchmark_tooltip": "Riktmärke",
      "peer_avg": "Jämförelsegrupp snitt.",
      "score": "Aktuell poäng",
      "text_higher": "% bättre än jämförbara företag",
      "text_lower": "% lägre än jämförbara företag",
      "title": "Prestandatest"
    },
    "breaches": {
      "title": "Överträdelser"
    },
    "competence": {
      "text": "Hur väl dina medarbetare presterar i sin utbildning",
      "title": "Kompetens"
    },
    "culture": {
      "text": "Hur engagerade dina anställda är i deras säkerhetsutbildning",
      "title": "Kultur"
    },
    "employee_activity": {
      "title": "Medarbetares aktivitet"
    },
    "employees": {
      "title": "Aktiva anställda"
    },
    "onboarding": {
      "title": "Introduktion"
    },
    "overdue": {
      "change": "{points} procentenheter jämfört med {date}",
      "security_program_text": "Andel medarbetare som inte följer sitt säkerhetsprogram (utbildning, policyer)",
      "security_program_title": "Medarbetare som ligger efter med säkerhetsprogrammet",
      "text": "Andel aktiva anställda med missade utbildningsdeadlines",
      "title": "Missade deadlines",
      "unit": "Försenade tidsfrister"
    },
    "recent_activity": "Senaste aktivitet",
    "resilience_score": {
      "change_last_90_days": "{value}% de senaste 90 dagarna",
      "text": "Beräknat poäng baserat på hur alla aktiva anställda tränar och presterar i simuleringar.",
      "title": "Aktuell motståndskraftspoäng"
    },
    "resilience_score_progression": {
      "title": "Motståndskraftpoäng över tid"
    },
    "risk_level": {
      "country": "Land",
      "text": "Risknivån bestäms av land, organisation och en syntetiserad risknivå, vilket ger insikt i det aktuella hotlandskapet.",
      "title": "Risknivå",
      "workspace": "Arbetsyta"
    },
    "show_more": "Visa mer",
    "simulation_coverage": {
      "title": "Simuleringsomfattning"
    },
    "simulations": {
      "campaign_overview": "Kampanjöversikt",
      "click_count": {
        "text": "Antal gånger en simulering har klickats på.",
        "title": "Totala klick",
        "unit": "Klickar"
      },
      "click_rate": {
        "text": "Beräknat betyg baserat på procentandelen anställda som har klickat på en länk i en simulering.",
        "title": "Klickfrekvens",
        "unit": "%"
      },
      "count": {
        "text": "Totalt antal simuleringar skickade.",
        "title": "Simuleringar skickade",
        "unit": "Simuleringar"
      },
      "performance_metrics": "Prestandamått",
      "reporting_count": {
        "text": "Totalt antal rapporterade simuleringar",
        "title": "Totalt antal rapporter",
        "unit": "Rapporter"
      },
      "reporting_rate": {
        "text": "Beräknat resultat baserat på procentandelen anställda som har rapporterat en simulering.",
        "title": "Rapporteringsfrekvens",
        "unit": "%"
      },
      "submission_count": {
        "text": "Totalt antal inskickade simuleringar.",
        "title": "Totalt antal inskickade",
        "unit": "Inlämningar"
      },
      "submission_rate": {
        "text": "Beräknat resultat baserat på procentandelen anställda som har loggat in på en simulering.",
        "title": "Inloggningsfrekvens",
        "unit": "procent"
      },
      "submission_sent_count": "Totalt antal inskickade bidrag"
    },
    "simulations_sent": {
      "title": "Simuleringar skickade"
    },
    "threats": {
      "count": {
        "text": "Antal hot som rapporterats av anställda.",
        "title": "Rapporterade hot"
      },
      "fraud_count": {
        "text": "Antal rapporterade bedrägliga hot av anställda.",
        "title": "Bedrägliga hot"
      },
      "handle_rate": {
        "text": "Beräknat resultat baserat på andelen hot som har hanterats av en administratör.",
        "title": "Hot hanteringshastighet"
      },
      "reporting_rate": {
        "title": "Rapporterade hot"
      },
      "status_partition": {
        "title": "Hotstatus"
      },
      "text": "Hur väl dina anställda agerar på hot",
      "time_to_handle": {
        "text": "Den genomsnittliga tiden det tar för dina anställda att hantera ett hot.",
        "title": "Hanteringstid"
      },
      "title": "Hotdetektering"
    },
    "timeframe_nienty_days": "Under de senaste 90 dagarna",
    "training": {
      "courses": {
        "title": "Kurser",
        "unit": "Kurser genomförda"
      },
      "phishing_quizzes": {
        "title": "Fisketestfrågesporter"
      },
      "quizzes": {
        "title": "Frågesporter"
      },
      "video_quizzes": {
        "title": "Videofrågesporter"
      },
      "videos": {
        "title": "Videor",
        "unit": "Videor slutförda"
      }
    },
    "training_coverage": {
      "text": "Beräknat resultat baserat på procentandelen anställda som har slutfört säkerhetsutbildningen.",
      "title": "Träningsomfattning"
    }
  },
  "tables": {
    "anonymized_at": "Anonymiserad vid",
    "audience": "Publik",
    "audit_completed_status": "Bekräftad den",
    "available_at": "Tillgänglig vid",
    "breached_at": "Skapelsedatum",
    "completed_at": "Slutförd den",
    "created": "Skapad",
    "created_at": "Skapad den",
    "deadlines": {
      "deadline": "Deadline",
      "employee": "Anställd",
      "last_learning_interaction": "Senaste interaktion",
      "lesson": "Lektion",
      "reminder_sent": "Senaste påminnelse"
    },
    "delivery_method": "Leveransmetod",
    "domain": "Domän",
    "employee": "Anställd",
    "employees": "Anställda",
    "enrolled_at": "Inskriven vid",
    "error_count": "Hoppa över",
    "filters": {
      "back": "Tillbaka",
      "boolean": "{column} är {toggle}",
      "data": "Filtrera data",
      "false": "Falskt",
      "filter_by": "Filtrera efter",
      "group": "Filtrera efter grupp",
      "numberRange": "{column} från {minValue} till {maxValue}",
      "search": "Sök",
      "select_date": "Välj datum",
      "status": "Status",
      "training_type": "Typ",
      "true": "Sant"
    },
    "group": "Grupp",
    "groups": "Grupper",
    "invited": "Inbjuden",
    "languages": "Språk",
    "last_sent_at": "Senast skickat",
    "lesson_status": "Lektionsstatus",
    "locale": "Språk",
    "name": "Namn",
    "overdue": "Förfallen",
    "published_at": "Publicerad den",
    "report_count": "Antal rapporter",
    "reports": "Rapporter",
    "scheduled_at": "Schemalagt till",
    "score": "Poäng",
    "sensitivity": "Känslighetsnivå",
    "sent_to_count": "Attacker",
    "status": "Status",
    "synced_count": "Synkroniserad",
    "title": "Titel",
    "unique_click_count": "Klickar",
    "unique_submission_count": "Inloggningar",
    "updated_at": "Uppdaterad den"
  },
  "threats": {
    "analysis": {
      "attachments": {
        "files": "Filer",
        "subtitle": "E-postbilagor",
        "title": "Bilagor"
      },
      "indicators": {
        "common": {
          "heading": "Vanliga hot",
          "help": "E-postinnehållet nämner företagsnamn som vanligtvis används i nätfiske."
        },
        "credentials": {
          "heading": "Referenser",
          "help": "E-postinnehållet nämner autentiseringsuppgifter eller lösenord."
        },
        "detected": "Upptäckt",
        "homoglyphs": {
          "heading": "Homoglyfer",
          "help": "Avsändarnamnet eller e-posten innehåller homoglypher."
        },
        "inconsistency": {
          "heading": "Inkonsekvens",
          "help": "Inkonsekvenser i länkar och/eller avsändarinformation."
        },
        "no_data": "Inga data",
        "not_detected": "Inte upptäckt",
        "subtitle": "Hotindikatorer",
        "title": "Indikatorer",
        "urgency": {
          "heading": "Brådskande",
          "help": "Brådska används för att pressa mottagaren att vidta åtgärder."
        }
      },
      "links": {
        "button": "Webbläsarisolering",
        "empty": "Inga länkar hittades",
        "showing_links": "Visar {shown} av {total} länkar",
        "subtitle": "Länkar funna i e-postmeddelande",
        "title": "Länkar"
      },
      "preview": {
        "not_available": {
          "description": "Det var inte möjligt för oss att skapa en förhandsgranskning av detta mejl.",
          "title": "Ingen bildförhandsvisning tillgänglig"
        },
        "subtitle": "E-postförhandsgranskning",
        "title": "Förhandsgranskning"
      },
      "sender": {
        "domain": "Domän",
        "email": "E-post",
        "empty": "Ingen avsändaranalys hittades",
        "ip": "IP-adress",
        "mx": "DNS MX-poster",
        "subtitle": "Avsändaranalys",
        "title": "Avsändare",
        "type": "Typ",
        "type_text": {
          "free": "Kostnadsfri tjänst",
          "paid": "Betald tjänst"
        }
      }
    },
    "anonymized": {
      "title": "Anonymiserat hot"
    },
    "browser_isolation": {
      "button": "Öppna länken i webbläsarens isolering",
      "copied": "Kopierat till urklipp",
      "heading": "Webbläsarisolering",
      "host": "Värd",
      "notice": "BrowserLing är en tredjepartstjänst som tillhandahåller en säker miljö för att öppna länkar. Genom att klicka på knappen nedan kommer du att omdirigeras till BrowserLing-webbplatsen. Moxso är inte anslutet till BrowserLing och kan inte hållas ansvarigt för något innehåll eller aktivitet som sker på BrowserLing-webbplatsen.",
      "path": "Sökväg",
      "scheme": "Schemat",
      "secured_by": "Skyddad av BrowserLing"
    },
    "buttons": {
      "delete": "Ta bort hot",
      "download_html": "Ladda ner HTML",
      "fraudulent": "Bedräglig",
      "legitimate": "Legitimt",
      "mark_as_fraudulent": "Markera som bedräglig",
      "mark_as_legitimate": "Markera som legitim",
      "mark_as_spam": "Markera som skräppost",
      "notify_reporters": "Meddela reportrar",
      "notify_reporters_description": "Meddela rapportörer om statusändringen av deras rapporter.",
      "show_headers": "Visa e-posthuvuden",
      "show_less": "Visa mindre",
      "show_more": "Visa mer",
      "spam": "Skräppost"
    },
    "comment_added": "Kommentar tillagd",
    "created_at": "Skapad den",
    "current": "Aktuell",
    "disabled": {
      "button": "Gå till inställningar",
      "heading": "Hantera hot är inaktiverat",
      "text": "Ge dina anställda ett säkert sätt att informera dig och vidta åtgärder mot potentiella hot som lurar i deras e-postinkorgar, vilket skyddar organisationens integritet dagligen. Ligg steget före alla potentiella skador."
    },
    "export_csv": {
      "description": "Nedladdningen inkluderar endast hot med den valda statusen i CSV-exporten.",
      "subtitle": "Välj hotstatus",
      "title": "Ladda ner CSV"
    },
    "filter": {
      "status": {
        "all": "Status: Alla",
        "forwarded": "Status: Vidarebefordrad",
        "fraudulent": "Status: Bedräglig",
        "legitimate": "Status: Legitimt",
        "spam": "Status: Spam",
        "unhandled": "Status: Ohanterad"
      }
    },
    "forwarding_enabled": "Vidarebefordran aktiverad",
    "forwarding_warning": "Rapporterade hot är skrivskyddade och måste hanteras i ett externt system.",
    "from": "Från",
    "headers": "Rubriker",
    "mark_as": "Markera som:",
    "no_more_unhandled_threats_button": "Stäng",
    "no_more_unhandled_threats_text": "Du har granskat alla rapporterade hot. Din inkorg är nu säker.",
    "no_more_unhandled_threats_title": "Faran över!",
    "note_placeholder": "Lägg till en anteckning till rapportörerna...",
    "related_threats": "Relaterade hot",
    "relative_time": {
      "days_ago": "{count} dag sedan | {count} dagar sedan",
      "hours_ago": "{count} timme sedan | {count} timmar sedan",
      "minutes_ago": "{count} minut sedan | {count} minuter sedan"
    },
    "report_information": "Rapportinformation",
    "reported_by": "Rapporterat av: {name}",
    "reports": {
      "clicked_link_warning": "Klickade på en länk",
      "phishing": "Phishing",
      "reported_as_phishing": "Rapporterat som phishing",
      "reported_as_spam": "Rapporterat som skräppost",
      "reporter_note": "Rapportörens anteckning",
      "spam": "Skräppost"
    },
    "review_next_threat_button": "Granska nästa hot",
    "review_next_threat_text": "Vill du granska nästa obehandlade hot?",
    "status_updated": "Status uppdaterad",
    "subject": "Ämne",
    "this_threat_has_been_forwarded": "Detta hot har vidarebefordrats till ett externt system. Ingen analys har genomförts.",
    "timeline": {
      "analysis_completed": "Analys genomförd",
      "button": "Spara",
      "status_transition": "Status övergången från {from} till {to}",
      "textarea_placeholder": "Lägg till en kommentar...",
      "title": "Aktivitet"
    },
    "transition_description": "Bekräfta vilka rapporter som får denna status.",
    "x_of_n_selected": "{x} av {n} valda"
  },
  "titles": {
    "automations": {
      "subtitle": "Automatiserade träningssekvenser",
      "title": "Automatisering"
    },
    "breaches": {
      "subtitle": "Upptäck dataintrången i din arbetsyta.",
      "title": "Brott"
    },
    "dashboard": {
      "subtitle": "Översikt över din arbetsyta.",
      "title": "Översikt"
    },
    "group": {
      "subtitle": "En aktiv gruppmedlem. | {count} aktiva gruppmedlemmar."
    },
    "groups": {
      "subtitle": "Ordna dina anställda tillsammans i grupper.",
      "title": "Grupper"
    },
    "integrations": {
      "subtitle": "Översikt över integrationer",
      "title": "Integrationer"
    },
    "resilience": {
      "subtitle": "Översikt över er organisations motståndskraft.",
      "title": "Motståndskraft"
    },
    "simulations": {
      "custom_templates": {
        "subtitle": "Översikt över alla dina anpassade mallar",
        "title": "Anpassade mallar"
      },
      "subtitle": "Simulera nätfiskeförsök på ditt team.",
      "title": "Simuleringar"
    },
    "team": {
      "subtitle": "Alla anställda som för närvarande finns i ditt arbetsutrymme.",
      "title": "Anställda"
    },
    "threat": {
      "title": "Hotrapport"
    },
    "threats": {
      "subtitle": "Översikt över alla hot och deras status",
      "title": "Hot"
    },
    "training": {
      "course": {
        "subtitle": "Översikt över alla kurser",
        "title": "Kurser"
      },
      "course_overview": {
        "title": "Kursöversikt"
      },
      "deadlines": {
        "subtitle": "Översikt över deadlines",
        "title": "Tidsfrister"
      },
      "participation": {
        "subtitle": "Översikt av utbildningsdeltagande",
        "title": "Deltagandeöversikt"
      },
      "subtitle": "Översikt av din organisations utbildning",
      "title": "E-lärande",
      "video": {
        "subtitle": "Översikt över alla videor",
        "title": "Videor"
      },
      "video_overview": {
        "title": "Videoöversikt"
      }
    }
  },
  "training": {
    "actions": {
      "edit": "Redigera",
      "edit_categories": "Redigera kategorier",
      "save": "Spara"
    },
    "completed_status": {
      "completed": "Slutförd",
      "not_completed": "Inte slutförd"
    },
    "courses": {
      "actions": {
        "collapse_all": "Fäll ihop alla",
        "delete_course": "Ta bort kurs",
        "edit": "Redigera",
        "edit_categories": "Redigera kategorier",
        "edit_course": "Redigera kurs",
        "expand_all": "Expandera alla",
        "preview_course": "Förhandsgranska kurs",
        "save": "Spara"
      },
      "add_step": {
        "quiz": "Frågesportens innehåll",
        "text": "Innehåll för text",
        "video": "Videoinnehåll"
      },
      "create": {
        "button": "Skapa kurs"
      },
      "create_button": "Skapa kurs",
      "create_success": "Kursen har skapats framgångsrikt",
      "create_title": "Skapa ny kurs",
      "default_language_badge": "Standard",
      "default_language_label": "Standardspråk",
      "default_language_placeholder": "Välj standardspråk",
      "delete": {
        "are_you_sure": "Är du säker på att du vill ta bort detta steg? Denna åtgärd kan inte ångras.",
        "course_are_you_sure": "Är du säker på att du vill ta bort den här kursen? All obligatorisk utbildning och alla poäng som är kopplade till kursen kommer också att tas bort. Den här åtgärden kan inte ångras.",
        "translation_are_you_sure": "Är du säker på att du vill ta bort den här översättningen? Den här åtgärden kan inte ångras."
      },
      "details": {
        "heading": "Detaljer"
      },
      "edit_name_dialog": {
        "save": "Spara titel",
        "title": "Redigera kurstitel"
      },
      "errors": {
        "select_category": "Välj minst en kategori",
        "select_locale": "Vänligen välj minst ett språk"
      },
      "form": {
        "labels": {
          "categories": "Kategorier",
          "risk_categories": "Kategorier",
          "title": "Titel"
        },
        "placeholders": {
          "categories": "Välj kategorier",
          "title": "Ange titel"
        }
      },
      "labels": {
        "categories": "Kategori | Kategorier",
        "no_categories": "Inga kategorier"
      },
      "language_card": {
        "add_language": "Lägg till språk",
        "editing": "Redigerar",
        "select_language": "Välj ett språk",
        "switch": "Byt",
        "translate_with_ai": "Översätt med AI"
      },
      "navigation": {
        "course": "Kurs",
        "participants": "Deltagare"
      },
      "notifications": {
        "course_deleted": "Kurs raderad",
        "name_updated": "Kurstiteln uppdaterad",
        "saved": "Sparad",
        "settings_saved": "Ändringar sparade",
        "step_deleted": "Steg borttaget"
      },
      "preview": "Förhandsvisning",
      "publish": "Publicera kurs",
      "publish_confirm": "Ja, publicera kurs",
      "publish_confirm_description": "Är du säker på att du vill publicera den här kursen? Den kan inte bli opublicerad och kommer att visas i hubben omedelbart.",
      "publish_success": "Kurs publicerad",
      "quiz_editor": {
        "actions": {
          "cancel": "Avbryt",
          "save": "Spara"
        },
        "ai_prompt": {
          "button": "AI-uppmaning",
          "generate": "Generera",
          "no_previous_steps": "Lägg till en video- eller textsteg tidigare i kursen för att använda som kontext.",
          "placeholder": "Anpassade instruktioner",
          "select_helper": "Välj steg",
          "select_label": "Använd befintligt innehåll, en skriven uppmaning eller båda för att generera nya frågor.",
          "step_number": "Steg {order}",
          "step_type": {
            "quiz": "Frågesport",
            "text": "Träningen omfattar olika typer av frågor inklusive flervalsfrågor, fyll i luckorna och utvecklingsfrågor. Lägg till en förklarande text som hjälper deltagarna att förstå uppgiften för varje kurs. Ange instruktioner i fältet {'@'}förklarande{'@'} text{'} inklusive specifika detaljer om frågan eller ämnet.",
            "video": "Video"
          },
          "title": "Lägg till frågor med AI",
          "untitled": "Oskrift"
        },
        "heading": {
          "description": "Frågesport",
          "title": "Steg {step}"
        },
        "select_action": {
          "ai": {
            "description": "Låt AI automatiskt generera quizfrågor från ditt befintliga innehåll i denna kurs.",
            "title": "AI generera från innehåll"
          },
          "manual": {
            "description": "Bygg din egen quiz från grunden genom att lägga till frågor och svar manuellt.",
            "title": "Skapa quiz manuellt"
          }
        }
      },
      "select_languages_description": "Välj de språk du vill inkludera i ditt kursinnehåll.",
      "set_current_language_as_default": "Ange som standard",
      "settings": {
        "edit_description": "Redigera kursbeskrivning",
        "save": "Spara"
      },
      "status": {
        "draft": "Utkast",
        "missing_content_warning": "Kursen saknar innehåll på ett eller flera språk",
        "published": "Publicerad"
      },
      "steps": {
        "empty": {
          "description": "Klicka på redigeringsknappen ovan för att lägga till innehåll",
          "title": "Tomt steg"
        },
        "intro": "Introduktion",
        "knowledge_check": "Kunskapskontroll",
        "missing_translation": "Översättning saknas för denna platsinställning",
        "quiz": "Frågesport",
        "text": "Träning",
        "video": "Video"
      },
      "tabs": {
        "course": "Kurs",
        "participants": "Deltagare"
      },
      "text_editor": {
        "actions": {
          "cancel": "Avbryt",
          "edit": "Redigera",
          "save": "Spara"
        },
        "ai_prompt": {
          "button": "Textredigerare AI-knapp",
          "generate": "Generera",
          "label": "Beskriv vad du vill att AI:n ska göra",
          "placeholder": "\"Hjälp mig att göra texten mer formell\"",
          "title": "Generera textkort med AI"
        },
        "ai_viewer": {
          "accept": "Acceptera",
          "back": "Avbryt",
          "caption": "Granska det AI-genererade innehållet och avgör om du vill acceptera eller återskapa det",
          "generating": "Genererar kursinnehåll",
          "heading": "Granska genererat innehåll"
        },
        "apply_image": {
          "button": "Tillämpa på andra språk",
          "has_image": "Har bild",
          "subtitle": "Välj språk att tillämpa den här bilden på",
          "title": "Använd bild på andra språk"
        },
        "course_title_badge": "Kurstitel",
        "heading": {
          "description": "Textredigerare",
          "title": "Steg {step}"
        },
        "labels": {
          "after": "Efter",
          "before": "Före",
          "excerpt": "Utdrag",
          "image_upload": "Bild",
          "remove_image": "Ta bort bild",
          "title": "Titel",
          "uploaded_image_alt": "Uppladdad bild"
        },
        "placeholders": {
          "content": "Ange ditt innehåll",
          "excerpt": "Ange ett utdrag",
          "title": "Ange en titel"
        },
        "title_linked_tooltip": "Används som titeln i kursens {language}-version."
      },
      "title_summary": {
        "course_title": "Kurstitel",
        "description": "Används som titeln i kursens {language}-version."
      },
      "translate": {
        "open": "Översätt kurs",
        "submit": "Träna",
        "title": "Översätt kurs"
      },
      "translate_success": "Kurs översatt.",
      "translation_list_label": "Översättning | Översättningar",
      "unpublish": "Avpublicera kurs",
      "unpublish_confirm": "Ja, avpublicera kurs",
      "unpublish_confirm_description": "Är du säker på att du vill avpublicera den här kursen? Den försvinner från hubben direkt.",
      "unpublish_success": "Kurs avpublicerad",
      "untitled": "Oanmäld",
      "validation": {
        "content_missing_in_languages": "Innehåll saknas i ett språk | Innehåll saknas i {count} språk",
        "missing_content": "Saknat innehåll",
        "missing_excerpt": "Saknat utdrag",
        "missing_image": "Saknad bild",
        "missing_questions": "Saknade frågor",
        "missing_title": "Saknas titel",
        "options_missing_text": "Vissa alternativ saknar text",
        "questions_missing_correct_options": "Vissa frågor saknar korrekta alternativ",
        "questions_missing_text": "Vissa frågor saknar text",
        "step_issues": "Stegproblem"
      },
      "video_editor": {
        "empty_search": {
          "description": "Försök att förbättra dina sökord eller rensa sökningen för att se alla videor.",
          "title": "Inga videor matchar din sökning"
        },
        "empty_state": {
          "description": "Det här steget är tomt. Klicka på redigeringsknappen ovan för att lägga till innehåll."
        },
        "fallback_translation_tooltip": "Den här videon använder en reservöversättning",
        "search_placeholder": "Sök videor",
        "selected": {
          "button": "Ändra video",
          "title": "VIDEO"
        },
        "subtitle": "Välj en video att lägga till i detta steg.",
        "title": "Välj video"
      }
    },
    "custom_uploads": {
      "subtitle": "Videor skapade av din organisation",
      "title": "Anpassade uppladdningar",
      "video": {
        "badges": {
          "quiz": "Quiz",
          "video": "Video"
        },
        "create": {
          "create_video": "Skapa video",
          "next_steps_text": "Fyll i informationen nedan för att ställa in din video. Efter att ha skapat videon kommer du att tas till videosidan, där du kan välja denna översättning och ladda upp en videofil.",
          "video_created": "Video skapad"
        },
        "delete": {
          "are_you_sure": "Är du säker på att du vill radera den här videon? Den här åtgärden kan inte ångras.",
          "button": "Ta bort",
          "video_deleted": "Video raderad"
        },
        "form": {
          "labels": {
            "categories": "Kategorier",
            "description": "Beskrivning",
            "language": "Språk",
            "title": "Titel"
          },
          "placeholders": {
            "categories": "Välj kategorier",
            "description": "Ange en beskrivning",
            "language": "Välj språk",
            "title": "Ange en titel"
          }
        },
        "publish": "Publicera",
        "publish_confirm": "Publicera",
        "publish_confirm_description": "Att publicera gör den här videon tillgänglig i navet och användbar över hela plattformen.",
        "publish_success": "Videon publicerad",
        "publish_unavailable": "Ladda upp videor för alla översättningar innan publicering.",
        "quiz": {
          "available_quizzes": "Tillgängliga frågor",
          "create": "Skapa",
          "edit": "Redigera",
          "quiz_deleted": "Quiz borttagen",
          "quiz_saved": "Quiz sparad",
          "quizzes": "Frågesporter",
          "quizzes_translated": "Quiz översatta."
        },
        "single": {
          "details": {
            "heading": "Detaljer",
            "text": "Videodetaljer"
          },
          "labels": {
            "categories": "Kategori | Kategorier",
            "created_at": "Skapad den",
            "published_at": "Publicerad den",
            "updated_at": "Uppdaterad den"
          },
          "title": "Anpassad video"
        },
        "status": {
          "draft": "Utkast",
          "published": "Publicerad"
        },
        "translations": {
          "add_translation": "Lägg till översättning",
          "ai": {
            "done_translate_button": "Klar",
            "processing_n_languages": "Bearbetar ett språk | Bearbetar {count} språk",
            "text": "Använd DeepL för att automatiskt översätta videons titel och beskrivning till ett valt språk.",
            "title": "Översätt videodetaljer med AI",
            "translate_button": "Översätt",
            "translating_your_video": "Översätter videodetaljer",
            "video_now_available_in": "Översättningar har skapats på ytterligare ett språk | Översättningar har skapats på {count} ytterligare språk",
            "video_translate_success": "Framgång!"
          },
          "available_translations": "Tillgängliga översättningar",
          "create_title": "Lägg till översättning",
          "default_badge": "Standard",
          "delete": "Radera",
          "delete_are_you_sure": "Är du säker på att du vill radera denna översättning? Denna åtgärd kan inte ångras.",
          "edit": "Redigera",
          "edit_translation": "Redigera översättning",
          "empty": "Inga översättningar för den här videon",
          "make_default": "Ange som standard",
          "manual": {
            "text": "Skriv om översättningen från grunden till ett nytt språk.",
            "title": "Översätt video manuellt"
          },
          "quiz": {
            "create": "Skapa quiz",
            "edit": "Redigera quiz",
            "other_translations_have_quizzes": "Andra översättningar har quizzer",
            "other_translations_have_quizzes_want_to_translate": "Andra översättningar har redan frågesporter. Vill du automatiskt översätta denna frågesport till de språken?",
            "some_translations_have_no_quizzes": "Vissa översättningar har för närvarande inga quiz. Översätt nu?",
            "this_translation_has_quizzes_in_other_languages_translate_automatically": "Denna översättning har frågesporter på andra språk. Översätt automatiskt?",
            "translate_quiz": "Översätt",
            "update_this_quiz_and_translate_others": "Uppdatera detta quiz och översätt andra quiz",
            "update_this_quiz_only": "Uppdatera endast den här quizzen"
          },
          "save_changes": "Spara ändringar",
          "single": {
            "edit": {
              "subtitle": "Uppdatera videodetaljerna",
              "title": "Videodetaljer"
            },
            "upload": {
              "subtitle": "Ladda upp videofil för den här översättningen.",
              "title": "Ladda upp video",
              "video_deleted": "Video borttagen",
              "video_uploaded": "Video uppladdad"
            }
          },
          "translation_added": "Översättning tillagd",
          "translation_deleted": "Översättning raderad",
          "translation_updated": "Översättning uppdaterad",
          "translations": "Översättningar",
          "video": "Video"
        },
        "unpublish": "Avpublicera",
        "unpublish_confirm": "Avpublicera",
        "unpublish_confirm_description": "Avpublicering kommer att dölja denna video från navet. Den kommer fortfarande att finnas tillgänglig i alla automationer där den redan används.",
        "unpublish_success": "Video avpublicerad"
      }
    },
    "deadlines": {
      "bulk_reminder_dialog_confirm": "Skicka {count} påminnelse | Skicka {count} påminnelser",
      "bulk_reminder_dialog_text": "Detta kommer att avisera {count} medarbetare. Varje medarbetare får en avisering, även om de har flera tilldelningar.",
      "bulk_reminder_dialog_title": "Skicka påminnelser till alla som matchar dina valda filter",
      "bulk_reminders_sent": "Påminnelser skickade",
      "delete_reminder": "Radera påminnelse",
      "participation_title": "Deltagande",
      "reminder_deleted": "Påminnelse raderad",
      "reminder_sent": "Påminnelse skickad",
      "send_bulk_reminder": "Skicka påminnelser till alla",
      "send_reminder": "Skicka påminnelse"
    },
    "default_language_updated": "Standardspråk uppdaterat",
    "default_translation_tooltip": "Det här är för närvarande standardspråket. Välj ett annat språk innan du tar bort det.",
    "errors": {
      "select_category": "Välj minst en kategori"
    },
    "filter": {
      "course": "Visa endast kurser",
      "video": "Visa endast videor"
    },
    "form": {
      "labels": {
        "categories": "Kategorier",
        "no_categories": "Inga kategorier"
      },
      "placeholders": {
        "categories": "Välj kategorier"
      }
    },
    "invited_status": {
      "invited": "Inbjuden",
      "not_invited": "Inte inbjuden"
    },
    "moxso_courses": {
      "description": "Kurser tillhandahållna av Moxso",
      "title": "Moxso-kurser"
    },
    "moxso_uploads": {
      "subtitle": "Videor tillhandahållna av Moxso",
      "title": "Moxso-videor"
    },
    "quiz": "Frågesport",
    "search_courses": {
      "description": "Sökresultat som matchar din förfrågan",
      "title": "Sökresultat"
    },
    "type": {
      "course": "Kurs",
      "user_course": "Användarkurs",
      "video": "Video"
    },
    "user_defined_courses": {
      "description": "Kurser skapade av din organisation",
      "title": "Användardefinierade kurser"
    }
  },
  "translations": {
    "ai": {
      "overwrite_existing_translations_text": "Detta kommer att ta bort de befintliga översättningarna och översätta dem från grunden.",
      "overwrite_existing_translations_title": "Skriv över befintliga översättningar",
      "select_languages_to_translate_item_into": "Välj de språk du vill generera översättningar för",
      "translate_from": "Översätt från"
    },
    "deepl_privacy": "DeepL:s sekretesspolicy",
    "deepl_text": "Detta kommer att skicka en kopia av din översättning till DeepL, en extern AI-driven översättningstjänst. Ditt innehåll kommer att behandlas externt, och {link} kommer att tillämpas.",
    "quizzes": {
      "done_translate_button": "Klar",
      "processing_n_languages": "Bearbetar ett språk | Bearbetar {count} språk",
      "quiz_now_available_in": "Ditt quiz är nu tillgängligt på ytterligare ett språk | Ditt quiz är nu tillgängligt på {count} ytterligare språk",
      "quiz_translate_success": "Framgång!",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Välj de språk du vill översätta ditt quiz till",
      "translate_button": "Översätt",
      "translate_from": "Översätt från",
      "translate_multiple_choice_quiz": "Översätt flervalsfrågesport",
      "translating_your_quiz": "Översätter din quiz"
    }
  },
  "two_factor_challenge": {
    "back_to_login": "Tillbaka till inloggning",
    "code": {
      "label": "Autentiseringskod",
      "placeholder": "123456"
    },
    "heading": "Tvåfaktorsautentisering",
    "recovery_code": {
      "label": "Återställningskod",
      "placeholder": "aaaaaaaaaa-bbbbbbbbbb"
    },
    "submit": "Verifiera",
    "text": "Ange en kod från din autentiseringsapp eller använd en återställningskod för att fortsätta.",
    "use_authenticator_code": "Använd en kod från autentiseringsapp",
    "use_recovery_code": "Använd en återställningskod"
  },
  "uploads": {
    "file_upload": {
      "click_to_upload": "Klicka för att ladda upp",
      "delete": {
        "are_you_sure": "Är du säker på att du vill ta bort den här filen? Den här åtgärden kan inte ångras.",
        "button": "Ta bort"
      },
      "file_upload_limit": "{fileType} · Upp till {fileSize} · {imageRatio} rekommenderas",
      "or_drag_and_drop": "{click} eller dra och släpp",
      "placeholder": "fil",
      "title": "Ladda upp fil",
      "up_to": "Upp till",
      "upload_failed": {
        "button": "Ladda upp ny",
        "subtitle": "Den angivna filen kunde inte laddas upp.",
        "title": "Överföringen misslyckades"
      },
      "upload_in_progress": {
        "processing_subtitle": "Uppladdning slutförd. Du kan tryggt lämna denna sida medan vi bearbetar den.",
        "processing_title": "Bearbetar din fil...",
        "uploading_subtitle": "Din fil laddas upp.",
        "uploading_title": "Laddar upp fil..."
      }
    },
    "image_upload": {
      "click_to_upload": "Klicka för att ladda upp",
      "delete": {
        "are_you_sure": "Är du säker på att du vill radera denna bild? Denna åtgärd kan inte ångras.",
        "button": "Radera"
      },
      "or_drag_and_drop": "eller dra och släpp",
      "upload_failed": {
        "button": "Ladda upp ny",
        "subtitle": "Den angivna filen kunde inte laddas upp.",
        "title": "Överföring misslyckades"
      },
      "upload_in_progress": {
        "processing_subtitle": "Uppladdning klar. Du kan lämna denna sida medan vi bearbetar den.",
        "processing_title": "Bearbetar din fil...",
        "uploading_subtitle": "Din fil laddas upp.",
        "uploading_title": "Laddar upp fil..."
      }
    },
    "video_upload": {
      "click_to_upload": "Klicka för att ladda upp",
      "delete": {
        "are_you_sure": "Är du säker på att du vill ta bort den här videon? Denna åtgärd kan inte ångras.",
        "button": "Ta bort"
      },
      "format": "MP4",
      "max": "Maximal",
      "or_drag_and_drop": "eller dra och släpp",
      "up_to": "Upp till",
      "upload_failed": {
        "button": "Ladda upp ny",
        "subtitle": "Den angivna filen kunde inte laddas upp.",
        "title": "Uppladdning misslyckades"
      },
      "upload_in_progress": {
        "processing_subtitle": "Uppladdningen är klar. Du kan säkert lämna den här sidan medan vi bearbetar den.",
        "processing_title": "Bearbetar din fil...",
        "uploading_title": "Laddar upp fil..."
      }
    }
  },
  "upsell": {
    "click_to_open": "Klicka för att läsa mer",
    "contact": "Meddela Customer Success",
    "knowledge_base": "Kunskapsbas",
    "learn_more": "Läs mer",
    "locked_feature": "Låst funktion",
    "notify_success": "Meddelande skickat till Customer Success",
    "upgrade_required": "Den här funktionen kräver en uppgradering"
  },
  "user_settings": {
    "subtitle": "Hantera säkerhetsinställningarna för ditt adminkonto.",
    "title": "Säkerhet och åtkomst"
  },
  "validate_domain": {
    "login": "Logga in",
    "success": "Domänen har verifierats framgångsrikt."
  },
  "videos": {
    "error": "Strömning är för närvarande otillgänglig"
  },
  "workspace_onboarding": {
    "invite_admins": {
      "form": {
        "button": "Bjud in administratör",
        "description": "Lägg till fler administratörer om andra också ska hjälpa till att äga uppsättningen eller administrera Moxso. Alla administratörer har samma åtkomst och ser samma ändringar.",
        "title": "Bjud in ytterligare en administratör"
      },
      "header": {
        "description": "Bestäm vem som ska ha administratörsåtkomst från start. Om fler än en person ska hantera cybersäkerhet eller Moxso, bjud in dem nu så att uppsättning och ägarskap delas från dag ett. Alla administratörer har samma åtkomst och ser samma ändringar.",
        "title": "Bjud in administratörer"
      },
      "intro": {
        "admin_added": "Du har redan mer än en administratör i den här arbetsytan.",
        "description": "En administratör kan fungera bra för mindre team, medan flera administratörer kan göra överlämning och samarbete enklare.",
        "eyebrow": "Rekommenderas före lansering",
        "recommendation": "Välj den uppsättning som passar ert team och bjud in fler administratörer om ägarskapet delas.",
        "title": "Dela administratörsåtkomst"
      },
      "list": {
        "added_on": "Tillagd den",
        "description": "Granska de administratörer som för närvarande har åtkomst till den här arbetsytan.",
        "title": "Arbetsytans administratörer",
        "you": "Du"
      }
    },
    "kick_off": {
      "complete": "Planera kickoff",
      "dates": {
        "description": "Planera era kickoffdatum",
        "locked": "Låst",
        "locked_description": "Slutför kraven ovan för att låsa upp planeringen.",
        "simulation": {
          "custom_date": "Anpassat datum",
          "custom_date_description": "Välj ett specifikt datum",
          "label": "Kickoffdatum för simulering",
          "one_week_before": "1 vecka före utbildningen",
          "recommended": "Rekommenderas"
        },
        "title": "Kickoffdatum",
        "training": {
          "description": "Medarbetarna får sin första utbildningsmodul den här dagen.",
          "label": "Kickoffdatum för utbildning",
          "placeholder": "Välj ett datum"
        }
      },
      "header": {
        "description": "Välj dagen då medarbetarna börjar sin säkerhetsutbildning. En inledande phishing-simulering körs i förväg för att mäta utgångsläget.",
        "title": "Planera kickoff"
      },
      "validation": {
        "description": "Slutför dessa steg innan du kan planera utbildningen.",
        "requirements_count": "{count} av {total} slutförda",
        "set_up": "Konfigurera",
        "title": "Validering av kickoff"
      }
    },
    "microsoft_manual_setup": {
      "junk": {
        "button": "Så kringgår du skräppostfilter",
        "heading": "Kringgå skräppostfilter",
        "text": "Den här guiden ger stegvisa instruktioner för att låta Moxso-e-post kringgå skräppostfilter."
      },
      "safe_links": {
        "button": "Så kringgår du Safe Links",
        "heading": "Kringgå Safe Links",
        "text": "Den här guiden ger stegvisa instruktioner för att låta Moxso-e-post kringgå Safe Links."
      },
      "spam": {
        "button": "Så kringgår du spamfilter",
        "heading": "Kringgå spamfilter",
        "text": "Den här guiden ger stegvisa instruktioner för att låta Moxso-e-post kringgå spamfilter."
      },
      "tenant_allow_block": {
        "button": "Så godkänner du Moxso via IP i Outlook",
        "heading": "Lägg till Moxso-IP-adresser i Tenant Allow/Block Lists",
        "text": "Den här guiden ger stegvisa instruktioner för att lägga till Moxso-IP-adresser i Tenant Allow/Block Lists i Microsoft Defender för att säkerställa korrekt e-postleverans."
      },
      "third_party": {
        "button": "Så lägger du till Moxso-IP-adresser och domäner i Microsoft Defender",
        "heading": "Lägg till Moxsos IP-adresser och domäner i Microsoft Defender",
        "text": "Den här guiden ger stegvisa instruktioner för att lägga till Moxsos IP-adresser och domäner i Third-Party Phishing Simulation-inställningarna i Microsoft Defender för att säkerställa korrekt e-posttestning och leverans."
      }
    },
    "onboarding_actions": {
      "back": "Tillbaka",
      "continue": "Fortsätt",
      "knowledge_base": "Kunskapsbas",
      "mark_as_completed": "Markera som slutförd",
      "skip": "Konfigurera senare"
    },
    "progress_badge": {
      "kick_off_planned": "Kickoff planerad",
      "simulation_date": "Startdatum för simulering",
      "training_start": "Startdatum för utbildning",
      "workspace_setup": "Inställning:"
    },
    "reporting_add_in": {
      "confirm_setup": {
        "description": "Om Moxso-pluginen är synlig i din inkorg kan medarbetare börja använda den för att rapportera misstänkta e-postmeddelanden direkt från sin inkorg.",
        "manage_later": "Se hur rapportering fungerar i {link}.",
        "subtitle": "Slutför guiden för din e-postleverantör och fortsätt när add-inen har distribuerats.",
        "this_guide": "den här guiden",
        "title": "Är Moxso-pluginen synlig i din inkorg?"
      },
      "continue_disabled_tooltip_text": "Välj en e-postleverantör för att fortsätta.",
      "follow_guide": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "title": "Följ guiden nedan"
      },
      "guide_picker": {
        "gmail": {
          "description": "Steg-för-steg-guide för att konfigurera reporting add-in i Gmail.",
          "title": "Gmail"
        },
        "outlook": {
          "description": "Steg-för-steg-guide för att konfigurera reporting add-in i Outlook.",
          "title": "Outlook"
        },
        "title": "Välj din e-postleverantör"
      },
      "header": {
        "description": "Konfigurera Moxso reporting add-in så att medarbetare snabbt kan rapportera misstänkta e-postmeddelanden direkt från sin inkorg som en del av sitt vanliga e-postflöde.",
        "title": "Konfigurera reporting add-in"
      }
    },
    "setup_provider": {
      "add_simulation": {
        "button": "Skapa simuleringsutkast",
        "continue_disabled_tooltip_text": "Konfigurera en phishing-simuleringskampanj för att fortsätta",
        "description": "Vi har skapat en phishing-simuleringskampanj baserad på din företagsprofil. Denna kampanj fungerar som en baslinje för att hjälpa dig identifiera förbättringsområden.",
        "description_cta": "Klicka på knappen nedan för att skapa simuleringen",
        "header": {
          "description": "Konfigurera en phishing-simuleringskampanj som skickar realistiska e-postmeddelanden löpande för att hjälpa anställda att träna på att upptäcka hot. Du kan justera kampanjinställningar och målgrupp efter att kampanjen har startat.",
          "title": "Konfigurera din första phishing-simulering"
        },
        "settings_card": {
          "Audience": "Målgrupp",
          "Credential harvest": "Credential harvest",
          "Delivery rate": "Leveransfrekvens",
          "Name": "Namn",
          "all_employees": "Alla anställda",
          "baseline_campaign": "Baslinjekampanj",
          "credential_harvest": "Aktiverad",
          "delivery_rate": "Medel"
        },
        "simulation_created": "Simuleringsutkast skapat",
        "subtitle": "Redo att starta",
        "title": "Rekommenderade inställningar"
      },
      "buttons": {
        "back": "Tillbaka",
        "continue": "Fortsätt"
      },
      "header": {
        "description": "Konfigurera en integration för att automatiskt synkronisera dina anställdas data med systemet. Detta håller anställdas uppgifter uppdaterade och tar bort behovet av manuella uppdateringar.",
        "title": "Konfigurera integrationer"
      },
      "integration": {
        "header": {
          "description": "Välj om du vill integrera med din HR-databas (identitetsleverantör) eller istället importera dina anställda manuellt genom en CSV-fil. Vi rekommenderar inte det manuella alternativet eftersom det inte låter systemet automatiskt synkronisera och uppdatera över tid (hålla koll på nya eller inaktiva användare).",
          "title": "Välj din identity provider"
        },
        "warning": "Ett administratörskonto med globala behörigheter krävs för att konfigurera synkronisering med Microsoft Entra ID eller Google Workspace."
      },
      "provider": {
        "csv_import": "CSV-import",
        "description": "Välj den plattform du använder för att hantera identiteter och anställda.",
        "employees": "Anställda",
        "google": "Google Workspace",
        "google_sync": "Google Sync",
        "microsoft": "Microsoft",
        "microsoft_sync": "Microsoft Entra ID",
        "okta": "Okta",
        "title": "Välj leverantör"
      },
      "recommendations": {
        "create_target_group": {
          "description": "Skapa en grupp med de anställda du vill rikta dig till för att enkelt kunna tilldela simuleringar och utbildning genom att välja gruppen direkt.",
          "title": "Skapa målgrupp"
        },
        "heading": {
          "description": "Följ dessa rekommenderade steg innan du importerar anställda data för att säkerställa att rätt data synkroniseras och dina anställda får bästa möjliga upplevelse. Även om det inte är obligatoriskt är dessa steg starkt rekommenderade.",
          "title": "Förbered för providerintegration"
        },
        "verify_language_settings": {
          "description": "Se till att anställdas språkinställningar är korrekta så att rätt språk synkroniseras till Moxso.",
          "title": "Verifiera språkinställningar"
        },
        "warning": "Se till att nya anställda alltid läggs till i de grupper som är synkroniserade med Moxso."
      },
      "saml_scim": {
        "header": {
          "description": "Konfigurera single sign-on och automatisk användarprovisionering. Slutför båda avsnitten nedan och fortsätt när din identitetsleverantör är ansluten.",
          "title": "Konfigurera SAML och SCIM"
        }
      },
      "setup_method": {
        "header": {
          "description": "Använd SAML och SCIM för säker inloggning och automatisk provisionering, eller anslut en leverantör med standardintegrationen.",
          "title": "Välj konfiguration"
        },
        "provider_integration": {
          "description": "Synkronisera anställda direkt från Microsoft Entra ID, Google Workspace, Slack eller en CSV-fil.",
          "title": "Standardintegration"
        },
        "recommended": "Rekommenderas",
        "saml_scim": {
          "description": "Aktivera single sign-on och automatisera användarprovisionering.",
          "title": "SAML och SCIM"
        }
      },
      "whitelisting": {
        "buttons": {
          "change_guides": "Byt guide",
          "confirm_whitelist": "Bekräfta allowlist",
          "manual": "Manuell",
          "test_whitelist": "Testa allowlist"
        },
        "continue_disabled_tooltip_text": "Bekräfta att allowlisting fungerar innan du fortsätter.",
        "follow_guide": {
          "gmail": "Gmail",
          "outlook": "Outlook",
          "title": "Följ guiden nedan"
        },
        "guide_picker": {
          "gmail": {
            "description": "Steg-för-steg-guide för att tillåta e-post i Gmail.",
            "title": "Gmail"
          },
          "outlook": {
            "description": "Steg-för-steg-guide för att tillåta e-post i Outlook.",
            "title": "Outlook"
          },
          "title": "Välj din e-postleverantör"
        },
        "header": {
          "description": "Konfigurera allowlisting av våra IP-adresser och domäner för att säkerställa att phishing-simuleringar levereras till anställdas inkorgar och inte blockeras av spamfilter.",
          "title": "Se till att meddelanden inte markeras som spam"
        },
        "send_test": {
          "buttons": {
            "no": "Nej, hjälp mig",
            "send_test": "Skicka testmail",
            "yes": "Ja, jag fick det"
          },
          "confirm": {
            "text": "Kontrollera din inkorg (och skräppostmappen).",
            "title": "Fick du e-postmeddelandet | Fick du e-postmeddelandena"
          },
          "description": "Skicka ett testmail för att bekräfta att det levereras till din inkorg på {email} (inte till skräppost). {try_a_few_times}, varje e-post använder olika innehåll och domäner.",
          "subtitle": "Skicka testmail",
          "success": {
            "text": "Din konfiguration är korrekt. Du kan nu fortsätta till nästa steg.",
            "title": "Allowlisting fungerar"
          },
          "title": "Bekräfta att allowlisting fungerar",
          "try_a_few_times": "Prova några gånger"
        }
      }
    },
    "simulation": {
      "targeting": {
        "add_services": "Lägg till tjänster",
        "ceo": "Kontaktuppgifter för vd",
        "cfo": "Kontaktuppgifter för ekonomichef",
        "content_description": "Lägg till ledningskontakter och era tjänster för mer realistiska simuleringar.",
        "content_title": "Anpassa era simuleringar",
        "cto": "Kontaktuppgifter för teknikchef",
        "description": "Konfigurera realistisk inriktning för organisationen.",
        "edit_services": "Redigera tjänster",
        "no_services": "Inga tjänster har valts",
        "services": "Tjänster",
        "services_title": "Välj tjänster",
        "title": "Konfigurera simuleringar"
      }
    },
    "steps": {
      "add_simulation": "Simuleringar",
      "invite_admins": "Administratörer",
      "kick_off": "Kickoff",
      "reporting_add_in": "Rapporteringstillägg",
      "setup_provider": "Integrationer",
      "training": "Utbildning",
      "verify_domains": "Domäner",
      "welcome": "Välkommen",
      "whitelisting": "Allowlisting"
    },
    "training": {
      "header": {
        "description": "Välj om Moxso ska tilldela utbildning automatiskt eller om ni schemalägger den själva, och anpassa sedan inställningarna för organisationen.",
        "title": "Konfigurera utbildning"
      },
      "mode": {
        "continue_disabled": "Välj ett utbildningsupplägg för att fortsätta.",
        "description": "Välj ett upplägg för att slutföra steget.",
        "title": "Välj utbildningsupplägg"
      }
    },
    "verify_domains": {
      "buttons": {
        "add": "Lägg till",
        "resend": "Skicka igen",
        "verify": "Verifiera"
      },
      "continue_disabled_tooltip_text": "Verifiera minst en domän innan du fortsätter",
      "domain_placeholder": "company.com",
      "empty": {
        "subtitle": "Lägg till dina företagsdomäner ovan för att fortsätta",
        "title": "Inga domäner tillagda ännu"
      },
      "heading": {
        "description": "Lägg till alla företagsdomäner som används i anställdas e-postadresser för att importera dina anställda. Ett verifieringsmail skickas till {email} för att bekräfta varje domän.",
        "title": "Bekräfta dina domäner"
      },
      "labels": {
        "add_domain": "Lägg till domän",
        "not_verified": "Inte verifierad",
        "verification_pending": "Verifiering väntar",
        "verified": "Verifierad",
        "verified_on": "Verifierad: {date}"
      },
      "verification_email_sent": "Verifieringsmail skickat",
      "your_domains": "Dina domäner"
    },
    "welcome": {
      "connect_provider": {
        "description": "Synkronisera anställda automatiskt",
        "title": "Anslut provider"
      },
      "description": "För att komma igång kommer vi att konfigurera e-postleverans, synkronisera anställda och starta din första phishing-simuleringskampanj.",
      "get_started": "Kom igång",
      "invite_admins": {
        "description": "Bestäm om andra också ska hjälpa till med uppsättningen och det löpande administrativa arbetet.",
        "title": "Bjud in administratörer"
      },
      "launch_phishing_simulation": {
        "description": "Skapa en baslinjesimulering och konfigurera vd-bedrägeri och programvaruinriktning.",
        "title": "Simuleringar"
      },
      "reporting_add_in": {
        "description": "Lägg till Moxso rapportknapp i medarbetarnas inkorgar.",
        "title": "Konfigurera reporting add-in"
      },
      "review_and_start": {
        "description": "Gå igenom konfigurationen och börja använda Moxso.",
        "title": "Börja använda Moxso"
      },
      "subtitle": "Välkommen till Moxso",
      "title": "Låt oss göra dig redo att lansera.",
      "training": {
        "description": "Välj utbildningsupplägg och de ramverk som är viktiga för organisationen.",
        "title": "Utbildning"
      },
      "verify_domains": {
        "description": "Verifiera de domäner du vill använda med Moxso.",
        "title": "Verifiera domäner"
      },
      "whitelist_email": {
        "description": "Säkerställ att meddelanden når inkorgar.",
        "title": "Allowlist e-post"
      }
    }
  },
  "workspace_report": {
    "assignments": "Tilldelningar",
    "avg_score": "Genomsnittligt resultat",
    "compared_against": "Jämfört med {period}",
    "department": "Avdelning",
    "employee": "Medarbetare",
    "employees_at_risk": "Medarbetare i riskzonen",
    "generated": "Genererad {date}",
    "group": "Grupp",
    "group_breakdown": "Gruppuppdelning",
    "group_breakdown_description": "Aggregerade signaler, tilldelningar och insatser per grupp",
    "group_breakdown_description_without_hri": "Aggregerade tilldelningar per grupp",
    "group_breakdown_note": "Genomsnittligt resultat viktas efter antalet medarbetare i varje grupp. Signalstapeln delar upp aktiviteten i negativ, neutral och positiv känsla.",
    "group_breakdown_note_without_hri": "Genomsnittligt resultat viktas efter antalet medarbetare i varje grupp.",
    "hri_summary": "HRI-sammanfattning för arbetsområdet",
    "human_risk_intelligence": "Human Risk Intelligence",
    "interventions": "Insatser",
    "interventions_by_type": "Insatser per typ",
    "last_six_months": "Senaste 6 månaderna",
    "loading": "Läser in arbetsområdesrapport…",
    "missed": "Missade",
    "no_employees_at_risk": "Inga medarbetare i riskzonen",
    "no_groups": "Inga gruppdata tillgängliga",
    "no_risk_indicators": "Inga riskindikatorer",
    "operational_metrics": "Operativa mätvärden",
    "performance_by_team": "Resultat per team",
    "resilience_score": "Motståndskraftspoäng",
    "risk_index": "Riskindex {value}/10 · lägre är bättre",
    "risk_indicator": "Riskindikator",
    "risk_level": "Risknivå",
    "risk_levels": {
      "high": "Hög",
      "low": "Låg",
      "moderate": "Måttlig"
    },
    "security_behaviour_overview": "Översikt över säkerhetsbeteende",
    "signals": "Signaler",
    "signals_by_sentiment": "Signaler efter känsla",
    "signals_by_severity": "Signaler efter allvarlighetsgrad",
    "threshold": "Tröskel {value}% · sorterad från låg till hög",
    "title": "Arbetsområdesrapport",
    "top_five_period": "Topp 5 denna period",
    "total": "{count} totalt",
    "total_employees": "{count} medarbetare totalt",
    "total_groups": "{count} grupper",
    "total_signals": "{count} signaler",
    "training": "Utbildningsmätvärden",
    "training_simulations_risk": "Utbildning, simuleringar och risk",
    "trend": "Trend",
    "trend_title": "Motståndskraft, klick- och rapporteringsfrekvens",
    "trending_risk_indicators": "Aktuella riskindikatorer",
    "unavailable": "Rapporten är inte tillgänglig",
    "unavailable_description": "Rapporten kunde inte läsas in. Kontrollera att rapportens URL är giltig och inte har löpt ut.",
    "workspace_summary": "Översikt över arbetsområdet"
  }
}
